import { createStore } from "vuex";
import { useCookies } from "vue3-cookies";
import "vue3-toastify/dist/index.css";
import { toast } from "vue3-toastify";
import api from "../axios";
import axios from "axios";

const API_HOST = process.env.VUE_APP_APIHOST;
const VERSION = "api/v1";
const WEBSOCKET_URL = `${process.env.VUE_APP_WSHOST}/online-users/`;
const LOGIN = `${API_HOST}/api/token-auth/`;
const ADMINS_LIST = `${API_HOST}/${VERSION}/admins`;
const ADMINS_LIST_GROUP = `${API_HOST}/${VERSION}/admins/group_action/`;
const ADMIN_BY_USERNAME = `${API_HOST}/${VERSION}/admins/get_admin_by_username/`;
const MACHINES = `${API_HOST}/${VERSION}/machines/`;
const MACHINE_ACTIONS = `${API_HOST}/${VERSION}/machine_actions/`;
const COMPETENCIES_LIST = `${API_HOST}/${VERSION}/competencies`;
const PERMISSIONS_LIST = `${API_HOST}/${VERSION}/model-permissions/admin_model_permissions/`;
const PERMISSIONS_GROUP_LIST = `${API_HOST}/${VERSION}/model-permissions-groups`;
const PRODUCTION_LOGS = `${API_HOST}/${VERSION}/production-logs/`;
const ALLOWED_IPS = `${API_HOST}/${VERSION}/allowed-ips`;
const SETTINGS = `${API_HOST}/${VERSION}/settings`;
const HOLIDAYS = `${API_HOST}/${VERSION}/holidays`;
const PACKAGES = `${API_HOST}/${VERSION}/packages/`;
const PROCESSES = `${API_HOST}/${VERSION}/processes/`;
const PLATES = `${API_HOST}/${VERSION}/plates/`;
const PRINTING_MACHINES = `${API_HOST}/${VERSION}/printing-machines/`;
const VARIABLES = `${API_HOST}/${VERSION}/variables/`;
const PRODLOGS = `${API_HOST}/${VERSION}/production-logs/`;
const NEWS = `${API_HOST}/${VERSION}/news/`;
const BANNERS = `${API_HOST}/${VERSION}/banners/`;
const PAGES_BANNERS = `${API_HOST}/${VERSION}/pages/admin_banner_pages/`;
const PAGES_PRODUCTS = `${API_HOST}/${VERSION}/pages/admin_product_pages/`;
const PAGES = `${API_HOST}/${VERSION}/pages/`;
const FAQS = `${API_HOST}/${VERSION}/faqs/`;
const TRANSLATIONS = `${API_HOST}/${VERSION}/translation/`;
const TRANSLATIONS_MODELS = `${API_HOST}/${VERSION}/translation-models/`;
const I18N_TRANSLATIONS = `${API_HOST}/${VERSION}/i18n/translations/`;
const I18N_TRANSLATIONS_META = `${API_HOST}/${VERSION}/i18n/translations/meta/`;
const FILES = `${API_HOST}/${VERSION}/files/`;
const CATEGORIES = `${API_HOST}/${VERSION}/categories/`;
const PRODUCTS = `${API_HOST}/${VERSION}/products/`;
const FORMAT = `${API_HOST}/${VERSION}/format/`;
const APPLIANCES = `${API_HOST}/${VERSION}/appliances/`;
const PARAMETERS = `${API_HOST}/${VERSION}/product-parameters/`;
const ADMIN_PARAMETERS = `${API_HOST}/${VERSION}/product-parameters/admin_product_parameters/`;
const FORMAT_GROUPS = `${API_HOST}/${VERSION}/format_groups/`;
const PGROUP_OPTIONS = `${API_HOST}/${VERSION}/product-group-options/`;
const PAGROUP_OPTIONS = `${API_HOST}/${VERSION}/product-group-options/admin_product_group_options/`;
const PRODUCT_OPTIONS = `${API_HOST}/${VERSION}/product-options/`;
const PEX_OPTIONS = `${API_HOST}/${VERSION}/product-options-exclusion/`;
const MONTAGES = `${API_HOST}/${VERSION}/montages/`;
const ORDERS = `${API_HOST}/${VERSION}/orders/`;
const ORDER_DELIVERIES = `${API_HOST}/${VERSION}/order-deliveries/`;
const ORDER_DELIVERY_PACKAGES = `${API_HOST}/${VERSION}/order-delivery-packages/`;
const ORDER_PRODUCTSBD = `${API_HOST}/${VERSION}/order-products-by-deliveries/`;
const ORDER_PRODUCT_FILES = `${API_HOST}/${VERSION}/order-product-files/`;
const ORDER_SOURCE_FILES = `${API_HOST}/${VERSION}/order-source-files/`;
const CUBES = `${API_HOST}/${VERSION}/production-cubes/`;
const CUBE_PRODUCTS = `${API_HOST}/${VERSION}/production-cube-products/`;
const ORDER_PROCESS_STAGE = `${API_HOST}/${VERSION}/order-product-process-stage-statuses/`;
const ORDER_PRODUCT_FILE_PAGES = `${API_HOST}/${VERSION}/order-product-files-pages/`;
const MONTAGE_PRODUCTS = `${API_HOST}/${VERSION}/montage-products/`;
const SITES = `${API_HOST}/${VERSION}/sites/`;
const QUANTITIES = `${API_HOST}/${VERSION}/quantities/`;
const PRODUCT_GALLERY = `${API_HOST}/${VERSION}/product-gallery/`;
const CLIENTS = `${API_HOST}/${VERSION}/clients/`;
const COUNTRIES = `${API_HOST}/${VERSION}/country-list/`;
const COURIERS = `${API_HOST}/${VERSION}/couriers/`;
const DISCOUNTS_GROUPS = `${API_HOST}/${VERSION}/discount-groups/`;
const DISCOUNTS = `${API_HOST}/${VERSION}/discounts/`;
const DISCOUNT_NOTES = `${API_HOST}/${VERSION}/discount-notes/`;
const ORDER_PRODUCTS = `${API_HOST}/${VERSION}/order-products/`;
const ORDER_PRODUCTS_ADMIN_REALIZED = `${API_HOST}/${VERSION}/order-products/admin_realized_products/`;
const CONTACT = `${API_HOST}/${VERSION}/contact/`;
const CONTACT_FOR_USER_COMPETENCES = `${CONTACT}admin_contact_for_user_competences/`;
const MESSAGES = `${API_HOST}/${VERSION}/messages/`;
const MESSAGE_FILES = `${API_HOST}/${VERSION}/message-files/`;
const INVOICES = `${API_HOST}/${VERSION}/invoices/`;
const LEGACY_INVOICES = `${API_HOST}/${VERSION}/legacy-invoices/`;
const TAGS = `${API_HOST}/${VERSION}/tags/`;
const APM = `${API_HOST}/${VERSION}/admin-payment-methods/`;
const ORDER_LOGS = `${API_HOST}/${VERSION}/order-logs/`;
const PROCESS_STAGES = `${API_HOST}/${VERSION}/process-stages/`;
const MONTAGE_STATS = `${API_HOST}/${VERSION}/montage-stats/`;
const PRODUCTION_STATS = `${API_HOST}/${VERSION}/production-stats/`;
const SYSTEM_LOGS = `${API_HOST}/${VERSION}/system_logs/`;
const CLIENT_STATS = `${API_HOST}/${VERSION}/client-stats/`;
const PRODUCTS_STATS = `${API_HOST}/${VERSION}/products-stats/`;
const PACKAGE_STATS = `${API_HOST}/${VERSION}/packages-stats/`;
const SALES_STATS = `${API_HOST}/${VERSION}/sales-stats/`;
const ALLEGRO_CONF = `${API_HOST}/${VERSION}/allegro/configurations/`;
const ALLEGRO_OFFERS = `${API_HOST}/${VERSION}/allegro/offers/`;
const ALLEGRO_ACCOUNTS = `${API_HOST}/${VERSION}/allegro/accounts/`;
const ALLEGRO_SELLERS = `${API_HOST}/${VERSION}/allegro/sellers/`;
const ALLEGRO_SENDERS = `${API_HOST}/${VERSION}/allegro/senders/`;
const ALLEGRO_COD_RECEIVERS = `${API_HOST}/${VERSION}/allegro/cod-receivers/`;
const ALLEGRO_RESPONSIBLE_PRODUCERS = `${API_HOST}/${VERSION}/allegro/responsible-producers/`;
const ALLEGRO_SAFETY_INFORMATIONS = `${API_HOST}/${VERSION}/allegro/safety-informations/`;
const ALLEGRO_THREADS = `${API_HOST}/${VERSION}/allegro/threads/`;
const POP = `${API_HOST}/${VERSION}/product-option-prices/`;
const NOTES = `${API_HOST}/${VERSION}/notes/`;
const CEL = `${API_HOST}/${VERSION}/company-external-lookup/`;
const UNITS = `${API_HOST}/${VERSION}/units/`;
const COSTS = `${API_HOST}/${VERSION}/costs/`;
const COSTS_LIST_SUMMARY = `${API_HOST}/${VERSION}/costs/list_summary/`;
const COSTS_PERIOD_UNIT_OPTS = `${API_HOST}/${VERSION}/costs/period-unit-opts/`;
const TRACKING_TAGS = `${API_HOST}/${VERSION}/tracking-tags/`;
const TRACKING_TAGS_TYPE_OPTS = `${API_HOST}/${VERSION}/tracking-tags/type-opts/`;
const TRACKING_TAGS_LOCATION_OPTS = `${API_HOST}/${VERSION}/tracking-tags/location-opts/`;
const MACHINE_COST_TYPE_OPTS = `${API_HOST}/${VERSION}/machine_actions/cost-type-opts/`;
const ORDERS_LIST_SUMMARY = `${API_HOST}/${VERSION}/orders/list_summary/`;
const MONTAGES_LIST_SUMMARY = `${API_HOST}/${VERSION}/montages/list_summary/`;
const MONTAGES_LIST_SUMMARY_CLOSED = `${API_HOST}/${VERSION}/montages/list_summary_closed/`;
const TURNOVER_DISCOUNT_SETTINGS = `${API_HOST}/${VERSION}/turnover-discount-settings/`;
const TURNOVER_DISCOUNT_SUMMARY = `${API_HOST}/${VERSION}/turnover-discount-summary/`;
const KSEF_COMPANIES = `${API_HOST}/${VERSION}/ksef/companies/`;
const KSEF_CERTIFICATES = `${API_HOST}/${VERSION}/ksef/certificates/`;
const KSEF_INVOICES_STATUS_OPTS = `${API_HOST}/${VERSION}/ksef/invoices/status_opts/`;
const KSEF_INVOICES_UNSENT_COUNT = `${API_HOST}/${VERSION}/ksef/invoices/unsent_count/`;
const { cookies } = useCookies();
const websocket = new WebSocket(WEBSOCKET_URL + cookies.get("CPsession") + "/");

export default createStore({
  state: {
    loginData: [],
    adminsData: [],
    adminsPGsData: [],
    onlineAdminsData: [],
    adminsBarcideData: [],
    adminData: [],
    adminEditData: [],
    collectionPointsData: [],
    adminGroupEditData: [],
    adminEditionData: [],
    machinesData: [],
    machineActionsData: [],
    machineData: [],
    machinesAdminPSData: [],
    pOptionsAdminPSData: [],
    createMachinesData: [],
    deleteMachinesData: [],
    updateMachinesData: [],
    competenciesData: [],
    permissionsGroupData: [],
    permissionsGroupsData: [],
    permissionsData: [],
    createAdminData: [],
    deleteAdminData: [],
    adminLogsData: [],
    deletePermissionsGroupData: [],
    createPermissionsGroupData: [],
    updatePermissionsGroupData: [],
    deleteCompetenceData: [],
    createCompetenceData: [],
    competenceData: [],
    updateCompetenceData: [],
    ipData: [],
    ipsData: [],
    updateIpData: [],
    deleteIpData: [],
    createIpData: [],
    settingData: [],
    settingsData: [],
    updateSettingData: [],
    deleteSettingData: [],
    createSettingData: [],
    holidaysData: [],
    deleteHolidaysData: [],
    createHolidaysData: [],
    packagesData: [],
    packageData: [],
    deletePackagesData: [],
    createPackagesData: [],
    updatePackagesData: [],
    processesData: [],
    processData: [],
    createProcessesData: [],
    updateProcessesData: [],
    deleteProcessesData: [],
    platesData: [],
    plateDate: [],
    updatePlatesData: [],
    createPlatesData: [],
    deletePlatesData: [],
    variablesData: [],
    variableData: [],
    updateVariablesData: [],
    createVariablesData: [],
    deleteVariablesData: [],
    costsData: [],
    costData: [],
    updateCostsData: [],
    createCostsData: [],
    deleteCostsData: [],
    costsSummaryData: [],
    periodUnitOptsData: [],
    prodlogsData: [],
    newsListData: [],
    newsData: [],
    createNewsData: [],
    updateNewsData: [],
    deleteNewsData: [],
    deleteMontagesData: [],
    bannersData: [],
    bannerData: [],
    createBannersData: [],
    updateBannersData: [],
    deleteBannersData: [],
    pageBannersData: [],
    productPagesData: [],
    statusesData: [],
    prodLogsSummaryData: [],
    pagesData: [],
    pageData: [],
    createPagesData: [],
    updatePagesData: [],
    pageTypesData: [],
    pageLayoutsData: [],
    pageMenuData: [],
    faqsData: [],
    faqData: [],
    deleteFaqData: [],
    createFaqData: [],
    updateFaqData: [],
    translationsData: [],
    translationsModelsData: [],
    updateTranslationsModelsData: [],
    updateTranslationsData: [],
    i18nTranslationsData: [],
    i18nCreateTranslationData: [],
    i18nUpdateTranslationData: [],
    i18nDeleteTranslationData: [],
    i18nTranslationsMetaData: [],
    turnoverDiscountSettingsData: [],
    turnoverDiscountSettingsSaveData: [],
    turnoverDiscountSummaryData: [],
    filesData: [],
    createFilesData: [],
    deleteFilesData: [],
    updateFilesData: [],
    importTMData: [],
    categoriesData: [],
    categoriesAdminProductData: [],
    categoryData: [],
    deleteCategoriesData: [],
    updateCategoriesData: [],
    createCategoriesData: [],
    categoryParentsData: [],
    deletePagesData: [],
    productsData: [],
    productData: [],
    createProductsData: [],
    updateProductsData: [],
    productMaterialsData: [],
    productOptionsData: [],
    productFormatsData: [],
    appliancesData: [],
    applianceData: [],
    createAppliancesData: [],
    updateAppliancesData: [],
    deleteAppliancesData: [],
    parametersData: [],
    adminParametersData: [],
    parameterData: [],
    createParametersData: [],
    updateParametersData: [],
    deleteParametersData: [],
    formatGroupsdata: [],
    formatGroupsAdmindata: [],
    formatGroupdata: [],
    createFormatGroupsdata: [],
    updateFormatGroupsdata: [],
    deleteFormatGroupsdata: [],
    formatsData: [],
    formatData: [],
    createFormatsData: [],
    updateFormatsData: [],
    deleteFormatsData: [],
    pOptionsGroupData: [],
    paOptionsGroupData: [],
    pOptionsExData: [],
    pOptionGroupData: [],
    pOptionExData: [],
    createPoptionsGroupData: [],
    createPoptionsExData: [],
    updatePoptionsGroupData: [],
    updatePoptionsExData: [],
    deletePoptionsGroupData: [],
    deletePoptionsExData: [],
    POGChoicesData: [],
    adminProductOptionsData: [],
    publishProductsData: [],
    popularProductsData: [],
    copyProductData: [],
    adminProductsOptionsData: [],
    montagesData: [],
    sendOrderData: [],
    adminSendUpsData: [],
    labelData: [],
    confirmDeliveryPackageData: [],
    updateTrackingData: [],
    realWeightData: [],
    orderProductFilesData: [],
    montageData: [],
    montageProcessData: [],
    montageProductionLogsData: [],
    cubesData: [],
    cubeData: [],
    cubeProductFilterData: [],
    cubeProductsData: [],
    cubeProductData: [],
    orderProcessStageData: [],
    orderProcessStatusData: [],
    orderProductFileData: [],
    orderProductFileData2: [],
    createOrderProductFileData: [],
    orderProductFileDetailData: [],
    createSourceFileData: [],
    orderData: [],
    clientOrdersData: [],
    clientMessagesData: [],
    clientInvoicesData: [],
    ordersData: [],
    montageProductsData: [],
    montageFilterGroupData: [],
    sitesData: [],
    montageFormatData: [],
    montageQuantityData: [],
    montagePaperOptionsData: [],
    montagePapersData: [],
    montageFormatsData: [],
    montagePlatesData: [],
    createMontageData: [],
    updateMontageProductData: [],
    clientsData: [],
    clientData: [],
    createClientData: [],
    deleteClientData: [],
    updateClientData: [],
    adminClientsData: [],
    clientsContactData: [],
    countriesData: [],
    discountGroupsData: [],
    discountGroupData: [],
    createDiscountGroupsData: [],
    updateDiscountGroupsData: [],
    deleteDiscountGroupsData: [],
    orderProductsFileData: [],
    messagesData: [],
    homeMyMessagesCountData: [],
    homeAllMessagesCountData: [],
    messageData: [],
    adminsContactData: [],
    adminsReasonsData: [],
    adminsComplaintData: [],
    updateMessageData: [],
    createMessageData: [],
    conversationData: [],
    discountsData: [],
    discountData: [],
    updateDiscountsData: [],
    createDiscountsForQData: [],
    importDiscountsForQData: [],
    invoicesData: [],
    tagsData: [],
    apmData: [],
    createOrderData: [],
    paymentsImportData: [],
    orderLogsData: [],
    processStagesData: [],
    editProcessStagesData: [],
    createProcessStagesData: [],
    updateProcessStagesData: [],
    deleteProcessStagesData: [],
    montageStatsData: [],
    productionStatsData: [],
    systemLogsData: [],
    clientStatsData: [],
    productsStatsData: [],
    packageStatsData: [],
    salesStatsData: [],
    salesGroupsData: [],
    allConfDetailsData: [],
    allOffersData: [],
    productOfferPricingData: [],
    productOfferWeightData: [],
    productOfferDescriptionData: [],
    adminQuantitiesData: [],
    adminGPData: [],
    allCategoriesData: [],
    allMatchCategoriesData: [],
    allCatPData: [],
    createAllOfferData: [],
    deleteAllOfferData: [],
    updateAllOfferData: [],
    allOfferData: [],
    allShopingRatesData: [],
    allWarrantiesData: [],
    allReturnData: [],
    allDurationsPubData: [],
    allDeliveryTimesData: [],
    allegroAccountsData: [],
    allegroAccountData: [],
    allegroAccountCreateData: [],
    allegroAccountUpdateData: [],
    allegroAccountDeleteData: [],
    allegroAccountOauthData: [],
    allegroAccountSellerData: [],
    allegroAccountSenderData: [],
    allegroAccountCodReceiverData: [],
    allegroAccountResponsibleProducerData: [],
    allegroAccountSafetyInformationData: [],
    allegroAccountOffersData: [],
    allegroAccountThreadsData: [],
    allegroOauthCreateData: [],
    allegroOauthUpdateData: [],
    allegroSellersData: [],
    allegroSellerData: [],
    allegroSellerCreateData: [],
    allegroSellerUpdateData: [],
    allegroSendersData: [],
    allegroSenderData: [],
    allegroSenderCreateData: [],
    allegroSenderUpdateData: [],
    allegroCodReceiversData: [],
    allegroCodReceiverData: [],
    allegroCodReceiverCreateData: [],
    allegroCodReceiverUpdateData: [],
    allegroResponsibleProducersData: [],
    allegroResponsibleProducerData: [],
    allegroResponsibleProducerCreateData: [],
    allegroResponsibleProducerUpdateData: [],
    allegroSafetyInformationsData: [],
    allegroSafetyInformationData: [],
    allegroSafetyInformationCreateData: [],
    allegroSafetyInformationUpdateData: [],
    clientAllegroThreadsData: [],
    allegroThreadData: [],
    allegroThreadMessageCreateData: [],
    allegroOfferModificationCommandData: [],
    allegroOfferPriceChangeCommandData: [],
    updateMontageData: [],
    duplicateMontageData: [],
    chosenOptionsData: [],
    importProductPricesData: [],
    importProductPQData: [],
    updatePriceDetailData: [],
    actionsOrderData: [],
    notesData: [],
    orderNotesData: [],
    noteDetailData: [],
    ceidgData: [],
    unitsData: [],
    createUnitData: [],
    deleteUnitData: [],
    trackingTagsData: [],
    trackingTagData: [],
    createTrackingTagData: [],
    updateTrackingTagData: [],
    deleteTrackingTagData: [],
    trackingTagsTypeOpts: [],
    trackingTagsLocationOpts: [],
    ksefCompaniesData: [],
    ksefCompanyData: [],
    createKsefCompanyData: [],
    updateKsefCompanyData: [],
    activateKsefConnectionData: [],
    ksefCompanyCertsData: [],
    createKsefCertificateData: [],
    deleteKsefCertificateData: [],
    ksefInvoiceStatusOpts: [],
    ksefUnsentInvoicesData: [],
    machineCostTypeOpts: [],
    ordersListSummary: [],
    montagesListSummary: [],
    montagesListSummaryClosed: [],
    orderProductsAdminRealizedData: [],
    adminOptionsListByGroupData: [],
    optionData: [],
    updateOptionData: [],
    deleteOptionData: [],
    createOptionData: [],
    techLineData: [],
    updateTechLineData: [],
    deliveryOptionsData: [],
    updateExternalData: [],
    duplicateOrderData: [],
    externalOrderConfirmData: [],
    updateOrderProductData: [],
  },
  mutations: {
    addTurnoverDiscountSettings(state, data) {
      state.turnoverDiscountSettingsData = data;
    },
    addTurnoverDiscountSettingsSave(state, data) {
      state.turnoverDiscountSettingsSaveData = data;
    },
    addTurnoverDiscountSummary(state, data) {
      state.turnoverDiscountSummaryData = data;
    },
    addLoginData(state, data) {
      state.loginData = data;
    },
    addAdminsData(state, data) {
      state.adminsData = data;
    },
    addAdminsPGsData(state, data) {
      state.adminsPGsData = data;
    },
    addOnlineAdminsData(state, data) {
      state.onlineAdminsData = data;
    },
    addAdminBarcodeData(state, data) {
      state.adminsBarcodeData = data;
    },
    addAdminData(state, data) {
      state.adminData = data;
    },
    addAdminEditData(state, data) {
      state.adminEditData = data;
    },
    addAdminGroupEditData(state, data) {
      state.adminGroupEditData = data;
    },
    addAdminEditionData(state, data) {
      state.adminEditionData = data;
    },
    addMachinesData(state, data) {
      state.machinesData = data;
    },
    addMachineActionsData(state, data) {
      state.machineActionsData = data;
    },
    addCompetenciesData(state, data) {
      state.competenciesData = data;
    },
    addPermissionsGroupsData(state, data) {
      state.permissionsGroupsData = data;
    },
    addPermissionsGroupData(state, data) {
      state.permissionsGroupData = data;
    },
    addPermissionsData(state, data) {
      state.permissionsData = data;
    },
    addCreateAdminData(state, data) {
      state.createAdminData = data;
    },
    addAdminDeleteData(state, data) {
      state.deleteAdminData = data;
    },
    addAdminLogsData(state, data) {
      state.adminLogsData = data;
    },
    addDeletePermissionsGroupData(state, data) {
      state.deletePermissionsGroupData = data;
    },
    addCreatePermissionsGroupData(state, data) {
      state.createPermissionsGroupData = data;
    },
    addUpdatePermissionsGroupData(state, data) {
      state.updatePermissionsGroupData = data;
    },
    addDeleteCompetenceData(state, data) {
      state.deleteCompetenceData = data;
    },
    addCreateCompetenceData(state, data) {
      state.createCompetenceData = data;
    },
    addCompetenceData(state, data) {
      state.competenceData = data;
    },
    addUpdateCompetenceData(state, data) {
      state.updateCompetenceData = data;
    },
    addIpsData(state, data) {
      state.ipsData = data;
    },
    addIpData(state, data) {
      state.ipData = data;
    },
    addCreateIpData(state, data) {
      state.createIpData = data;
    },
    addDeleteIpData(state, data) {
      state.deleteIpData = data;
    },
    addUpdateIpData(state, data) {
      state.updateIpData = data;
    },
    addSettingsData(state, data) {
      state.settingsData = data;
    },
    addSettingData(state, data) {
      state.settingData = data;
    },
    addCreateSettingData(state, data) {
      state.createSettingData = data;
    },
    addDeleteSettingData(state, data) {
      state.deleteSettingData = data;
    },
    addUpdateSettingData(state, data) {
      state.updateSettingData = data;
    },
    addHolidaysData(state, data) {
      state.holidaysData = data;
    },
    addCreateHolidaysData(state, data) {
      state.createHolidaysData = data;
    },
    addDeleteHolidaysData(state, data) {
      state.deleteHolidaysData = data;
    },
    addPackagesData(state, data) {
      state.packagesData = data;
    },
    addPackageData(state, data) {
      state.packageData = data;
    },
    addCreatePackagesData(state, data) {
      state.createPackagesData = data;
    },
    addDeletePackagesData(state, data) {
      state.deletePackagesData = data;
    },
    addUpdatePackagesData(state, data) {
      state.updatePackagesData = data;
    },
    addProcessesData(state, data) {
      state.processesData = data;
    },
    addProcessData(state, data) {
      state.processData = data;
    },
    addCreateProcessesData(state, data) {
      state.createProcessesData = data;
    },
    addDeleteProcessesData(state, data) {
      state.deleteProcessesData = data;
    },
    addUpdateProcessesData(state, data) {
      state.updateProcessesData = data;
    },
    addPlatesData(state, data) {
      state.platesData = data;
    },
    addPlateData(state, data) {
      state.plateData = data;
    },
    addUpdatePlatesData(state, data) {
      state.updatePlatesData = data;
    },
    addCreatePlatesData(state, data) {
      state.createPlatesData = data;
    },
    addDeletePlatesData(state, data) {
      state.deletePlatesData = data;
    },
    addVariablesData(state, data) {
      state.variablesData = data;
    },
    addVariableData(state, data) {
      state.variableData = data;
    },
    addCreateVariablesData(state, data) {
      state.createVariablesData = data;
    },
    addUpdateVariablesData(state, data) {
      state.updateVariablesData = data;
    },
    addDeleteVariablesData(state, data) {
      state.deleteVariablesData = data;
    },
    addCostsData(state, data) {
      state.costsData = data;
    },
    addCostData(state, data) {
      state.costData = data;
    },
    addCreateCostsData(state, data) {
      state.createCostsData = data;
    },
    addUpdateCostsData(state, data) {
      state.updateCostsData = data;
    },
    addDeleteCostsData(state, data) {
      state.deleteCostsData = data;
    },
    addCostsSummaryData(state, data) {
      state.costsSummaryData = data;
    },
    addPeriodUnitOptsData(state, data) {
      state.periodUnitOptsData = data;
    },
    addProdlogsData(state, data) {
      state.prodlogsData = data;
    },
    addNewsListData(state, data) {
      state.newsListData = data;
    },
    addNewsData(state, data) {
      state.newsData = data;
    },
    addCreateNewsData(state, data) {
      state.createNewsData = data;
    },
    addUpdateNewsData(state, data) {
      state.updateNewsData = data;
    },
    addDeleteNewsData(state, data) {
      state.deleteNewsData = data;
    },
    addDeleteMontagesData(state, data) {
      state.deleteMontagesData = data;
    },
    addBannersData(state, data) {
      state.bannersData = data;
    },
    addBannerData(state, data) {
      state.bannerData = data;
    },
    addCreateBannersData(state, data) {
      state.createBannersData = data;
    },
    addUpdateBannersData(state, data) {
      state.updateBannersData = data;
    },
    addDeleteBannersData(state, data) {
      state.deleteBannersData = data;
    },
    addPageBannersData(state, data) {
      state.pageBannersData = data;
    },
    addProductPagesData(state, data) {
      state.productPagesData = data;
    },
    addCreateMachinesData(state, data) {
      state.createMachinesData = data;
    },
    addDeleteMachinesData(state, data) {
      state.deleteMachinesData = data;
    },
    addUpdateMachinesData(state, data) {
      state.updateMachinesData = data;
    },
    addMachineData(state, data) {
      state.machineData = data;
    },
    addMachinesAdminPSData(state, data) {
      state.machinesAdminPSData = data;
    },
    addPOptionsAdminPSData(state, data) {
      state.pOptionsAdminPSData = data;
    },
    addLogStatusesData(state, data) {
      state.statusesData = data;
    },
    addProdLogsSummaryData(state, data) {
      state.prodLogsSummaryData = data;
    },
    addPagesData(state, data) {
      state.pagesData = data;
    },
    addUpdatePagesData(state, data) {
      state.updatePagesData = data;
    },
    addPageTypesData(state, data) {
      state.pageTypesData = data;
    },
    addPageMenuData(state, data) {
      state.pageMenuData = data;
    },
    addFaqsData(state, data) {
      state.faqsData = data;
    },
    addDeleteFaqData(state, data) {
      state.deleteFaqData = data;
    },
    addCreateFaqData(state, data) {
      state.createFaqData = data;
    },
    addFaqData(state, data) {
      state.faqData = data;
    },
    addUpdateFaqData(state, data) {
      state.updateFaqData = data;
    },
    addTranslationsData(state, data) {
      state.translationsData = data;
    },
    addUpdateTranslationsData(state, data) {
      state.updateTranslationsData = data;
    },
    addTranslationsModelsData(state, data) {
      state.translationsModelsData = data;
    },
    addUpdateTranslationsModelsData(state, data) {
      state.updateTranslationsModelsData = data;
    },
    addI18nTranslationsData(state, data) {
      state.i18nTranslationsData = data;
    },
    addI18nCreateTranslationData(state, data) {
      state.i18nCreateTranslationData = data;
    },
    addI18nUpdateTranslationData(state, data) {
      state.i18nUpdateTranslationData = data;
    },
    addI18nDeleteTranslationData(state, data) {
      state.i18nDeleteTranslationData = data;
    },
    addI18nTranslationsMetaData(state, data) {
      state.i18nTranslationsMetaData = data;
    },
    addFilesData(state, data) {
      state.filesData = data;
    },
    addFileData(state, data) {
      state.fileData = data;
    },
    addCreateFilesData(state, data) {
      state.createFilesData = data;
    },
    addDeleteFilesData(state, data) {
      state.deleteFilesData = data;
    },
    addUpdateFilesData(state, data) {
      state.updateFilesData = data;
    },
    addImportTMData(state, data) {
      state.importTMData = data;
    },
    addCategoriesData(state, data) {
      state.categoriesData = data;
    },
    addCategoriesAdminProductData(state, data) {
      state.categoriesAdminProductData = data;
    },
    addCategoryData(state, data) {
      state.categoryData = data;
    },
    addUpdateCategoriesData(state, data) {
      state.updateCategoriesData = data;
    },
    addCreateCategoriesData(state, data) {
      state.createCategoriesData = data;
    },
    addDeleteCategoriesData(state, data) {
      state.deleteCategoriesData = data;
    },
    addCategoryParentsData(state, data) {
      state.categoryParentsData = data;
    },
    addPageLayoutsData(state, data) {
      state.pageLayoutsData = data;
    },
    addCreatePagesData(state, data) {
      state.createPagesData = data;
    },
    addDeletePagesData(state, data) {
      state.deletePagesData = data;
    },
    addProductsData(state, data) {
      state.productsData = data;
    },
    addProductData(state, data) {
      state.productData = data;
    },
    addImportProductPricesData(state, data) {
      state.importProductPricesData = data;
    },
    addCreateProductsData(state, data) {
      state.createProductsData = data;
    },
    addUpdateProductsData(state, data) {
      state.updateProductsData = data;
    },
    addPageData(state, data) {
      state.pageData = data;
    },
    addProductMaterialsData(state, data) {
      state.productMaterialsData = data;
    },
    addProductOptionsData(state, data) {
      state.productOptionsData = data;
    },
    addProductFormatsData(state, data) {
      state.productFormatsData = data;
    },
    addAppliancesData(state, data) {
      state.appliancesData = data;
    },
    addApplianceData(state, data) {
      state.applianceData = data;
    },
    addCreateAppliancesData(state, data) {
      state.createAppliancesData = data;
    },
    addUpdateAppliancesData(state, data) {
      state.updateAppliancesData = data;
    },
    addDeleteAppliancesData(state, data) {
      state.deleteAppliancesData = data;
    },
    addParametersData(state, data) {
      state.parametersData = data;
    },
    addAdminParametersData(state, data) {
      state.adminParametersData = data;
    },
    addParameterData(state, data) {
      state.parameterData = data;
    },
    addUpdateParametersData(state, data) {
      state.updateParametersData = data;
    },
    addCreateParametersData(state, data) {
      state.createParametersData = data;
    },
    addDeleteParametersData(state, data) {
      state.deleteParametersData = data;
    },
    addFormatGroupsData(state, data) {
      state.formatGroupsData = data;
    },
    addFormatGroupData(state, data) {
      state.formatGroupData = data;
    },
    addCreateFormatGroupsData(state, data) {
      state.createFormatGroupsData = data;
    },
    addUpdateFormatGroupsData(state, data) {
      state.updateFormatGroupsData = data;
    },
    addDeleteFormatGroupsData(state, data) {
      state.deleteFormatGroupsData = data;
    },
    addFormatsData(state, data) {
      state.formatsData = data;
    },
    addFormatData(state, data) {
      state.formatData = data;
    },
    addCreateFormatsData(state, data) {
      state.createFormatsData = data;
    },
    addUpdateFormatsData(state, data) {
      state.updateFormatsData = data;
    },
    addDeleteFormatsData(state, data) {
      state.deleteFormatsData = data;
    },
    addFormatGroupsAdminData(state, data) {
      state.formatGroupsAdminData = data;
    },
    addPoptionsGroupData(state, data) {
      state.pOptionsGroupData = data;
    },
    addPAoptionsGroupData(state, data) {
      state.paOptionsGroupData = data;
    },
    addPoptionsExData(state, data) {
      state.pOptionsExData = data;
    },
    addCreatePoptionsGroupData(state, data) {
      state.createPoptionsGroupData = data;
    },
    addCreatePoptionsExData(state, data) {
      state.createPoptionsExData = data;
    },
    addPOGData(state, data) {
      state.pOptionGroupData = data;
    },
    addPOEXData(state, data) {
      state.pOptionExData = data;
    },
    addPOGChoicesData(state, data) {
      state.POGChoicesData = data;
    },
    addDeletePoptionsGroupData(state, data) {
      state.deletePoptionsGroupData = data;
    },
    addDeletePoptionsExData(state, data) {
      state.deletePoptionsExData = data;
    },
    addUpdatePoptionsGroupData(state, data) {
      state.updatePoptionsGroupData = data;
    },
    addUpdatePoptionsExData(state, data) {
      state.updatePoptionsExData = data;
    },
    addAdminProductOptionsData(state, data) {
      state.adminProductOptionsData = data;
    },
    addAdminProductSearchData(state, data) {
      state.adminProductSearchData = data;
    },
    addAdminOptionsListByGroupData(state, data) {
      state.adminOptionsListByGroupData = data;
    },
    addOptionData(state, data) {
      state.optionData = data;
    },
    addUpdateOptionData(state, data) {
      state.updateOptionData = data;
    },
    addDeleteOptionData(state, data) {
      state.deleteOptionData = data;
    },
    addCreateOptionData(state, data) {
      state.createOptionData = data;
    },
    addTechLineData(state, data) {
      state.techLineData = data;
    },
    addUpdateTechLineData(state, data) {
      state.updateTechLineData = data;
    },
    addPublishProductsData(state, data) {
      state.publishProductsData = data;
    },
    addPopularProductsData(state, data) {
      state.popularProductsData = data;
    },
    addCopyProductData(state, data) {
      state.copyProductData = data;
    },
    addAdminProductsOptionsData(state, data) {
      state.adminProductsOptionsData = data;
    },
    addMontagesData(state, data) {
      state.montagesData = data;
    },
    addSendOrderData(state, data) {
      state.sendOrderData = data;
    },
    addActionsOrderData(state, data) {
      state.actionsOrderData = data;
    },
    addAdminSendUpsData(state, data) {
      state.adminSendUpsData = data;
    },
    addLabelData(state, data) {
      state.labelData = data;
    },
    addConfirmDeliveryPackageData(state, data) {
      state.confirmDeliveryPackageData = data;
    },
    addUpdateTrackingData(state, data) {
      state.updateTrackingData = data;
    },
    addDeliveryOptionsData(state, data) {
      state.deliveryOptionsData = data;
    },
    addUpdateExternalData(state, data) {
      state.updateExternalData = data;
    },
    addDuplicateOrderData(state, data) {
      state.duplicateOrderData = data;
    },
    addExternalOrderConfirmData(state, data) {
      state.externalOrderConfirmData = data;
    },
    addUpdateOrderProductData(state, data) {
      state.updateOrderProductData = data;
    },
    addRealWeightData(state, data) {
      state.realWeightData = data;
    },
    addOrderProductFilesData(state, data) {
      state.orderProductFilesData = data;
    },
    addMontageData(state, data) {
      state.montageData = data;
    },
    addUpdateMontageData(state, data) {
      state.updateMontageData = data;
    },
    addDuplicateMontageData(state, data) {
      state.duplicateMontageData = data;
    },
    addMontageProcessData(state, data) {
      state.montageProcessData = data;
    },
    addMontageProductionLogsData(state, data) {
      state.montageProductionLogsData = data;
    },
    addCubesData(state, data) {
      state.cubesData = data;
    },
    addCubeData(state, data) {
      state.cubeData = data;
    },
    addCubeProductFilterData(state, data) {
      state.cubeProductFilterData = data;
    },
    addCubeProductsData(state, data) {
      state.cubeProductsData = data;
    },
    addCubeProductData(state, data) {
      state.cubeProductData = data;
    },
    addOrderProcessStageData(state, data) {
      state.orderProcessStageData = data;
    },
    addOrderProcessStatusData(state, data) {
      state.orderProcessStatusData = data;
    },
    addOrderProductFileData(state, data) {
      state.orderProductFileData = data;
    },
    addOrderProductFileData2(state, data) {
      state.orderProductFileData2 = data;
    },
    addCreateOrderProductFileData(state, data) {
      state.createOrderProductFileData = data;
    },
    addOrderProductFileDetailData(state, data) {
      state.orderProductFileDetailData = data;
    },
    addCreateSourceFileData(state, data) {
      state.createSourceFileData = data;
    },
    addOrderData(state, data) {
      state.orderData = data;
    },
    addOrdersData(state, data) {
      state.ordersData = data;
    },
    addClientOrdersData(state, data) {
      state.clientOrdersData = data;
    },
    addClientMessagesData(state, data) {
      state.clientMessagesData = data;
    },
    addClientInvoicesData(state, data) {
      state.clientInvoicesData = data;
    },
    addMontageProductsData(state, data) {
      state.montageProductsData = data;
    },
    addMontageFilterGroupData(state, data) {
      state.montageFilterGroupData = data;
    },
    addSitesData(state, data) {
      state.sitesData = data;
    },
    addMontageFormatData(state, data) {
      state.montageFormatData = data;
    },
    addMontageQuantityData(state, data) {
      state.montageQuantityData = data;
    },
    addMontagePaperOptionsData(state, data) {
      state.montagePaperOptionsData = data;
    },
    addMontagePapersData(state, data) {
      state.montagePapersData = data;
    },
    addMontageFormatsData(state, data) {
      state.montageFormatsData = data;
    },
    addMontagePlatesData(state, data) {
      state.montagePlatesData = data;
    },
    addCreateMontageData(state, data) {
      state.createMontageData = data;
    },
    addUpdateMontageProductData(state, data) {
      state.updateMontageProductData = data;
    },
    addImportProductPQData(state, data) {
      state.importProductPQData = data;
    },
    addClientsData(state, data) {
      state.clientsData = data;
    },
    addClientData(state, data) {
      state.clientData = data;
    },
    addAdminClientsData(state, data) {
      state.adminClientsData = data;
    },
    addCountriesData(state, data) {
      state.countriesData = data;
    },
    addCreateClientData(state, data) {
      state.createClientData = data;
    },
    addDeleteClientData(state, data) {
      state.deleteClientData = data;
    },
    addUpdateClientData(state, data) {
      state.updateClientData = data;
    },
    addDiscountGroupsData(state, data) {
      state.discountGroupsData = data;
    },
    addDiscountGroupData(state, data) {
      state.discountGroupData = data;
    },
    addCreateDiscountGroupsData(state, data) {
      state.createDiscountGroupsData = data;
    },
    addUpdateDiscountGroupsData(state, data) {
      state.updateDiscountGroupsData = data;
    },
    addDeleteDiscountGroupsData(state, data) {
      state.deleteDiscountGroupsData = data;
    },
    addOrderProductsFileData(state, data) {
      state.orderProductsFileData = data;
    },
    addMessagesData(state, data) {
      state.messagesData = data;
    },
    addHomeMyMessagesCountData(state, data) {
      state.homeMyMessagesCountData = data;
    },
    addHomeAllMessagesCountData(state, data) {
      state.homeAllMessagesCountData = data;
    },
    addMessageData(state, data) {
      state.messageData = data;
    },
    addClientsContactData(state, data) {
      state.clientsContactData = data;
    },
    addAdminContactData(state, data) {
      state.adminsContactData = data;
    },
    addAdminReasonsData(state, data) {
      state.adminsReasonsData = data;
    },
    addAdminComplaintData(state, data) {
      state.adminsComplaintData = data;
    },
    addUpdateMessageData(state, data) {
      state.updateMessageData = data;
    },
    addCreateMessageData(state, data) {
      state.createMessageData = data;
    },
    addConversationData(state, data) {
      state.conversationData = data;
    },
    addDiscountsData(state, data) {
      state.discountsData = data;
    },
    addDiscountData(state, data) {
      state.discountData = data;
    },
    addUpdateDiscountsData(state, data) {
      state.updateDiscountsData = data;
    },
    addCreateDiscountsForQData(state, data) {
      state.createDiscountsForQData = data;
    },
    addImportDiscountsForQData(state, data) {
      state.importDiscountsForQData = data;
    },
    addInvoicesData(state, data) {
      state.invoicesData = data;
    },
    addTagsData(state, data) {
      state.tagsData = data;
    },
    addApmData(state, data) {
      state.apmData = data;
    },
    addCreateOrderData(state, data) {
      state.createOrderData = data;
    },
    addPaymentsImportData(state, data) {
      state.paymentsImportData = data;
    },
    addOrderLogsData(state, data) {
      state.orderLogsData = data;
    },
    addProcessStagesData(state, data) {
      state.processStagesData = data;
    },
    addEditProcessStagesData(state, data) {
      state.editProcessStagesData = data;
    },
    addCreateProcessStagesData(state, data) {
      state.createProcessStagesData = data;
    },
    addUpdateProcessStagesData(state, data) {
      state.updateProcessStagesData = data;
    },
    addDeleteProcessStagesData(state, data) {
      state.deleteProcessStagesData = data;
    },
    addMontageStatsData(state, data) {
      state.montageStatsData = data;
    },
    addProductionStatsData(state, data) {
      state.productionStatsData = data;
    },
    addSystemLogsData(state, data) {
      state.systemLogsData = data;
    },
    addClientStatsData(state, data) {
      state.clientStatsData = data;
    },
    addProductsStatsData(state, data) {
      state.productsStatsData = data;
    },
    addPackageStatsData(state, data) {
      state.packageStatsData = data;
    },
    addSaleStatsData(state, data) {
      state.salesStatsData = data;
    },
    addSalesGroupsData(state, data) {
      state.salesGroupsData = data;
    },
    addAllOffersData(state, data) {
      state.allOffersData = data;
    },
    addAllConfDetailsData(state, data) {
      state.allConfDetailsData = data;
    },
    addProductOfferPricingData(state, data) {
      state.productOfferPricingData = data;
    },
    addProductOfferWeightData(state, data) {
      state.productOfferWeightData = data;
    },
    addProductOfferDescriptionData(state, data) {
      state.productOfferDescriptionData = data;
    },
    addAdminQuantitiesData(state, data) {
      state.adminQuantitiesData = data;
    },
    addAdminGPData(state, data) {
      state.adminGPData = data;
    },
    addAllCategoriesData(state, data) {
      state.allCategoriesData = data;
    },
    addAllMatchCategoriesData(state, data) {
      state.allMatchCategoriesData = data;
    },
    addAllCatPData(state, data) {
      state.allCatPData = data;
    },
    addCreateAllOfferData(state, data) {
      state.createAllOfferData = data;
    },
    addDeleteAllOfferData(state, data) {
      state.deleteAllOfferData = data;
    },
    addUpdateAllOfferData(state, data) {
      state.updateAllOfferData = data;
    },
    addAllOfferData(state, data) {
      state.allOfferData = data;
    },
    addAllShopingRatesData(state, data) {
      state.allShopingRatesData = data;
    },
    addAllWarrantiesData(state, data) {
      state.allWarrantiesData = data;
    },
    addAllReturnData(state, data) {
      state.allReturnData = data;
    },
    addAllDurationsPubData(state, data) {
      state.allDurationsPubData = data;
    },
    addAllDeliveryTimesData(state, data) {
      state.allDeliveryTimesData = data;
    },
    addAllegroAccountsData(state, data) {
      state.allegroAccountsData = data;
    },
    addAllegroAccountData(state, data) {
      state.allegroAccountData = data;
    },
    addAllegroAccountCreateData(state, data) {
      state.allegroAccountCreateData = data;
    },
    addAllegroAccountUpdateData(state, data) {
      state.allegroAccountUpdateData = data;
    },
    addAllegroAccountDeleteData(state, data) {
      state.allegroAccountDeleteData = data;
    },
    addAllegroAccountOauthData(state, data) {
      state.allegroAccountOauthData = data;
    },
    addAllegroAccountSellerData(state, data) {
      state.allegroAccountSellerData = data;
    },
    addAllegroAccountSenderData(state, data) {
      state.allegroAccountSenderData = data;
    },
    addAllegroAccountCodReceiverData(state, data) {
      state.allegroAccountCodReceiverData = data;
    },
    addAllegroAccountResponsibleProducerData(state, data) {
      state.allegroAccountResponsibleProducerData = data;
    },
    addAllegroAccountSafetyInformationData(state, data) {
      state.allegroAccountSafetyInformationData = data;
    },
    addAllegroAccountOffersData(state, data) {
      state.allegroAccountOffersData = data;
    },
    addAllegroAccountThreadsData(state, data) {
      state.allegroAccountThreadsData = data;
    },
    addAllegroOauthCreateData(state, data) {
      state.allegroOauthCreateData = data;
    },
    addAllegroOauthUpdateData(state, data) {
      state.allegroOauthUpdateData = data;
    },
    addAllegroSellersData(state, data) {
      state.allegroSellersData = data;
    },
    addAllegroSellerData(state, data) {
      state.allegroSellerData = data;
    },
    addAllegroSellerCreateData(state, data) {
      state.allegroSellerCreateData = data;
    },
    addAllegroSellerUpdateData(state, data) {
      state.allegroSellerUpdateData = data;
    },
    addAllegroSendersData(state, data) {
      state.allegroSendersData = data;
    },
    addAllegroSenderData(state, data) {
      state.allegroSenderData = data;
    },
    addAllegroSenderCreateData(state, data) {
      state.allegroSenderCreateData = data;
    },
    addAllegroSenderUpdateData(state, data) {
      state.allegroSenderUpdateData = data;
    },
    addAllegroCodReceiversData(state, data) {
      state.allegroCodReceiversData = data;
    },
    addAllegroCodReceiverData(state, data) {
      state.allegroCodReceiverData = data;
    },
    addAllegroCodReceiverCreateData(state, data) {
      state.allegroCodReceiverCreateData = data;
    },
    addAllegroCodReceiverUpdateData(state, data) {
      state.allegroCodReceiverUpdateData = data;
    },
    addAllegroResponsibleProducersData(state, data) {
      state.allegroResponsibleProducersData = data;
    },
    addAllegroResponsibleProducerData(state, data) {
      state.allegroResponsibleProducerData = data;
    },
    addAllegroResponsibleProducerCreateData(state, data) {
      state.allegroResponsibleProducerCreateData = data;
    },
    addAllegroResponsibleProducerUpdateData(state, data) {
      state.allegroResponsibleProducerUpdateData = data;
    },
    addAllegroSafetyInformationsData(state, data) {
      state.allegroSafetyInformationsData = data;
    },
    addAllegroSafetyInformationData(state, data) {
      state.allegroSafetyInformationData = data;
    },
    addAllegroSafetyInformationCreateData(state, data) {
      state.allegroSafetyInformationCreateData = data;
    },
    addAllegroSafetyInformationUpdateData(state, data) {
      state.allegroSafetyInformationUpdateData = data;
    },
    addClientAllegroThreadsData(state, data) {
      state.clientAllegroThreadsData = data;
    },
    addAllegroThreadData(state, data) {
      state.allegroThreadData = data;
    },
    addAllegroThreadMessageCreateData(state, data) {
      state.allegroThreadMessageCreateData = data;
    },
    addAllegroOfferModificationCommandData(state, data) {
      state.allegroOfferModificationCommandData = data;
    },
    addAllegroOfferPriceChangeCommandData(state, data) {
      state.allegroOfferPriceChangeCommandData = data;
    },
    addChosenOptionsData(state, data) {
      state.chosenOptionsData = data;
    },
    addUpdatePriceDetailData(state, data) {
      state.updatePriceDetailData = data;
    },
    addNotesData(state, data) {
      state.notesData = data;
    },
    addOrderNotesData(state, data) {
      state.orderNotesData = data;
    },
    addNoteDetailData(state, data) {
      state.noteDetailData = data;
    },
    addCeidgData(state, data) {
      state.ceidgData = data;
    },
    addUnitsData(state, data) {
      state.unitsData = data;
    },
    addCreateUnitData(state, data) {
      state.createUnitData = data;
    },
    addDeleteUnitData(state, unitId) {
      state.deleteUnitData = unitId;
    },
    addTrackingTagsData(state, data) {
      state.trackingTagsData = data;
    },
    addTrackingTagData(state, data) {
      state.trackingTagData = data;
    },
    addCreateTrackingTagData(state, data) {
      state.createTrackingTagData = data;
    },
    addUpdateTrackingTagData(state, data) {
      state.updateTrackingTagData = data;
    },
    addDeleteTrackingTagData(state, data) {
      state.deleteTrackingTagData = data;
    },
    addTrackingTagsTypeOpts(state, data) {
      state.trackingTagsTypeOpts = data;
    },
    addTrackingTagsLocationOpts(state, data) {
      state.trackingTagsLocationOpts = data;
    },
    addKsefCompaniesData(state, data) {
      state.ksefCompaniesData = data;
    },
    addKsefCompanyData(state, data) {
      state.ksefCompanyData = data;
    },
    addCreateKsefCompanyData(state, data) {
      state.createKsefCompanyData = data;
    },
    addUpdateKsefCompanyData(state, data) {
      state.updateKsefCompanyData = data;
    },
    addActivateKsefConnectionData(state, data) {
      state.activateKsefConnectionData = data;
    },
    addKsefCompanyCertsData(state, data) {
      state.ksefCompanyCertsData = data;
    },
    addCreateKsefCertificateData(state, data) {
      state.createKsefCertificateData = data;
    },
    addDeleteKsefCertificateData(state, data) {
      state.deleteKsefCertificateData = data;
    },
    addKsefInvoiceStatusOpts(state, data) {
      state.ksefInvoiceStatusOpts = data;
    },
    addKsefUnsentInvoicesData(state, data) {
      state.ksefUnsentInvoicesData = data;
    },
    addMachineCostTypeOpts(state, data) {
      state.machineCostTypeOpts = data;
    },
    addOrdersListSummary(state, data) {
      state.ordersListSummary = data;
    },
    addMontagesListSummary(state, data) {
      state.montagesListSummary = data;
    },
    addMontagesListSummaryClosed(state, data) {
      state.montagesListSummaryClosed = data;
    },
    addOrderProductsAdminRealizedData(state, data) {
      state.orderProductsAdminRealizedData = data;
    },
    addCollectionPointsData(state, data) {
      state.collectionPointsData = data;
    },
  },
  actions: {
    fetchTurnoverDiscountSettings(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(TURNOVER_DISCOUNT_SETTINGS)
        .then((response) => {
          context.commit("addTurnoverDiscountSettings", response);
        })
        .catch((error) => {
          context.commit("addTurnoverDiscountSettings", error.response);
        });
    },
    saveTurnoverDiscountSettings(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      // Prefer PATCH for partial update; backend supports PUT/PATCH
      api
        .patch(TURNOVER_DISCOUNT_SETTINGS, payload)
        .then((response) => {
          context.commit("addTurnoverDiscountSettingsSave", response);
          context.dispatch("fetchTurnoverDiscountSettings");
        })
        .catch((error) => {
          context.commit("addTurnoverDiscountSettingsSave", error.response);
        });
    },
    fetchTurnoverDiscountSummary(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(TURNOVER_DISCOUNT_SUMMARY)
        .then((response) => {
          context.commit("addTurnoverDiscountSummary", response);
        })
        .catch((error) => {
          context.commit("addTurnoverDiscountSummary", error.response);
        });
    },
    showToaster(context, payload) {
      if (websocket.readyState === 1) {
        websocket.send(JSON.stringify({ is_online: true }));
      }
      toast(payload.content, {
        theme: "colored",
        autoClose: "",
        type: payload.type,
        dangerouslyHTMLString: true,
      });
    },
    // Resolves with the response also for errors (400 with the messages of
    // the API); without a response at all (network error) it rejects.
    login(context, payload) {
      var data = new FormData();
      data.append("username", payload.username);
      data.append("password", payload.password);

      return axios
        .post(LOGIN, data)
        .then((response) => {
          context.commit("addLoginData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addLoginData", error.response);
          if (error.response) {
            return error.response;
          }
          throw error;
        });
    },
    getAdmins(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          ADMINS_LIST +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = ADMINS_LIST;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === ADMINS_LIST) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload.userPk) {
        if (pgurl === ADMINS_LIST) {
          pgurl += "?user_pk_on_first_row=" + payload.userPk;
        } else {
          pgurl += "&user_pk_on_first_row=" + payload.userPk;
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAdminsData", response);
        })
        .catch((error) => {
          context.commit("addAdminsData", error.response);
        });
    },
    getAdminsPGs(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ADMINS_LIST + "/?permission_group_pks=" + pk)
        .then((response) => {
          context.commit("addAdminsPGsData", response);
        })
        .catch((error) => {
          context.commit("addAdminsPGsData", error.response);
        });
    },
    getOnlineAdmins(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ADMINS_LIST + "?user_pks=" + payload)
        .then((response) => {
          context.commit("addOnlineAdminsData", response);
        })
        .catch((error) => {
          context.commit("addOnlineAdminsData", error.response);
        });
    },
    getAdminProductionLogs(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      if (!payload.params) {
        payload.params = "";
      }
      api
        .get(PRODUCTION_LOGS + "?user_pk=" + payload.pk + payload.params)
        .then((response) => {
          context.commit("addAdminLogsData", response);
        })
        .catch((error) => {
          context.commit("addAdminLogsData", error.response);
        });
    },
    getCollectionPoints(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(COURIERS + "collection_points/")
        .then((response) => {
          context.commit("addCollectionPointsData", response);
        })
        .catch((error) => {
          context.commit("addCollectionPointsData", error.response);
        });
    },
    getAdmin(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ADMINS_LIST + "/" + payload.pk)
        .then((response) => {
          context.commit("addAdminEditData", response);
        })
        .catch((error) => {
          context.commit("addAdminEditData", error.response);
        });
    },
    updateAdmin(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const serializerOptions = {
        indexes: null,
        dots: true,
      };

      if (typeof payload.image != "string" && payload.image) {
        api.patchForm(ADMINS_LIST + "/" + payload.pk, {
          image: payload.image,
        });
        delete payload.image;
      }

      api
        .patch(ADMINS_LIST + "/" + payload.pk + "/", payload, {
          formSerializer: serializerOptions,
        })
        .then((response) => {
          context.commit("addAdminEditionData", response);
        })
        .catch((error) => {
          context.commit("addAdminEditionData", error.response);
        });
    },
    updateAdminsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .patch(ADMINS_LIST_GROUP, payload)
        .then((response) => {
          context.commit("addAdminGroupEditData", response);
        })
        .catch((error) => {
          context.commit("addAdminGroupEditData", error.response || {});
        });
    },
    deleteAdmin(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(ADMINS_LIST + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addAdminDeleteData", response);
        })
        .catch((error) => {
          context.commit("addAdminDeleteData", error.response);
        });
    },
    getAdminBarcode(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ADMINS_LIST + "/" + payload.pk + "/barcode")
        .then((response) => {
          context.commit("addAdminBarcodeData", response);
        })
        .catch((error) => {
          context.commit("addAdminBarcodeData", error.response);
        });
    },
    getAdminByUsername(context, payload) {
      var data = new FormData();
      data.append("username", payload.username);
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      return api
        .post(ADMIN_BY_USERNAME, data)
        .then((response) => {
          context.commit("addAdminData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addAdminData", error.response);
          if (error.response) {
            return error.response;
          }
          throw error;
        });
    },
    getMachines(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          MACHINES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = MACHINES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === MACHINES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      api
        .get(pgurl)
        .then((response) => {
          context.commit("addMachinesData", response);
        })
        .catch((error) => {
          context.commit("addMachinesData", error.response);
        });
    },
    getMachineActions(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(MACHINE_ACTIONS + "admin_list/")
        .then((response) => {
          context.commit("addMachineActionsData", response);
        })
        .catch((error) => {
          context.commit("addMachineActionsData", error.response);
        });
    },
    updateMachines(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      let actions = [];
      var data = new FormData();
      data.append("name", payload.name);
      data.append("model", payload.model);
      data.append("type", payload.type);
      data.append("cost", payload.cost);
      data.append("max_print_x", payload.max_print_x);
      data.append("max_print_y", payload.max_print_y);
      data.append("min_print_x", payload.min_print_x);
      data.append("min_print_y", payload.min_print_y);
      data.append("matrix_x", payload.matrix_x);
      data.append("matrix_y", payload.matrix_y);
      data.append("matrix_cost_per_m2", payload.matrix_cost_per_m2);
      Object.keys(payload.actions).forEach((e) => {
        actions.push(payload.actions[e]);
      });
      data.append(`actions`, JSON.stringify(actions));
      if (typeof payload.image != "string" && payload.image) {
        data.append("image", payload.image);
      }
      api
        .patch(MACHINES + payload.pk + "/", data)
        .then((response) => {
          context.commit("addUpdateMachinesData", response);
        })
        .catch((error) => {
          context.commit("addUpdateMachinesData", error.response);
        });
    },
    getMachine(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(MACHINES + payload.pk)
        .then((response) => {
          context.commit("addMachineData", response);
        })
        .catch((error) => {
          context.commit("addMachineData", error.response);
        });
    },
    getMachinesAdminPS(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(MACHINES + "admin_for_process_stage")
        .then((response) => {
          context.commit("addMachinesAdminPSData", response);
        })
        .catch((error) => {
          context.commit("addMachinesAdminPSData", error.response);
        });
    },
    getPOptionsAdminPS(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      // The endpoint returns the whole list by default, the `paginated` flag
      // switches it to a paginated response so the select can load per scroll.
      // Filtering by pk/label is done by the backend through `query`.
      const params = {
        paginated: true,
        page: payload?.page || 1,
      };

      if (payload?.pageSize) {
        params.page_size = payload.pageSize;
      }

      if (payload?.query) {
        params.query = payload.query;
      }

      // Used to resolve labels of already selected options, which are not
      // necessarily part of the currently loaded page.
      if (payload?.pks?.length) {
        params.pks = payload.pks.join(",");
      }

      api
        .get(PRODUCT_OPTIONS + "admin_for_process_stage/", { params })
        .then((response) => {
          // The request shape travels with the response so that the consumer
          // knows whether to replace the list or only append to it.
          context.commit("addPOptionsAdminPSData", {
            ...response,
            page: params.page,
            pks: Boolean(params.pks),
          });
        })
        .catch((error) => {
          context.commit("addPOptionsAdminPSData", error.response);
        });
    },
    createMachines(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      let actions = [];
      var data = new FormData();
      data.append("name", payload.name);
      data.append("model", payload.model);
      data.append("type", payload.type);
      data.append("cost", payload.cost);
      data.append("image", payload.image);
      data.append("max_print_x", payload.max_print_x);
      data.append("max_print_y", payload.max_print_y);
      data.append("min_print_x", payload.min_print_x);
      data.append("min_print_y", payload.min_print_y);
      data.append("matrix_x", payload.matrix_x);
      data.append("matrix_y", payload.matrix_y);
      data.append("matrix_cost_per_m2", payload.matrix_cost_per_m2);
      Object.keys(payload.actions).forEach((e) => {
        actions.push(payload.actions[e]);
      });
      data.append(`actions`, JSON.stringify(actions));

      api
        .post(MACHINES, data)
        .then((response) => {
          context.commit("addCreateMachinesData", response);
        })
        .catch((error) => {
          context.commit("addCreateMachinesData", error.response);
        });
    },
    deleteMachines(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(MACHINES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteMachinesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteMachinesData", error.response);
        });
    },
    getCompetencies(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload && payload?.page) {
        pgurl =
          COMPETENCIES_LIST +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = COMPETENCIES_LIST;
      }
      if (payload && payload?.search) {
        for (const [key, value] of Object.entries(payload?.search)) {
          if (pgurl === ADMINS_LIST) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      api
        .get(pgurl)
        .then((response) => {
          context.commit("addCompetenciesData", response);
        })
        .catch((error) => {
          context.commit("addCompetenciesData", error.response);
        });
    },
    createCompetence(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(COMPETENCIES_LIST + "/", payload)
        .then((response) => {
          context.commit("addCreateCompetenceData", response);
        })
        .catch((error) => {
          context.commit("addCreateCompetenceData", error.response);
        });
    },
    getPermissions(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(PERMISSIONS_LIST)
        .then((response) => {
          context.commit("addPermissionsData", response);
        })
        .catch((error) => {
          context.commit("addPermissionsData", error.response);
        });
    },
    getPermissionsGroups(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          PERMISSIONS_GROUP_LIST +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PERMISSIONS_GROUP_LIST;
      }
      if (payload && payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PERMISSIONS_GROUP_LIST) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPermissionsGroupsData", response);
        })
        .catch((error) => {
          context.commit("addPermissionsGroupsData", error.response);
        });
    },
    getPermissionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.pk) {
        pgurl = PERMISSIONS_GROUP_LIST + "/" + payload.pk + "/";
      } else {
        pgurl = PERMISSIONS_GROUP_LIST;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPermissionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addPermissionsGroupData", error.response);
        });
    },
    deletePermissionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(PERMISSIONS_GROUP_LIST + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addDeletePermissionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addDeletePermissionsGroupData", error.response);
        });
    },
    deleteCompetence(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(COMPETENCIES_LIST + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteCompetenceData", response);
        })
        .catch((error) => {
          context.commit("addDeleteCompetenceData", error.response);
        });
    },
    getCompetence(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(COMPETENCIES_LIST + "/" + payload.pk)
        .then((response) => {
          context.commit("addCompetenceData", response);
        })
        .catch((error) => {
          context.commit("addCompetenceData", error.response);
        });
    },
    updateCompetence(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(COMPETENCIES_LIST + "/" + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateCompetenceData", response);
        })
        .catch((error) => {
          context.commit("addUpdateCompetenceData", error.response);
        });
    },
    createAdmin(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      let tempImg;
      if (payload.value.image) {
        tempImg = payload.value.image;
        delete payload.value.image;
      }

      const serializerOptions = {
        indexes: null,
        dots: true,
      };

      api
        .post(ADMINS_LIST + "/", payload.value, {
          formSerializer: serializerOptions,
        })
        .then((response) => {
          if (response?.data?.pk) {
            api.patchForm(ADMINS_LIST + "/" + response?.data?.pk, {
              image: tempImg,
            });
          }
          context.commit("addCreateAdminData", response);
        })
        .catch((error) => {
          context.commit("addCreateAdminData", error.response);
        });
    },
    createPermissionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(PERMISSIONS_GROUP_LIST + "/", payload)
        .then((response) => {
          context.commit("addCreatePermissionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addCreatePermissionsGroupData", error.response);
        });
    },
    updatePermissionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(PERMISSIONS_GROUP_LIST + "/" + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdatePermissionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addUpdatePermissionsGroupData", error.response);
        });
    },
    getIps(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          ALLOWED_IPS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = ALLOWED_IPS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === ALLOWED_IPS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addIpsData", response);
        })
        .catch((error) => {
          context.commit("addIpsData", error.response);
        });
    },
    getIp(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ALLOWED_IPS + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addIpData", response);
        })
        .catch((error) => {
          context.commit("addIpData", error.response);
        });
    },
    deleteIp(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(ALLOWED_IPS + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteIpData", response);
        })
        .catch((error) => {
          context.commit("addDeleteIpData", error.response);
        });
    },
    updateIp(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(ALLOWED_IPS + "/" + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateIpData", response);
        })
        .catch((error) => {
          context.commit("addUpdateIpData", error.response);
        });
    },
    createIp(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(ALLOWED_IPS + "/", payload)
        .then((response) => {
          context.commit("addCreateIpData", response);
        })
        .catch((error) => {
          context.commit("addCreateIpData", error.response);
        });
    },
    getSettings(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          SETTINGS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = SETTINGS;
      }
      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === SETTINGS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addSettingsData", response);
        })
        .catch((error) => {
          context.commit("addSettingsData", error.response);
        });
    },
    getSetting(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(SETTINGS + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addSettingData", response);
        })
        .catch((error) => {
          context.commit("addSettingData", error.response);
        });
    },
    deleteSetting(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(SETTINGS + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteSettingData", response);
        })
        .catch((error) => {
          context.commit("addDeleteSettingData", error.response);
        });
    },
    updateSetting(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(SETTINGS + "/" + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateSettingData", response);
        })
        .catch((error) => {
          context.commit("addUpdateSettingData", error.response);
        });
    },
    createSetting(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(SETTINGS + "/", payload)
        .then((response) => {
          context.commit("addCreateSettingData", response);
        })
        .catch((error) => {
          context.commit("addCreateSettingData", error.response);
        });
    },
    getHolidays(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(HOLIDAYS)
        .then((response) => {
          context.commit("addHolidaysData", response);
        })
        .catch((error) => {
          context.commit("addHolidaysData", error.response);
        });
    },
    createHolidays(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(HOLIDAYS + "/", payload)
        .then((response) => {
          context.commit("addCreateHolidaysData", response);
        })
        .catch((error) => {
          context.commit("addCreateHolidaysData", error.response);
        });
    },
    deleteHolidays(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(HOLIDAYS + "/" + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteHolidaysData", response);
        })
        .catch((error) => {
          context.commit("addDeleteHolidaysData", error.response);
        });
    },
    getPackages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          PACKAGES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PACKAGES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PACKAGES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPackagesData", response);
        })
        .catch((error) => {
          context.commit("addPackagesData", error.response);
        });
    },
    getPackage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(PACKAGES + payload.pk + "/")
        .then((response) => {
          context.commit("addPackageData", response);
        })
        .catch((error) => {
          context.commit("addPackageData", error.response);
        });
    },
    createPackages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(PACKAGES, payload)
        .then((response) => {
          context.commit("addCreatePackagesData", response);
        })
        .catch((error) => {
          context.commit("addCreatePackagesData", error.response);
        });
    },
    updatePackages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(PACKAGES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdatePackagesData", response);
        })
        .catch((error) => {
          context.commit("addUpdatePackagesData", error.response);
        });
    },
    deletePackages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(PACKAGES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeletePackagesData", response);
        })
        .catch((error) => {
          context.commit("addDeletePackagesData", error.response);
        });
    },
    getProcesses(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          PROCESSES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PROCESSES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PROCESSES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      api
        .get(pgurl)
        .then((response) => {
          context.commit("addProcessesData", response);
        })
        .catch((error) => {
          context.commit("addProcessesData", error.response);
        });
    },
    getProcess(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PROCESSES + payload.pk)
        .then((response) => {
          context.commit("addProcessData", response);
        })
        .catch((error) => {
          context.commit("addProcessData", error.response);
        });
    },
    updateProcesses(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(PROCESSES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateProcessesData", response);
        })
        .catch((error) => {
          context.commit("addUpdateProcessesData", error.response);
        });
    },
    createProcesses(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(PROCESSES, payload)
        .then((response) => {
          context.commit("addCreateProcessesData", response);
        })
        .catch((error) => {
          context.commit("addCreateProcessesData", error.response);
        });
    },
    deleteProcesses(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(PROCESSES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteProcessesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteProcessesData", error.response);
        });
    },
    getPlates(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          PLATES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PLATES;
      }
      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PLATES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPlatesData", response);
        })
        .catch((error) => {
          context.commit("addPlatesData", error.response);
        });
    },
    getPlate(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(PLATES + payload.pk)
        .then((response) => {
          context.commit("addPlateData", response);
        })
        .catch((error) => {
          context.commit("addPlateData", error.response);
        });
    },
    updatePlates(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(PLATES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdatePlatesData", response);
        })
        .catch((error) => {
          context.commit("addUpdatePlatesData", error.response);
        });
    },
    createPlates(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(PLATES, payload)
        .then((response) => {
          context.commit("addCreatePlatesData", response);
        })
        .catch((error) => {
          context.commit("addCreatePlatesData", error.response);
        });
    },
    createPlatesMach(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(PRINTING_MACHINES, payload)
        .then((response) => {
          context.commit("addCreatePlatesData", response);
        })
        .catch((error) => {
          context.commit("addCreatePlatesData", error.response);
        });
    },
    deletePlates(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(PLATES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeletePlatesData", response);
        })
        .catch((error) => {
          context.commit("addDeletePlatesData", error.response);
        });
    },
    getVariables(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          VARIABLES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = VARIABLES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === VARIABLES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      api
        .get(pgurl)
        .then((response) => {
          context.commit("addVariablesData", response);
        })
        .catch((error) => {
          context.commit("addVariablesData", error.response);
        });
    },
    getVariable(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(VARIABLES + payload.pk)
        .then((response) => {
          context.commit("addVariableData", response);
        })
        .catch((error) => {
          context.commit("addVariableData", error.response);
        });
    },
    createVariables(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(VARIABLES, payload)
        .then((response) => {
          context.commit("addCreateVariablesData", response);
        })
        .catch((error) => {
          context.commit("addCreateVariablesData", error.response);
        });
    },
    updateVariables(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(VARIABLES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateVariablesData", response);
        })
        .catch((error) => {
          context.commit("addUpdateVariablesData", error.response);
        });
    },
    deleteVariables(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(VARIABLES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteVariablesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteVariablesData", error.response);
        });
    },
    fetchCosts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          COSTS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.rowsPerPage +
          "&ordering=" +
          (payload.ordering || "pk");
      } else {
        pgurl = COSTS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === COSTS) {
            pgurl += "?" + key + "=" + value;
          } else {
            pgurl += "&" + key + "=" + value;
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addCostsData", response);
        })
        .catch((error) => {
          context.commit("addCostsData", error.response);
        });
    },
    fetchCost(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(COSTS + payload)
        .then((response) => {
          context.commit("addCostData", response);
        })
        .catch((error) => {
          context.commit("addCostData", error.response);
        });
    },
    createCost(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(COSTS, payload)
        .then((response) => {
          context.commit("addCreateCostsData", response);
        })
        .catch((error) => {
          context.commit("addCreateCostsData", error.response);
        });
    },
    updateCost(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .put(COSTS + payload.pk + "/", payload.data)
        .then((response) => {
          context.commit("addUpdateCostsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateCostsData", error.response);
        });
    },
    deleteCost(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(COSTS + payload + "/")
        .then((response) => {
          context.commit("addDeleteCostsData", response);
        })
        .catch((error) => {
          context.commit("addDeleteCostsData", error.response);
        });
    },
    fetchCostsSummary(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(COSTS_LIST_SUMMARY)
        .then((response) => {
          context.commit("addCostsSummaryData", response);
        })
        .catch((error) => {
          context.commit("addCostsSummaryData", error.response);
        });
    },
    fetchUnits(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(UNITS)
        .then((response) => {
          context.commit("addUnitsData", response);
        })
        .catch((error) => {
          context.commit("addUnitsData", error.response);
        });
    },
    fetchPeriodUnitOpts(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(COSTS_PERIOD_UNIT_OPTS)
        .then((response) => {
          context.commit("addPeriodUnitOptsData", response);
        })
        .catch((error) => {
          context.commit("addPeriodUnitOptsData", error.response);
        });
    },
    getMontages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.page) {
        pgurl =
          MONTAGES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = MONTAGES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === MONTAGES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload.isArchive) {
        if (pgurl === MONTAGES) {
          pgurl += "?is_archive=" + payload.isArchive;
        } else {
          pgurl += "&is_archive=" + payload.isArchive;
        }
      }

      if (payload?.date) {
        if (payload.date[0]) {
          const startDate = new Date(payload.date[0]);
          day = startDate.getDate();
          month = startDate.getMonth() + 1;
          year = startDate.getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          const endDate = new Date(payload.date[1]);
          dayEnd = endDate.getDate();
          monthEnd = endDate.getMonth() + 1;
          yearEnd = endDate.getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      if (payload.filters) {
        Object.keys(payload.filters).forEach((e) => {
          if (payload.filters[e].length) {
            Object.keys(payload.filters[e]).forEach((e1) => {
              pgurl += "&" + e + "=" + payload.filters[e][e1];
            });
          }
        });
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addMontagesData", response);
        })
        .catch((error) => {
          context.commit("addMontagesData", error.response);
        });
    },
    getMontage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(MONTAGES + payload.pk)
        .then((response) => {
          context.commit("addMontageData", response);
        })
        .catch((error) => {
          context.commit("addMontageData", error.response);
        });
    },
    updateMontage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      // The montage products may come in either as full rows or as bare pks.
      if (Array.isArray(payload.montage_products)) {
        payload.montage_products = payload.montage_products
          .map((item) => (item && typeof item === "object" ? item.pk : item))
          .filter((pk) => pk !== null && pk !== undefined);
      }
      api
        .patch(MONTAGES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateMontageData", response);
        })
        .catch((error) => {
          context.commit("addUpdateMontageData", error.response);
        });
    },
    duplicateMontage(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(MONTAGES + pk + "/admin_duplicate/")
        .then((response) => {
          context.commit("addDuplicateMontageData", response);
        })
        .catch((error) => {
          context.commit("addDuplicateMontageData", error.response);
        });
    },
    getProdLogsSummary(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(PRODLOGS + "summary")
        .then((response) => {
          context.commit("addProdLogsSummaryData", response);
        })
        .catch((error) => {
          context.commit("addProdLogsSummaryData", error.response);
        });
    },
    getProdlogs(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }
      if (payload?.page) {
        pgurl =
          PRODLOGS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;

        if (payload.status) {
          pgurl += "&production_process=" + payload.status;
        }

        if (payload.date) {
          pgurl += "&max_date=" + dateMax;
          pgurl += "&min_date=" + dateMin;
        }
      } else {
        pgurl = PRODLOGS;
        if (payload.status) {
          pgurl += "?production_process=" + payload.status;
          if (payload.date) {
            pgurl += "&max_date=" + dateMax;
            pgurl += "&min_date=" + dateMin;
          }
        }
      }
      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PRODLOGS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      api
        .get(pgurl)
        .then((response) => {
          context.commit("addProdlogsData", response);
        })
        .catch((error) => {
          context.commit("addProdlogsData", error.response);
        });
    },
    getNewsList(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          NEWS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = NEWS;
      }
      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === NEWS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addNewsListData", response);
        })
        .catch((error) => {
          context.commit("addNewsListData", error.response);
        });
    },
    getNews(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(NEWS + payload.pk)
        .then((response) => {
          context.commit("addNewsData", response);
        })
        .catch((error) => {
          context.commit("addNewsData", error.response);
        });
    },
    createNews(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var data = new FormData();
      data.append("title_pl", payload.title_pl);
      data.append("content_pl", payload.content_pl);
      data.append("title_en", payload.title_en);
      data.append("content_en", payload.content_en);
      data.append("title_de", payload.title_de);
      data.append("content_de", payload.content_de);
      data.append("title_cpde", payload.title_cpde);
      data.append("content_cpde", payload.content_cpde);
      data.append("title_cpen", payload.title_cpen);
      data.append("content_cpen", payload.content_cpen);
      data.append("publication_date", payload.publication_date);
      api
        .post(NEWS, data)
        .then((response) => {
          context.commit("addCreateNewsData", response);
        })
        .catch((error) => {
          context.commit("addCreateNewsData", error.response);
        });
    },
    updateNews(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var data = new FormData();
      data.append("title_pl", payload.title_pl);
      data.append("content_pl", payload.content_pl);
      data.append("title_en", payload.title_en);
      data.append("content_en", payload.content_en);
      data.append("title_de", payload.title_de);
      data.append("content_de", payload.content_de);
      data.append("title_cpde", payload.title_cpde);
      data.append("content_cpde", payload.content_cpde);
      data.append("title_cpen", payload.title_cpen);
      data.append("content_cpen", payload.content_cpen);
      data.append("publication_date", payload.publication_date);
      api
        .patch(NEWS + payload.pk + "/", data)
        .then((response) => {
          context.commit("addUpdateNewsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateNewsData", error.response);
        });
    },
    deleteNews(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(NEWS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteNewsData", response);
        })
        .catch((error) => {
          context.commit("addDeleteNewsData", error.response);
        });
    },
    deleteMontage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(MONTAGES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteMontagesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteMontagesData", error.response);
        });
    },
    getBanners(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          BANNERS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = BANNERS;
      }
      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === BANNERS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }
      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addBannersData", response);
        })
        .catch((error) => {
          context.commit("addBannersData", error.response);
        });
    },
    getBanner(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(BANNERS + payload.pk)
        .then((response) => {
          context.commit("addBannerData", response);
        })
        .catch((error) => {
          context.commit("addBannerData", error.response);
        });
    },
    // Lightweight, unpaginated list of pages (pk and title) for the product
    // forms - the same endpoint pageDataSrvc.productPages uses in the old panel.
    // Dictionaries of the product create/update forms - the unpaginated option
    // endpoints the old panel uses (packageOptions, productParents,
    // productAppliances, formatsAsOptions).
    fetchProductPackageOptions() {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      return api.get(PACKAGES + "admin_package_options/");
    },
    fetchProductCategoryParents() {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      return api.get(CATEGORIES + "admin_product_parents/");
    },
    fetchProductAppliances() {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      return api.get(APPLIANCES + "admin_product_appliances/");
    },
    fetchProductFormatOptions() {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      return api.get(FORMAT + "admin_formats_as_options/");
    },
    // Product material files searched by name, like onFilesSearch in the old
    // panel; with product_pk the first page also holds the product's own files.
    searchProductMaterials(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.productPk) params.append("product_pk", payload.productPk);
      if (payload.name) params.append("name", payload.name);
      // Without a page number the backend puts the product's own files first.
      if (payload.page > 1) params.append("page", payload.page);
      const query = params.toString();
      return api.get(
        FILES + "admin_product_materials_files/" + (query ? "?" + query : "")
      );
    },
    // Products picker searched by name or id, like productDataSrvc.optionsList
    // with the "query" param in the old panel.
    searchProductsOptionsList(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.query) params.append("query", payload.query);
      if (payload.page > 1) params.append("page", payload.page);
      const query = params.toString();
      return api.get(
        PRODUCTS + "admin_options_list/" + (query ? "?" + query : "")
      );
    },
    getProductPages(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(PAGES_PRODUCTS)
        .then((response) => {
          context.commit("addProductPagesData", response);
        })
        .catch((error) => {
          context.commit("addProductPagesData", error.response);
        });
    },
    getPageBanners(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(PAGES_BANNERS)
        .then((response) => {
          context.commit("addPageBannersData", response);
        })
        .catch((error) => {
          context.commit("addPageBannersData", error.response);
        });
    },
    deleteBanners(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(BANNERS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteBannersData", response);
        })
        .catch((error) => {
          context.commit("addDeleteBannersData", error.response);
        });
    },
    getLogStatuses(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(PRODUCTION_LOGS + "log_statuses/")
        .then((response) => {
          context.commit("addLogStatusesData", response);
        })
        .catch((error) => {
          context.commit("addLogStatusesData", error.response);
        });
    },
    createBanners(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var data = new FormData();
      let pages = [],
        countries = [];
      data.append("name", payload.name);
      data.append("url", payload.url);
      data.append("is_published", payload.is_published);
      if (payload.datetime_from) {
        data.append("datetime_from", payload.datetime_from);
      }
      if (payload.datetime_to) {
        data.append("datetime_to", payload.datetime_to);
      }

      data.append("display_time", payload.display_time);
      data.append("image", payload.image);
      Object.keys(payload.available_in_countries).forEach((e) => {
        countries.push(payload.available_in_countries[e]);
      });
      data.append(`available_in_countries`, JSON.stringify(countries));
      Object.keys(payload.pages).forEach((e) => {
        pages.push(payload.pages[e]);
      });
      data.append(`pages`, JSON.stringify(pages));
      data.append("description_pl", payload.description_pl);
      data.append("description_de", payload.description_de);
      data.append("description_en", payload.description_en);
      data.append("description_cpde", payload.description_cpde);
      data.append("description_cpen", payload.description_cpen);
      api
        .post(BANNERS, data)
        .then((response) => {
          context.commit("addCreateBannersData", response);
        })
        .catch((error) => {
          context.commit("addCreateBannersData", error.response);
        });
    },
    updateBanners(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var data = new FormData();
      let pages = [],
        countries = [];
      data.append("pk", payload.pk);
      data.append("name", payload.name);
      data.append("url", payload.url);
      data.append("is_published", payload.is_published);
      data.append("display_time", payload.display_time);
      Object.keys(payload.available_in_countries).forEach((e) => {
        countries.push(payload.available_in_countries[e]);
      });
      data.append(`available_in_countries`, JSON.stringify(countries));

      Object.keys(payload.pages).forEach((e) => {
        pages.push(payload.pages[e]);
      });
      data.append(`pages`, JSON.stringify(pages));

      if (payload.datetime_from) {
        data.append("datetime_from", payload.datetime_from);
      }
      if (payload.datetime_to) {
        data.append("datetime_to", payload.datetime_to);
      }
      if (payload.image) {
        data.append("image", payload.image);
      }
      data.append("description_pl", payload.description_pl);
      data.append("description_de", payload.description_de);
      data.append("description_en", payload.description_en);
      data.append("description_cpde", payload.description_cpde);
      data.append("description_cpen", payload.description_cpen);
      api
        .patch(BANNERS + payload.pk + "/", data)
        .then((response) => {
          context.commit("addUpdateBannersData", response);
        })
        .catch((error) => {
          context.commit("addUpdateBannersData", error.response);
        });
    },
    createPages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(PAGES, payload)
        .then((response) => {
          context.commit("addCreatePagesData", response);
        })
        .catch((error) => {
          context.commit("addCreatePagesData", error.response);
        });
    },
    deletePages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(PAGES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeletePagesData", response);
        })
        .catch((error) => {
          context.commit("addDeletePagesData", error.response);
        });
    },
    async getPages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          PAGES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PAGES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PAGES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.all) {
        try {
          let response = await api.get(pgurl);
          if (!Array.isArray(response?.data?.results)) {
            context.commit("addPagesData", response);
            return;
          }

          let allResults = [...response.data.results];
          let nextUrl = response.data.next;

          while (nextUrl) {
            const nextResponse = await api.get(nextUrl);
            if (!Array.isArray(nextResponse?.data?.results)) {
              break;
            }
            allResults = allResults.concat(nextResponse.data.results);
            nextUrl = nextResponse.data.next;
          }

          response = {
            ...response,
            data: {
              ...response.data,
              count: allResults.length,
              next: null,
              previous: null,
              results: allResults,
            },
          };
          context.commit("addPagesData", response);
        } catch (error) {
          context.commit("addPagesData", error.response);
        }
        return;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPagesData", response);
        })
        .catch((error) => {
          context.commit("addPagesData", error.response);
        });
    },
    getPage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PAGES + payload.pk)
        .then((response) => {
          context.commit("addPageData", response);
        })
        .catch((error) => {
          context.commit("addPageData", error.response);
        });
    },
    updatePages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(PAGES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdatePagesData", response);
        })
        .catch((error) => {
          context.commit("addUpdatePagesData", error.response);
        });
    },
    reorderPages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const data = new FormData();
      data.append("subpage_position", payload.subpage_position);
      return api.patch(PAGES + payload.pk + "/", data);
    },
    getPageTypes(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PAGES + "admin_type_options/")
        .then((response) => {
          context.commit("addPageTypesData", response);
        })
        .catch((error) => {
          context.commit("addPageTypesData", error.response);
        });
    },
    getPageLayouts(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PAGES + "admin_layout_options/")
        .then((response) => {
          context.commit("addPageLayoutsData", response);
        })
        .catch((error) => {
          context.commit("addPageLayoutsData", error.response);
        });
    },
    getPageMenu(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PAGES + "admin_menu_options/")
        .then((response) => {
          context.commit("addPageMenuData", response);
        })
        .catch((error) => {
          context.commit("addPageMenuData", error.response);
        });
    },
    getFaqs(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          FAQS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = FAQS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === FAQS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addFaqsData", response);
        })
        .catch((error) => {
          context.commit("addFaqsData", error.response);
        });
    },
    getFaq(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(FAQS + payload.pk)
        .then((response) => {
          context.commit("addFaqData", response);
        })
        .catch((error) => {
          context.commit("addFaqData", error.response);
        });
    },
    deleteFaq(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(FAQS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteFaqData", response);
        })
        .catch((error) => {
          context.commit("addDeleteFaqData", error.response);
        });
    },
    createFaq(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(FAQS, payload)
        .then((response) => {
          context.commit("addCreateFaqData", response);
        })
        .catch((error) => {
          context.commit("addCreateFaqData", error.response);
        });
    },
    updateFaq(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(FAQS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateFaqData", response);
        })
        .catch((error) => {
          context.commit("addUpdateFaqData", error.response);
        });
    },
    updateTranslations(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(TRANSLATIONS, payload)
        .then((response) => {
          context.commit("addUpdateTranslationsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateTranslationsData", error.response);
        });
    },
    // Nowe tłumaczenia (i18n) – lista i CRUD
    getI18nTranslations(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      let pgurl;
      if (payload?.page) {
        pgurl =
          I18N_TRANSLATIONS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          (payload.ordering || "");
      } else {
        pgurl = I18N_TRANSLATIONS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (!value) continue;
          if (pgurl === I18N_TRANSLATIONS) {
            pgurl += "?" + key + "=" + value;
          } else {
            pgurl += "&" + key + "=" + value;
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addI18nTranslationsData", response);
        })
        .catch((error) => {
          context.commit("addI18nTranslationsData", error.response);
        });
    },
    getI18nTranslationsMeta(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(I18N_TRANSLATIONS_META)
        .then((response) => {
          context.commit("addI18nTranslationsMetaData", response);
        })
        .catch((error) => {
          context.commit("addI18nTranslationsMetaData", error.response);
        });
    },
    createI18nTranslation(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(I18N_TRANSLATIONS, payload)
        .then((response) => {
          context.commit("addI18nCreateTranslationData", response);
        })
        .catch((error) => {
          context.commit("addI18nCreateTranslationData", error.response);
        });
    },
    updateI18nTranslation(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(I18N_TRANSLATIONS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addI18nUpdateTranslationData", response);
        })
        .catch((error) => {
          context.commit("addI18nUpdateTranslationData", error.response);
        });
    },
    deleteI18nTranslation(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(I18N_TRANSLATIONS + payload.pk + "/")
        .then((response) => {
          context.commit("addI18nDeleteTranslationData", response);
        })
        .catch((error) => {
          context.commit("addI18nDeleteTranslationData", error.response);
        });
    },
    getTranslations(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          TRANSLATIONS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = TRANSLATIONS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === TRANSLATIONS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.radio) {
        for (const [key, value] of Object.entries(payload.radio)) {
          if (pgurl === TRANSLATIONS) {
            if (value) {
              pgurl += "?onlyEmptyColumns=" + key;
            }
          } else {
            if (value) {
              pgurl += "&onlyEmptyColumns=" + key;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addTranslationsData", response);
        })
        .catch((error) => {
          context.commit("addTranslationsData", error.response);
        });
    },
    getFiles(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          FILES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = FILES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === FILES) {
            if (value) {
              pgurl += "?" + key + "=" + encodeURIComponent(value);
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + encodeURIComponent(value);
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addFilesData", response);
        })
        .catch((error) => {
          context.commit("addFilesData", error.response);
        });
    },
    createFile(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      api
        .post(FILES, payload)
        .then((response) => {
          context.commit("addCreateFilesData", response);
        })
        .catch((error) => {
          context.commit("addCreateFilesData", error.response);
        });
    },
    deleteFile(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(FILES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteFilesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteFilesData", error.response);
        });
    },
    updateFiles(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      api
        .patch(FILES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateFilesData", response);
        })
        .catch((error) => {
          context.commit("addUpdateFilesData", error.response);
        });
    },
    getFile(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(FILES + payload.pk)
        .then((response) => {
          context.commit("addFileData", response);
        })
        .catch((error) => {
          context.commit("addFileData", error.response);
        });
    },
    getTranslationsModels(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          TRANSLATIONS_MODELS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = TRANSLATIONS_MODELS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === TRANSLATIONS_MODELS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.radio) {
        for (const [key, value] of Object.entries(payload.radio)) {
          if (pgurl === TRANSLATIONS) {
            if (value) {
              pgurl += "?onlyEmptyColumns=" + key;
            }
          } else {
            if (value) {
              pgurl += "&onlyEmptyColumns=" + key;
            }
          }
        }
      }

      if (payload?.site_pk) {
        if (pgurl === TRANSLATIONS_MODELS) {
          pgurl += "?site_pk=" + payload.site_pk;
        } else {
          pgurl += "&site_pk=" + payload.site_pk;
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addTranslationsModelsData", response);
        })
        .catch((error) => {
          context.commit("addTranslationsModelsData", error.response);
        });
    },
    updateTranslationsModels(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(TRANSLATIONS_MODELS, payload)
        .then((response) => {
          context.commit("addUpdateTranslationsModelsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateTranslationsModelsData", error.response);
        });
    },
    exportTranslationsModels() {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(TRANSLATIONS_MODELS + "export/")
        .then((response) => {
          let blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch();
    },
    importTranslationsModels(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      api
        .post(TRANSLATIONS_MODELS + "import_from_file/", payload)
        .then((response) => {
          context.commit("addImportTMData", response);
        })
        .catch((error) => {
          context.commit("addImportTMData", error.response);
        });
    },
    getCategories(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let cats = CATEGORIES;

      if (payload?.adminParents) {
        cats += "admin_product_parents/";
      }

      var pgurl;
      if (payload?.page) {
        pgurl =
          cats +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = cats;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === cats) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.radio === true) {
        pgurl += "&is_published=True";
      } else if (payload?.radio === false) {
        pgurl += "&is_published=False";
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addCategoriesData", response);
        })
        .catch((error) => {
          context.commit("addCategoriesData", error.response);
        });
    },
    getCategoriesAdminProductFilter(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(CATEGORIES + "admin_product_filter")
        .then((response) => {
          context.commit("addCategoriesAdminProductData", response);
        })
        .catch((error) => {
          context.commit("addCategoriesAdminProductData", error.response);
        });
    },
    getCategoryParents(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CATEGORIES + "admin_category_parents/")
        .then((response) => {
          context.commit("addCategoryParentsData", response);
        })
        .catch((error) => {
          context.commit("addCategoryParentsData", error.response);
        });
    },
    getCategory(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CATEGORIES + payload.pk)
        .then((response) => {
          context.commit("addCategoryData", response);
        })
        .catch((error) => {
          context.commit("addCategoryData", error.response);
        });
    },
    // The Allegro dictionaries below are read through the account the offer
    // belongs to - they need its OAuth configuration.
    getAllShopingRates(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const accountPk = payload?.accountPk || payload;

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/shoping_rates/")
        .then((response) => {
          context.commit("addAllShopingRatesData", response);
        })
        .catch((error) => {
          context.commit("addAllShopingRatesData", error.response);
        });
    },
    getAllWarranties(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const accountPk = payload?.accountPk || payload;

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/implied_warranties/")
        .then((response) => {
          context.commit("addAllWarrantiesData", response);
        })
        .catch((error) => {
          context.commit("addAllWarrantiesData", error.response);
        });
    },
    getAllDeliveryTimes(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const accountPk = payload?.accountPk || payload;

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/delivery_handling_times/")
        .then((response) => {
          context.commit("addAllDeliveryTimesData", response);
        })
        .catch((error) => {
          context.commit("addAllDeliveryTimesData", error.response);
        });
    },
    getAllDurationsPub(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const accountPk = payload?.accountPk || payload;

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/publication_durations/")
        .then((response) => {
          context.commit("addAllDurationsPubData", response);
        })
        .catch((error) => {
          context.commit("addAllDurationsPubData", error.response);
        });
    },
    getAllReturn(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const accountPk = payload?.accountPk || payload;

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/return_policies/")
        .then((response) => {
          context.commit("addAllReturnData", response);
        })
        .catch((error) => {
          context.commit("addAllReturnData", error.response);
        });
    },
    getAllCategoryParameters(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(
          ALLEGRO_ACCOUNTS +
            payload.accountPk +
            "/category_parameters/?category_id=" +
            payload.categoryId
        )
        .then((response) => {
          context.commit("addAllCatPData", response);
        })
        .catch((error) => {
          context.commit("addAllCatPData", error.response);
        });
    },
    getAllMatchCategories(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(
          ALLEGRO_ACCOUNTS +
            payload.accountPk +
            "/matching_categories/?category_name=" +
            encodeURIComponent(payload.categoryName)
        )
        .then((response) => {
          context.commit("addAllMatchCategoriesData", response);
        })
        .catch((error) => {
          context.commit("addAllMatchCategoriesData", error.response);
        });
    },
    getAllCategories(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var url = ALLEGRO_ACCOUNTS + payload.accountPk + "/categories/";
      if (payload.parentId) {
        url += "?parent_id=" + payload.parentId;
      }

      api
        .get(url)
        .then((response) => {
          context.commit("addAllCategoriesData", response);
        })
        .catch((error) => {
          context.commit("addAllCategoriesData", error.response);
        });
    },
    createCategories(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .post(CATEGORIES, payload)
        .then((response) => {
          context.commit("addCreateCategoriesData", response);
        })
        .catch((error) => {
          context.commit("addCreateCategoriesData", error.response);
        });
    },
    updateCategories(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      api
        .patch(CATEGORIES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateCategoriesData", response);
        })
        .catch((error) => {
          context.commit("addUpdateCategoriesData", error.response);
        });
    },
    deleteCategories(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(CATEGORIES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteCategoriesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteCategoriesData", error.response);
        });
    },
    reorderCategories(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const data = new FormData();
      data.append("position", payload.position);
      return api.patch(CATEGORIES + payload.pk + "/", data);
    },
    getProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          PRODUCTS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
        if (payload.category && payload.category !== "undefined") {
          pgurl += "&category=" + payload.category;
        }
      } else {
        if (payload.category) {
          pgurl = PRODUCTS + "?category=" + payload.category;
        } else {
          pgurl = PRODUCTS;
        }
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PRODUCTS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.radio["is_published"] === true) {
        pgurl += "&is_published=True";
      } else if (payload?.radio["is_published"] === false) {
        pgurl += "&is_published=False";
      }

      if (payload?.radio["is_available_on_allegro"] === true) {
        pgurl += "&is_available_on_allegro=True";
      } else if (payload?.radio["is_available_on_allegro"] === false) {
        pgurl += "&is_available_on_allegro=False";
      }

      if (payload.site_pk) {
        pgurl += "&site_pk=" + payload.site_pk;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addProductsData", response);
        })
        .catch((error) => {
          context.commit("addProductsData", error.response);
        });
    },
    getProduct(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .get(PRODUCTS + payload.pk)
        .then((response) => {
          context.commit("addProductData", response);
        })
        .catch((error) => {
          context.commit("addProductData", error.response);
        });
    },
    // Downloads the xlsx file under the name from Content-Disposition, like
    // productSrvc.exportProductPrices in the old panel.
    exportProductPrices(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .get(PRODUCTS + payload.pk + "/export_product_prices/", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          const disposition = response.headers?.["content-disposition"] || "";
          const match = /filename="?([^";]+)"?/.exec(disposition);
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = match
            ? match[1]
            : `product_${payload.pk}_prices.xlsx`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        });
    },
    importProductPrices(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      const data = new FormData();
      data.append("excel_file", payload.excel_file);

      // Resolves with unassigned_rows - the rows the import could not match.
      return api.post(PRODUCTS + payload.pk + "/import_product_prices/", data);
    },
    createProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      let pay = {};
      Object.keys(payload).forEach((e) => {
        if (Array.isArray(payload[e])) {
          pay[e] = JSON.stringify(payload[e]);
        } else {
          pay[e] = payload[e];
        }
      });
      api
        .post(PRODUCTS, pay)
        .then((response) => {
          context.commit("addCreateProductsData", response);
        })
        .catch((error) => {
          context.commit("addCreateProductsData", error.response);
        });
    },
    updateProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      let pay = {};
      // A saved image comes back as its URL and is left out; an empty string
      // means the image was removed and is sent so the backend clears it.
      if (
        payload.image === null ||
        payload.image === undefined ||
        (typeof payload.image === "string" && payload.image !== "")
      ) {
        delete payload.image;
      }
      Object.keys(payload).forEach((e) => {
        if (Array.isArray(payload[e])) {
          pay[e] = JSON.stringify(payload[e]);
        } else {
          pay[e] = payload[e];
        }
      });

      api
        .patch(PRODUCTS + payload.pk + "/", pay)
        .then((response) => {
          context.commit("addUpdateProductsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateProductsData", error.response);
        });
    },
    reorderProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const data = new FormData();
      data.append("position", payload.position);
      return api.patch(PRODUCTS + payload.pk + "/", data);
    },
    publishProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .post(PRODUCTS + "admin_publish_many/", payload)
        .then((response) => {
          context.commit("addPublishProductsData", response);
        })
        .catch((error) => {
          // A network error has no response - still commit a fresh object so the
          // list watcher fires and shows the error.
          context.commit("addPublishProductsData", error.response || {});
        });
    },
    popularProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .post(PRODUCTS + "admin_popular_many/", payload)
        .then((response) => {
          context.commit("addPopularProductsData", response);
        })
        .catch((error) => {
          context.commit("addPopularProductsData", error.response || {});
        });
    },
    copyProduct(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(PRODUCTS + payload.pk + "/copy_product/", payload)
        .then((response) => {
          context.commit("addCopyProductData", response);
        })
        .catch((error) => {
          context.commit("addCopyProductData", error.response);
        });
    },
    getAdminProductsOptions(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl = PRODUCTS + "admin_options_list/";
      if (payload?.name) {
        pgurl += "?name=" + payload?.name;
      } else if (payload?.page) {
        pgurl += "?page=" + payload?.page;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAdminProductsOptionsData", response);
        })
        .catch((error) => {
          context.commit("addAdminProductsOptionsData", error.response);
        });
    },
    getProductMaterials(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl = FILES + "admin_product_materials_files";
      if (payload?.pk) {
        pgurl += "/?product_pk=" + payload?.pk;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addProductMaterialsData", response);
        })
        .catch((error) => {
          context.commit("addProductMaterialsData", error.response);
        });
    },
    getProductOptions(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PRODUCTS + "admin_kind_options")
        .then((response) => {
          context.commit("addProductOptionsData", response);
        })
        .catch((error) => {
          context.commit("addProductOptionsData", error.response);
        });
    },
    getProductFormats(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(FORMAT + "admin_order_products_formats")
        .then((response) => {
          context.commit("addProductFormatsData", response);
        })
        .catch((error) => {
          context.commit("addProductFormatsData", error.response);
        });
    },
    getFormats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          FORMAT +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PRODUCTS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === FORMAT) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addFormatsData", response);
        })
        .catch((error) => {
          context.commit("addFormatsData", error.response);
        });
    },
    getFormat(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(FORMAT + payload.pk)
        .then((response) => {
          context.commit("addFormatData", response);
        })
        .catch((error) => {
          context.commit("addFormatData", error.response);
        });
    },
    createFormats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(FORMAT, payload)
        .then((response) => {
          context.commit("addCreateFormatsData", response);
        })
        .catch((error) => {
          context.commit("addCreateFormatsData", error.response);
        });
    },
    updateFormats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(FORMAT + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateFormatsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateFormatsData", error.response);
        });
    },
    deleteFormats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(FORMAT + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteFormatsData", response);
        })
        .catch((error) => {
          context.commit("addDeleteFormatsData", error.response);
        });
    },
    async getAppliances(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          APPLIANCES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = APPLIANCES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === APPLIANCES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.all) {
        try {
          let response = await api.get(pgurl);
          // Fallback for endpoints that do not use paginated shape.
          if (!Array.isArray(response?.data?.results)) {
            context.commit("addAppliancesData", response);
            return;
          }

          let allResults = [...response.data.results];
          let nextUrl = response.data.next;

          while (nextUrl) {
            const nextResponse = await api.get(nextUrl);
            if (!Array.isArray(nextResponse?.data?.results)) {
              break;
            }
            allResults = allResults.concat(nextResponse.data.results);
            nextUrl = nextResponse.data.next;
          }

          response = {
            ...response,
            data: {
              ...response.data,
              count: allResults.length,
              next: null,
              previous: null,
              results: allResults,
            },
          };

          context.commit("addAppliancesData", response);
        } catch (error) {
          context.commit("addAppliancesData", error.response);
        }
        return;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAppliancesData", response);
        })
        .catch((error) => {
          context.commit("addAppliancesData", error.response);
        });
    },
    getAppliance(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .get(APPLIANCES + payload.pk)
        .then((response) => {
          context.commit("addApplianceData", response);
        })
        .catch((error) => {
          context.commit("addApplianceData", error.response);
        });
    },
    createAppliances(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .post(APPLIANCES, payload)
        .then((response) => {
          context.commit("addCreateAppliancesData", response);
        })
        .catch((error) => {
          context.commit("addCreateAppliancesData", error.response);
        });
    },
    updateAppliances(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .patch(APPLIANCES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateAppliancesData", response);
        })
        .catch((error) => {
          context.commit("addUpdateAppliancesData", error.response);
        });
    },
    deleteAppliances(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(APPLIANCES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteAppliancesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteAppliancesData", error.response);
        });
    },
    getParameters(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          PARAMETERS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PARAMETERS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PARAMETERS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addParametersData", response);
        })
        .catch((error) => {
          context.commit("addParametersData", error.response);
        });
    },
    getAdminParameters(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          ADMIN_PARAMETERS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = ADMIN_PARAMETERS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === ADMIN_PARAMETERS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAdminParametersData", response);
        })
        .catch((error) => {
          context.commit("addAdminParametersData", error.response);
        });
    },
    getParameter(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PARAMETERS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addParameterData", response);
        })
        .catch((error) => {
          context.commit("addParameterData", error.response);
        });
    },
    createParameters(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(PARAMETERS, payload)
        .then((response) => {
          context.commit("addCreateParametersData", response);
        })
        .catch((error) => {
          context.commit("addCreateParametersData", error.response);
        });
    },
    updateParameters(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(PARAMETERS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateParametersData", response);
        })
        .catch((error) => {
          context.commit("addUpdateParametersData", error.response);
        });
    },
    deleteParameters(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(PARAMETERS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteParametersData", response);
        })
        .catch((error) => {
          context.commit("addDeleteParametersData", error.response);
        });
    },
    getFormatGroups(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          FORMAT_GROUPS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = FORMAT_GROUPS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === FORMAT_GROUPS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addFormatGroupsData", response);
        })
        .catch((error) => {
          context.commit("addFormatGroupsData", error.response);
        });
    },
    getFormatGroupsAdmin(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(FORMAT_GROUPS + "admin_for_formats_list")
        .then((response) => {
          context.commit("addFormatGroupsAdminData", response);
        })
        .catch((error) => {
          context.commit("addFormatGroupsAdminData", error.response);
        });
    },
    getFormatGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(FORMAT_GROUPS + payload.pk)
        .then((response) => {
          context.commit("addFormatGroupData", response);
        })
        .catch((error) => {
          context.commit("addFormatGroupData", error.response);
        });
    },
    createFormatGroups(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(FORMAT_GROUPS, payload)
        .then((response) => {
          context.commit("addCreateFormatGroupsData", response);
        })
        .catch((error) => {
          context.commit("addCreateFormatGroupsData", error.response);
        });
    },
    updateFormatGroups(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(FORMAT_GROUPS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateFormatGroupsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateFormatGroupsData", error.response);
        });
    },
    deleteFormatGroups(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(FORMAT_GROUPS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteFormatGroupsData", response);
        })
        .catch((error) => {
          context.commit("addDeleteFormatGroupsData", error.response);
        });
    },
    getpOptionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          PGROUP_OPTIONS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PGROUP_OPTIONS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PGROUP_OPTIONS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.site_pk) {
        if (pgurl === PGROUP_OPTIONS) {
          pgurl += "?site_pk=" + payload.site_pk;
        } else {
          pgurl += "&site_pk=" + payload.site_pk;
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPoptionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addPoptionsGroupData", error.response);
        });
    },
    getpOptionsAdminGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          PAGROUP_OPTIONS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PAGROUP_OPTIONS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PAGROUP_OPTIONS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPAoptionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addPAoptionsGroupData", error.response);
        });
    },
    getpOptionsEx(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          PEX_OPTIONS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PEX_OPTIONS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PEX_OPTIONS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addPoptionsExData", response);
        })
        .catch((error) => {
          context.commit("addPoptionsExData", error.response);
        });
    },
    getPOG(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PGROUP_OPTIONS + payload.pk)
        .then((response) => {
          context.commit("addPOGData", response);
        })
        .catch((error) => {
          context.commit("addPOGData", error.response);
        });
    },
    getPOEX(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PEX_OPTIONS + payload.pk)
        .then((response) => {
          context.commit("addPOEXData", response);
        })
        .catch((error) => {
          context.commit("addPOEXData", error.response);
        });
    },
    createpOptionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(PGROUP_OPTIONS, payload)
        .then((response) => {
          context.commit("addCreatePoptionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addCreatePoptionsGroupData", error.response);
        });
    },
    createpOptionsEx(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(PEX_OPTIONS, payload)
        .then((response) => {
          context.commit("addCreatePoptionsExData", response);
        })
        .catch((error) => {
          context.commit("addCreatePoptionsExData", error.response);
        });
    },
    deletepOptionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(PGROUP_OPTIONS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeletePoptionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addDeletePoptionsGroupData", error.response);
        });
    },
    deletepOptionsEx(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(PEX_OPTIONS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeletePoptionsExData", response);
        })
        .catch((error) => {
          context.commit("addDeletePoptionsExData", error.response);
        });
    },
    updatepOptionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const pk = payload?.pk;
      const data = payload?.data ? payload.data : payload;
      const formData = new FormData();
      Object.entries(data || {}).forEach(([key, value]) => {
        if (value instanceof Date) {
          formData.append(key, value.toISOString());
        } else if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      api
        .patch(PGROUP_OPTIONS + pk + "/", formData)
        .then((response) => {
          context.commit("addUpdatePoptionsGroupData", response);
        })
        .catch((error) => {
          context.commit("addUpdatePoptionsGroupData", error.response);
        });
    },
    reorderpOptionsGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const data = new FormData();
      data.append("position", payload.position);
      return api.patch(PGROUP_OPTIONS + payload.pk + "/", data);
    },
    updatepOptionsEx(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(PEX_OPTIONS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdatePoptionsExData", response);
        })
        .catch((error) => {
          context.commit("addUpdatePoptionsExData", error.response);
        });
    },
    getPOGChoices(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PGROUP_OPTIONS + "group_choices")
        .then((response) => {
          context.commit("addPOGChoicesData", response);
        })
        .catch((error) => {
          context.commit("addPOGChoicesData", error.response);
        });
    },
    getAdminProductOptions(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PRODUCT_OPTIONS + "admin_product_options/")
        .then((response) => {
          context.commit("addAdminProductOptionsData", response);
        })
        .catch((error) => {
          context.commit("addAdminProductOptionsData", error.response);
        });
    },
    getAdminProductSearchOptions(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl = PRODUCT_OPTIONS + "admin_search_list/";

      if (payload?.name) {
        pgurl += "?query=" + payload?.name;
      } else if (payload?.page) {
        pgurl += "?page=" + payload?.page;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAdminProductSearchData", response);
        })
        .catch((error) => {
          context.commit("addAdminProductSearchData", error.response);
        });
    },
    getAdminOptionsListByGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let url =
        PRODUCT_OPTIONS + "admin_options_list/?group_pk=" + payload.group_pk;
      if (payload?.page) {
        url += "&page=" + payload.page;
      }
      if (payload?.itemsPerPage) {
        url += "&page_size=" + payload.itemsPerPage;
      }
      if (payload?.ordering) {
        url += "&ordering=" + payload.ordering;
      }
      if (payload?.search) {
        Object.entries(payload.search).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            url +=
              "&" +
              encodeURIComponent(key) +
              "=" +
              encodeURIComponent(String(value));
          }
        });
      }

      api
        .get(url)
        .then((response) => {
          context.commit("addAdminOptionsListByGroupData", response);
        })
        .catch((error) => {
          context.commit("addAdminOptionsListByGroupData", error.response);
        });
    },
    getOption(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PRODUCT_OPTIONS + pk + "/")
        .then((response) => {
          context.commit("addOptionData", response);
        })
        .catch((error) => {
          context.commit("addOptionData", error.response);
        });
    },
    updateOption(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const formData = new FormData();
      Object.keys(payload.data).forEach((key) => {
        const value = payload.data[key];
        if (value !== null && value !== undefined) {
          if (value instanceof File) {
            formData.append(key, value);
          } else if (typeof value === "object") {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        }
      });

      api
        .put(PRODUCT_OPTIONS + payload.pk + "/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          context.commit("addUpdateOptionData", response);
        })
        .catch((error) => {
          context.commit("addUpdateOptionData", error.response);
        });
    },
    reorderOption(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const data = new FormData();
      data.append("position", payload.position);
      return api.patch(PRODUCT_OPTIONS + payload.pk + "/", data);
    },
    deleteOption(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(PRODUCT_OPTIONS + pk + "/")
        .then((response) => {
          context.commit("addDeleteOptionData", response);
        })
        .catch((error) => {
          context.commit("addDeleteOptionData", error.response);
        });
    },
    createOption(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const formData = new FormData();
      Object.keys(payload.data).forEach((key) => {
        const value = payload.data[key];
        if (value !== null && value !== undefined) {
          if (value instanceof File) {
            formData.append(key, value);
          } else if (typeof value === "object") {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        }
      });

      api
        .post(PRODUCT_OPTIONS, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          context.commit("addCreateOptionData", response);
        })
        .catch((error) => {
          context.commit("addCreateOptionData", error.response);
        });
    },
    upsertProductOptionTechLine(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const urlBase = `${API_HOST}/${VERSION}/product-option-tech-line/`;
      const formData = new FormData();

      // Add all fields to FormData
      if (payload.option) formData.append("option", payload.option);
      if (payload.start_x !== undefined)
        formData.append("start_x", payload.start_x);
      if (payload.start_y !== undefined)
        formData.append("start_y", payload.start_y);
      if (payload.end_x !== undefined) formData.append("end_x", payload.end_x);
      if (payload.end_y !== undefined) formData.append("end_y", payload.end_y);

      // Add image if provided
      if (payload.image && payload.image instanceof File) {
        formData.append("image", payload.image);
      }
      // Include pk in body when known
      if (payload.pk) {
        formData.append("pk", payload.pk);
      }

      if (payload.option) {
        // Prefer pk from option's tech_line_object when available
        api
          .get(PRODUCT_OPTIONS + payload.option + "/")
          .then((optionRes) => {
            const techPk = optionRes?.data?.tech_line_object?.pk || payload.pk;
            if (techPk) {
              return api
                .patch(urlBase + techPk + "/", formData, {
                  headers: { "Content-Type": "multipart/form-data" },
                })
                .then((response) => ({ response, wasPatch: true }));
            }
            // No pk, create new
            return api
              .post(urlBase, formData, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .then((response) => ({ response, wasPatch: false }));
          })
          .then(({ response, wasPatch }) => {
            if (wasPatch) {
              context.commit("addUpdateTechLineData", response);
            } else {
              context.commit("addTechLineData", response);
            }
          })
          .catch((error) => {
            const res = error.response;
            if (res?.status === 400 || res?.status === 404) {
              context.commit("addTechLineData", res);
            } else {
              context.commit("addUpdateTechLineData", res);
            }
          });
      } else if (payload.pk) {
        api
          .patch(urlBase + payload.pk + "/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            context.commit("addUpdateTechLineData", response);
          })
          .catch((error) => {
            context.commit("addUpdateTechLineData", error.response);
          });
      } else {
        api
          .post(urlBase, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            context.commit("addTechLineData", response);
          })
          .catch((error) => {
            context.commit("addTechLineData", error.response);
          });
      }
    },
    deleteProductOptionTechLine(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const urlBase = `${API_HOST}/${VERSION}/product-option-tech-line/`;
      const pk = typeof payload === "object" ? payload.pk : payload;

      if (!pk) {
        return Promise.resolve();
      }

      return api
        .delete(urlBase + pk + "/")
        .then((response) => {
          // Reuse update bucket for now
          context.commit("addUpdateTechLineData", response);
        })
        .catch((error) => {
          context.commit("addUpdateTechLineData", error.response);
        });
    },
    getProductOptionTechLine(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(
          `${API_HOST}/${VERSION}/product-option-tech-line/?option=${payload.option}`
        )
        .then((response) => {
          context.commit("addTechLineData", response);
        })
        .catch((error) => {
          context.commit("addTechLineData", error.response);
        });
    },
    sendOrder(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ORDERS + pk + "/admin_send_check/")
        .then((response) => {
          context.commit("addSendOrderData", response);
        })
        .catch((error) => {
          context.commit("addSendOrderData", error.response);
        });
    },
    orderActions(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      if (payload.type === "/admin_card/") {
        api
          .get(ORDERS + payload.pk + payload.type, {
            responseType: "blob",
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", payload.pk + "_card");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error("Błąd podczas pobierania pliku:", error);
          });
      } else if (
        payload.type === "/proforma_invoice/" ||
        payload.type === "/advance_invoice/" ||
        payload.type === "/final_invoice/" ||
        payload.type === "/vat_invoice/"
      ) {
        api
          .get(ORDERS + payload.pk + payload.type, {
            responseType: "blob",
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", payload.pk + "_f");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error("Błąd podczas pobierania pliku:", error);
          });
      } else {
        api
          .post(ORDERS + payload.pk + payload.type, payload)
          .then((response) => {
            response.type = payload.type;
            context.commit("addActionsOrderData", response);
          })
          .catch((error) => {
            context.commit("addActionsOrderData", error.response);
          });
      }
    },
    getOrder(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ORDERS + pk)
        .then((response) => {
          context.commit("addOrderData", response);
        })
        .catch((error) => {
          context.commit("addOrderData", error.response);
        });
    },
    getOrders(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.page) {
        pgurl =
          ORDERS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = ORDERS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === ORDERS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.filters) {
        for (const [key, value] of Object.entries(payload.filters)) {
          if (value === undefined || value === null || value === "") {
            continue;
          }

          const values = Array.isArray(value) ? value : [value];
          const normalized = values
            .map((element) =>
              typeof element === "object" && element !== null
                ? element.value
                : element
            )
            .filter(
              (element) =>
                element !== undefined && element !== null && element !== ""
            );

          if (normalized.length === 0) {
            continue;
          }

          normalized.forEach((element) => {
            if (pgurl === ORDERS) {
              pgurl += "?" + key + "=" + element;
            } else {
              pgurl += "&" + key + "=" + element;
            }
          });
        }
      }

      if (payload?.notes_text && payload?.notes_text.length > 0) {
        pgurl += "&notes_text=" + payload.notes_text;
      }
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addOrdersData", response);
        })
        .catch((error) => {
          context.commit("addOrdersData", error.response);
        });
    },
    getClientOrders(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          ORDERS +
          "?client_pk=" +
          payload.client_pk +
          "&page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = ORDERS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === ORDERS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addClientOrdersData", response);
        })
        .catch((error) => {
          context.commit("addClientOrdersData", error.response);
        });
    },

    getClientMessages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          CONTACT +
          "?client_pk=" +
          payload.client_pk +
          "&page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = CONTACT;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === CONTACT) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addClientMessagesData", response);
        })
        .catch((error) => {
          context.commit("addClientMessagesData", error.response);
        });
    },
    getClientInvoices(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          INVOICES +
          "?client_pk=" +
          payload.client_pk +
          "&page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = INVOICES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === INVOICES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addClientInvoicesData", response);
        })
        .catch((error) => {
          context.commit("addClientInvoicesData", error.response);
        });
    },
    getOrderAdminCard(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ORDERS + pk + "/admin_card/", { responseType: "arraybuffer" })
        .then((response) => {
          let blob = new Blob([response.data], {
              type: "application/pdf",
            }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch();
    },
    adminSendUpsRetrieve(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ORDERS + pk + "/admin_send_ups_retrieve/")
        .then((response) => {
          context.commit("addAdminSendUpsData", response);
        })
        .catch((error) => {
          context.commit("addAdminSendUpsData", error.response);
        });
    },
    generateLabel(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      return api
        .patch(ORDER_DELIVERIES + pk + "/admin_generate_label/")
        .then((response) => {
          context.commit("addLabelData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addLabelData", error.response);
          return Promise.reject(error.response || error);
        });
    },
    updateTracking(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(ORDER_DELIVERIES + payload.pk + "/", payload)
        .then((response) => {
          if (payload.country) {
            response.type = "address";
          }
          context.commit("addUpdateTrackingData", response);
        })
        .catch((error) => {
          context.commit("addUpdateTrackingData", error.response);
        });
    },
    getOrderDeliveryOptions(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ORDERS + pk + "/admin_get_order_delivery_options/")
        .then((response) => {
          context.commit("addDeliveryOptionsData", response);
        })
        .catch((error) => {
          context.commit("addDeliveryOptionsData", error.response);
        });
    },
    updateOrderDeliveryMethod(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(ORDERS + payload.pk + "/admin_update_external/", {
          ups_delivery_service: payload.ups_delivery_service,
          target_point_name: payload.target_point_name,
        })
        .then((response) => {
          context.commit("addUpdateExternalData", response);
        })
        .catch((error) => {
          context.commit("addUpdateExternalData", error.response);
        });
    },
    duplicateOrder(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(ORDERS + pk + "/admin_duplicate/")
        .then((response) => {
          context.commit("addDuplicateOrderData", response);
        })
        .catch((error) => {
          context.commit("addDuplicateOrderData", error.response);
        });
    },
    externalOrderConfirm(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(ORDERS + pk + "/admin_external_order_confirm/", {})
        .then((response) => {
          context.commit("addExternalOrderConfirmData", response);
        })
        .catch((error) => {
          context.commit("addExternalOrderConfirmData", error.response);
        });
    },
    updateOrderProduct(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(ORDER_PRODUCTS + payload.pk + "/admin_update/", payload.data)
        .then((response) => {
          context.commit("addUpdateOrderProductData", response);
        })
        .catch((error) => {
          context.commit("addUpdateOrderProductData", error.response);
        });
    },
    upsUpdateRealWeight(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var data = new FormData();
      data.append("real_weight", payload.real_weight);

      api
        .patch(
          ORDER_PRODUCTSBD + payload.pk + "/admin_send_ups_update_real_weight/",
          data
        )
        .then((response) => {
          context.commit("addRealWeightData", response);
        })
        .catch((error) => {
          context.commit("addRealWeightData", error.response);
        });
    },
    confirmDeliveryPackage(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(ORDER_DELIVERY_PACKAGES + pk + "/", { is_packed: true })
        .then((response) => {
          context.commit("addConfirmDeliveryPackageData", response);
        })
        .catch((error) => {
          context.commit("addConfirmDeliveryPackageData", error.response);
        });
    },
    printDeliveryPackageLabel(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      return api.get(ORDER_DELIVERY_PACKAGES + pk + "/");
    },
    getOrderProductFiles(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ORDER_PRODUCT_FILES + payload.pk + payload.type, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let blob = new Blob([response.data], {
              type: "application/pdf",
            }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch((error) => {
          context.commit("addOrderProductFilesData", error);
        });
    },
    // Single order product file - used to poll the preflight status after
    // the project file has been uploaded.
    getOrderProductFileDetail(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .get(ORDER_PRODUCT_FILES + pk + "/")
        .then((response) => {
          context.commit("addOrderProductFileDetailData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addOrderProductFileDetailData", error.response);
          return Promise.reject(error);
        });
    },
    // Project (preview) file of an order product. For booklets with UV the
    // file is sent as the cover file, exactly as the old admin panel does.
    createOrderProductFile(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      const data = new FormData();
      data.append("order_product", payload.orderProductPk);
      data.append(
        payload.isBookletUv ? "client_cover_file" : "client_file",
        payload.file
      );

      return api
        .post(ORDER_PRODUCT_FILES, data)
        .then((response) => {
          context.commit("addCreateOrderProductFileData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addCreateOrderProductFileData", error.response);
          return Promise.reject(error);
        });
    },
    deleteOrderProductFile(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.delete(ORDER_PRODUCT_FILES + pk + "/");
    },
    // Source file of an order product - the backend accepts it only for
    // orders coming from Allegro.
    createSourceFile(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      const data = new FormData();
      data.append("order_product", payload.orderProductPk);
      data.append("file", payload.file);

      return api
        .post(ORDER_SOURCE_FILES, data)
        .then((response) => {
          context.commit("addCreateSourceFileData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addCreateSourceFileData", error.response);
          return Promise.reject(error);
        });
    },
    getMontageCard(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(MONTAGES + payload.pk + "/admin_montage_card/", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let blob = new Blob([response.data], {
              type: "application/pdf",
            }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        });
    },
    getMontageProductionLogs(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(MONTAGES + payload.pk + "/production_logs/")
        .then((response) => {
          response.montage_pk = payload.pk;
          context.commit("addMontageProductionLogsData", response);
        })
        .catch((error) => {
          context.commit("addMontageProductionLogsData", error.response);
        });
    },
    startMontageProcess(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(MONTAGES + payload.pk + payload.type, payload)
        .then((response) => {
          context.commit("addMontageProcessData", response);
        })
        .catch((error) => {
          context.commit("addMontageProcessData", error.response);
        });
    },
    getCubes(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl = CUBES;
      const params = [];

      if (payload?.page) {
        params.push("page=" + payload.page);
      }

      if (payload?.page_size) {
        params.push("page_size=" + payload.page_size);
      }

      if (payload?.order_pk) {
        params.push("order_pk=" + payload.order_pk);
      }

      if (payload?.site_pk) {
        params.push("site_pk=" + payload.site_pk);
      }

      if (params.length > 0) {
        pgurl += "?" + params.join("&");
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addCubesData", response);
        })
        .catch((error) => {
          context.commit("addCubesData", error.response);
        });
    },
    getCube(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CUBES + payload.pk)
        .then((response) => {
          context.commit("addCubeData", response);
        })
        .catch((error) => {
          context.commit("addCubeData", error.response);
        });
    },
    getCubeProductFilterGO(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(
          PGROUP_OPTIONS +
            "admin_production_cube_product_filter_group_options/?production_cube=" +
            payload.pk
        )
        .then((response) => {
          context.commit("addCubeProductFilterData", response);
        })
        .catch((error) => {
          context.commit("addCubeProductFilterData", error.response);
        });
    },
    getCubeProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          CUBE_PRODUCTS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = CUBE_PRODUCTS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === CUBE_PRODUCTS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      for (const value of Object.entries(payload.filters)) {
        if (value[1].length) {
          pgurl += "&options_pks=" + value[1];
        }
      }

      api
        .get(pgurl + "&production_cube_pk=" + payload.pk)
        .then((response) => {
          context.commit("addCubeProductsData", response);
        })
        .catch((error) => {
          context.commit("addCubeProductsData", error.response);
        });
    },
    getCubeProduct(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let products_pks = "";
      for (const value of Object.values(payload.pks)) {
        if (value.pk) {
          products_pks += "&products_pks=" + value.pk;
        }
      }

      if (!products_pks) {
        products_pks = "&products_pks=" + payload.pks;
      }

      api
        .get(
          CUBE_PRODUCTS +
            "admin_to_realization_list/?production_cube_pk=" +
            payload.pk +
            products_pks
        )
        .then((response) => {
          context.commit("addCubeProductData", response);
        })
        .catch((error) => {
          context.commit("addCubeProductData", error.response);
        });
    },
    saveOrderProcessStage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(ORDER_PROCESS_STAGE, payload)
        .then((response) => {
          context.commit("addOrderProcessStageData", response);
        })
        .catch((error) => {
          context.commit("addOrderProcessStageData", error.response);
        });
    },
    getOrderProcessStage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let products_pks = "";
      for (const value of Object.values(payload.pks)) {
        if (value.pk) {
          if (products_pks) {
            products_pks += "&order_products_pks=" + value.pk;
          } else {
            products_pks += "?order_products_pks=" + value.pk;
          }
        }
      }
      if (!products_pks) {
        products_pks = "?order_products_pks=" + payload.pk;
      }

      api
        .get(ORDER_PROCESS_STAGE + products_pks)
        .then((response) => {
          context.commit("addOrderProcessStatusData", response);
        })
        .catch((error) => {
          context.commit("addOrderProcessStatusData", error.response);
        });
    },
    getOrderProductFilePages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ORDER_PRODUCT_FILE_PAGES + payload.pk + "/get_page_preview", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          if (payload.second) {
            context.commit("addOrderProductFileData2", response);
          } else {
            context.commit("addOrderProductFileData", response);
          }
        })
        .catch((error) => {
          if (payload.second) {
            context.commit("addOrderProductFileData2", error.response);
          } else {
            context.commit("addOrderProductFileData", error.response);
          }
        });
    },
    // Accepts or revokes the acceptance of a single preview page.
    // The backend serializer works on a list, so the response is an array.
    acceptOrderProductFilePage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.patch(ORDER_PRODUCT_FILE_PAGES + payload.pk + "/", {
        is_accepted: payload.is_accepted,
      });
    },
    getMontagePapers(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PRODUCT_OPTIONS + "admin_montage_paper_options")
        .then((response) => {
          context.commit("addMontagePapersData", response);
        })
        .catch((error) => {
          context.commit("addMontagePapersData", error.response);
        });
    },
    getMontageFormats(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(FORMAT + "admin_montage_format")
        .then((response) => {
          context.commit("addMontageFormatsData", response);
        })
        .catch((error) => {
          context.commit("addMontageFormatsData", error.response);
        });
    },
    getMontagePlates(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PLATES + "admin_montage_plates")
        .then((response) => {
          context.commit("addMontagePlatesData", response);
        })
        .catch((error) => {
          context.commit("addMontagePlatesData", error.response);
        });
    },
    getMontageProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      let exValName = "exclude_pks";
      var url = MONTAGE_PRODUCTS + "admin_list_left_table";
      if (payload.right) {
        url = MONTAGE_PRODUCTS + "admin_list_right_table";
        exValName = "pks";
      }

      var pgurl;
      if (payload?.page) {
        pgurl =
          url +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = url;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === url) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload.site_pk) {
        if (pgurl === url) {
          pgurl += "?site_pk=" + payload.site_pk;
        } else {
          pgurl += "&site_pk=" + payload.site_pk;
        }
      }

      // Process filters
      if (payload.filters) {
        for (const [key, value] of Object.entries(payload.filters)) {
          if (value && value.length > 0) {
            const filterValues = Array.isArray(value) ? value : [value];
            const validValues = filterValues
              .filter((v) => v && v !== "")
              .map((v) =>
                typeof v === "object" && v.value !== undefined ? v.value : v
              );
            if (validValues.length > 0) {
              const filterString = validValues.join(",");

              // Check if parameter name contains "filter" and add options_pks instead of original parameter
              if (key.toLowerCase().includes("filter")) {
                // Add multiple options_pks parameters instead of comma-separated values
                validValues.forEach((vv) => {
                  pgurl += "&options_pks=" + vv;
                });
              } else if (key === "quantities") {
                // Do not send &quantities; only send repeated &quantity_pks
                validValues.forEach((vv) => {
                  pgurl += "&quantity_pks=" + vv;
                });
              } else if (key === "paper") {
                // Do not send &paper; only send repeated &paper_pks
                validValues.forEach((vv) => {
                  pgurl += "&paper_pks=" + vv;
                });
              } else if (key === "format") {
                // Do not send &format; only send repeated &format_pks
                validValues.forEach((vv) => {
                  pgurl += "&format_pks=" + vv;
                });
              } else if (key === "source") {
                // Repeat &source for each value instead of comma-separated
                validValues.forEach((vv) => {
                  pgurl += "&source=" + vv;
                });
              } else if (key === "order_statuses") {
                // Repeat &order_statuses for each value instead of comma-separated
                validValues.forEach((vv) => {
                  pgurl += "&order_statuses=" + vv;
                });
              } else {
                pgurl += "&" + key + "=" + filterString;
              }
            }
          }
        }
      }

      for (const value of payload.exclude) {
        if (value) {
          let pkValue;
          if (typeof value === "object" && value.pk) {
            pkValue = value.pk;
          } else if (
            typeof value === "number" ||
            (typeof value === "string" && !isNaN(value))
          ) {
            pkValue = value;
          }

          if (pkValue !== undefined) {
            pgurl += "&" + exValName + "=" + pkValue;
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          response.right = payload.right;
          context.commit("addMontageProductsData", response);
        })
        .catch((error) => {
          context.commit("addMontageProductsData", error.response);
        });
    },
    updateMontageProduct(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(MONTAGE_PRODUCTS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateMontageProductData", response);
        })
        .catch((error) => {
          context.commit("addUpdateMontageProductData", error.response);
        });
    },
    importProductPQ(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.post(PRODUCTS + payload.pk + "/admin_apply_product_log/", {
        product: payload.product,
      });
    },
    // Applies the latest group/option log of one product to many products -
    // the same endpoint productDataSrvc.applyManyProductLog uses in the old
    // panel. Resolves with the list of skipped operations.
    applyManyProductLog(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.post(PRODUCTS + "admin_apply_many_product_log/", {
        product_to_apply: payload.productToApply,
        products: payload.products,
      });
    },
    getSites(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(SITES + "field_opts")
        .then((response) => {
          context.commit("addSitesData", response);
        })
        .catch((error) => {
          context.commit("addSitesData", error.response);
        });
    },
    getMontageFilterGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let url =
        PGROUP_OPTIONS +
        "admin_montage_product_filter_group_options/?" +
        payload.type +
        "=true";

      // Dla prawej tabeli dodaj pks produktów
      if (payload.type === "right" && payload.pks && payload.pks.length > 0) {
        const sanitizedPks = payload.pks.filter(
          (pk) => pk !== undefined && pk !== null && pk !== "undefined"
        );
        if (sanitizedPks.length > 0) {
          const pksString = sanitizedPks.map((pk) => `pks=${pk}`).join("&");
          url += "&" + pksString;
        }
      }

      api
        .get(url)
        .then((response) => {
          response.type = payload.type;
          context.commit("addMontageFilterGroupData", response);
        })
        .catch((error) => {
          context.commit("addMontageFilterGroupData", error.response);
        });
    },
    getMontageFormatsOptions(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let url =
        FORMAT +
        "admin_montage_product_filter_format?" +
        payload.type +
        "=true";

      if (payload.type === "right" && payload.pks && payload.pks.length > 0) {
        const sanitizedPks = payload.pks.filter(
          (pk) => pk !== undefined && pk !== null && pk !== "undefined"
        );
        if (sanitizedPks.length > 0) {
          url += "&" + sanitizedPks.map((pk) => `pks=${pk}`).join("&");
        }
      }

      api
        .get(url)
        .then((response) => {
          response.type = payload.type;
          context.commit("addMontageFormatData", response);
        })
        .catch((error) => {
          context.commit("addMontageFormatData", error.response);
        });
    },
    getMontageQuantities(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let urlQ =
        QUANTITIES +
        "admin_montage_product_filter_quantity?" +
        payload.type +
        "=true";

      if (payload.type === "right" && payload.pks && payload.pks.length > 0) {
        const sanitizedPksQ = payload.pks.filter(
          (pk) => pk !== undefined && pk !== null && pk !== "undefined"
        );
        if (sanitizedPksQ.length > 0) {
          urlQ += "&" + sanitizedPksQ.map((pk) => `pks=${pk}`).join("&");
        }
      }

      api
        .get(urlQ)
        .then((response) => {
          response.type = payload.type;
          context.commit("addMontageQuantityData", response);
        })
        .catch((error) => {
          context.commit("addMontageQuantityData", error.response);
        });
    },
    getMontagePaperOptions(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let urlP =
        PRODUCT_OPTIONS +
        "admin_montage_product_filter_paper_options/?" +
        payload.type +
        "=true";

      if (payload.type === "right" && payload.pks && payload.pks.length > 0) {
        const sanitizedPksP = payload.pks.filter(
          (pk) => pk !== undefined && pk !== null && pk !== "undefined"
        );
        if (sanitizedPksP.length > 0) {
          urlP += "&" + sanitizedPksP.map((pk) => `pks=${pk}`).join("&");
        }
      }

      api
        .get(urlP)
        .then((response) => {
          response.type = payload.type;
          context.commit("addMontagePaperOptionsData", response);
        })
        .catch((error) => {
          context.commit("addMontagePaperOptionsData", error.response);
        });
    },
    createMontage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(MONTAGES, payload)
        .then((response) => {
          context.commit("addCreateMontageData", response);
        })
        .catch((error) => {
          context.commit("addCreateMontageData", error.response);
        });
    },
    getClients(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      var pgurl;
      if (payload?.page) {
        pgurl =
          CLIENTS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = CLIENTS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === CLIENTS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      if (payload?.is_active !== undefined && payload?.is_active !== null) {
        let arr = Array.isArray(payload.is_active)
          ? payload.is_active
          : [payload.is_active];
        const normalized = arr.map((item) =>
          item && typeof item === "object" ? item.value : item
        );
        const values = normalized.filter(
          (v) => v !== null && v !== undefined && v !== ""
        );
        if (values.length > 0) {
          const isActiveValues = values.join(",");
          if (pgurl === CLIENTS) {
            pgurl += "?is_active=" + isActiveValues;
          } else {
            pgurl += "&is_active=" + isActiveValues;
          }
        }
      }

      if (payload?.site_pk) {
        if (pgurl === CLIENTS) {
          pgurl += "?site_pk=" + payload.site_pk;
        } else {
          pgurl += "&site_pk=" + payload.site_pk;
        }
      }

      api
        .get(pgurl, payload)
        .then((response) => {
          context.commit("addClientsData", response);
        })
        .catch((error) => {
          context.commit("addClientsData", error.response);
        });
    },
    getClient(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CLIENTS + payload.pk + "/admin_get_flattened")
        .then((response) => {
          context.commit("addClientData", response);
        })
        .catch((error) => {
          context.commit("addClientData", error.response);
        });
    },
    deleteClient(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(CLIENTS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addDeleteClientData", response);
        })
        .catch((error) => {
          context.commit("addDeleteClientData", error.response);
        });
    },
    updateClient(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(CLIENTS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateClientData", response);
        })
        .catch((error) => {
          context.commit("addUpdateClientData", error.response);
        });
    },
    createClient(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(CLIENTS, payload)
        .then((response) => {
          context.commit("addCreateClientData", response);
        })
        .catch((error) => {
          context.commit("addCreateClientData", error.response);
        });
    },
    getAdminClients(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CLIENTS + "admin_client_options")
        .then((response) => {
          context.commit("addAdminClientsData", response);
        })
        .catch((error) => {
          context.commit("addAdminClientsData", error.response);
        });
    },
    getCountriesList(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(COUNTRIES)
        .then((response) => {
          context.commit("addCountriesData", response);
        })
        .catch((error) => {
          context.commit("addCountriesData", error.response);
        });
    },
    getDiscountGroups(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          DISCOUNTS_GROUPS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = DISCOUNTS_GROUPS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === DISCOUNTS_GROUPS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addDiscountGroupsData", response);
        })
        .catch((error) => {
          context.commit("addDiscountGroupsData", error.response);
        });
    },
    getDiscountGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(DISCOUNTS_GROUPS + payload.pk + "/")
        .then((response) => {
          context.commit("addDiscountGroupData", response);
        })
        .catch((error) => {
          context.commit("addDiscountGroupData", error.response);
        });
    },
    updateDiscountGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(DISCOUNTS_GROUPS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateDiscountGroupsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateDiscountGroupsData", error.response);
        });
    },
    deleteDiscountGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(DISCOUNTS_GROUPS + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteDiscountGroupsData", response);
        })
        .catch((error) => {
          context.commit("addDeleteDiscountGroupsData", error.response);
        });
    },
    createDiscountGroup(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(DISCOUNTS_GROUPS, payload)
        .then((response) => {
          context.commit("addCreateDiscountGroupsData", response);
        })
        .catch((error) => {
          context.commit("addCreateDiscountGroupsData", error.response);
        });
    },
    getOrderProductsFile(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ORDER_PRODUCTS + payload.pk + "/admin_get_file_data")
        .then((response) => {
          context.commit("addOrderProductsFileData", response);
        })
        .catch((error) => {
          context.commit("addOrderProductsFileData", error.response);
        });
    },
    getMessages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          CONTACT +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = CONTACT;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === CONTACT) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addMessagesData", response);
        })
        .catch((error) => {
          context.commit("addMessagesData", error.response);
        });
    },
    getHomeMyMessagesCount(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CONTACT_FOR_USER_COMPETENCES)
        .then((response) => {
          context.commit("addHomeMyMessagesCountData", response);
        })
        .catch((error) => {
          context.commit("addHomeMyMessagesCountData", error.response);
        });
    },
    getHomeAllMessagesCount(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CONTACT)
        .then((response) => {
          context.commit("addHomeAllMessagesCountData", response);
        })
        .catch((error) => {
          context.commit("addHomeAllMessagesCountData", error.response);
        });
    },
    getMessagesDetails(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CONTACT + payload.pk)
        .then((response) => {
          context.commit("addMessageData", response);
        })
        .catch((error) => {
          context.commit("addMessageData", error.response);
        });
    },
    getClientsContact(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      let url = CLIENTS + "/admin_client_contact_clients";
      if (payload?.pk) {
        url += "?client_contact_pk=" + payload.pk;
      }

      api
        .get(url)
        .then((response) => {
          context.commit("addClientsContactData", response);
        })
        .catch((error) => {
          context.commit("addClientsContactData", error.response);
        });
    },
    getAdminsContact(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ADMINS_LIST + "/client_contact_list")
        .then((response) => {
          context.commit("addAdminContactData", response);
        })
        .catch((error) => {
          context.commit("addAdminContactData", error.response);
        });
    },
    getAdminsReasons(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let url = COMPETENCIES_LIST + "/client_contact_list/";

      if (payload.complaintReason) {
        url += "?complaint_reason=True";
      }
      api
        .get(url)
        .then((response) => {
          if (payload.complaintReason) {
            context.commit("addAdminComplaintData", response);
          } else {
            context.commit("addAdminReasonsData", response);
          }
        })
        .catch((error) => {
          if (payload.complaintReason) {
            context.commit("addAdminComplaintData", error);
          } else {
            context.commit("addAdminReasonsData", error);
          }
        });
    },
    updateMessage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(CONTACT + payload.pk + "/", payload)
        .then((response) => {
          if (payload.closeMessage) {
            response.closeMessage = true;
          }
          context.commit("addUpdateMessageData", response);
        })
        .catch((error) => {
          context.commit("addUpdateMessageData", error.response);
        });
    },
    createMessage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(CONTACT, payload)
        .then((response) => {
          if (payload.closeMessage) {
            response.closeMessage = true;
          }
          context.commit("addCreateMessageData", response);
        })
        .catch((error) => {
          context.commit("addCreateMessageData", error.response);
        });
    },
    addMessageFile(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      // Returned so the caller can await the upload before unlocking the form.
      return api.post(MESSAGE_FILES, payload);
    },
    addConversation(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(MESSAGES, payload)
        .then((response) => {
          context.commit("addConversationData", response);
        })
        .catch((error) => {
          context.commit("addConversationData", error.response);
        });
    },
    // The tree as plain data - the labels and buttons of the nodes are built
    // in DiscountNodeLabel instead of the HTML sent by the list endpoint.
    getDiscounts(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(DISCOUNTS + "tree/")
        .then((response) => {
          context.commit("addDiscountsData", response);
        })
        .catch((error) => {
          context.commit("addDiscountsData", error.response);
        });
    },
    getDiscount(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(DISCOUNTS + payload.id)
        .then((response) => {
          context.commit("addDiscountData", response);
        })
        .catch((error) => {
          context.commit("addDiscountData", error.response);
        });
    },
    updateDiscount(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(DISCOUNTS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateDiscountsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateDiscountsData", error.response);
        });
    },
    // Bulk edit of the discounts checked in the tree. One request, so the API
    // can refuse a set in which one discount would zero another - separate
    // patches did that in a random order.
    updateDiscounts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(DISCOUNTS + "bulk_update/", {
          pks: payload.pks,
          value: payload.value,
        })
        .then((response) => {
          context.commit("addUpdateDiscountsData", response);
        })
        .catch((error) => {
          context.commit("addUpdateDiscountsData", error.response);
        });
    },
    // Downloads the JSON export of the whole tree or of the given branches
    // under the name from Content-Disposition.
    exportDiscountTree(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const params = {};
      if (payload.rootPks?.length) {
        params.root_pks = payload.rootPks.join(",");
      }
      return api
        .get(DISCOUNTS + "export_json/", { params, responseType: "blob" })
        .then((response) => {
          const disposition = response.headers?.["content-disposition"] || "";
          const match = /filename="?([^";]+)"?/.exec(disposition);
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/json" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.download = match ? match[1] : "discounts_export.json";
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        });
    },
    // Checks (commit=false) or saves (commit=true) the import of a file from
    // exportDiscountTree. Resolves with the response also for the 400 of a
    // file with errors, since it carries the plan to show.
    importDiscountTree(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      const data = new FormData();
      data.append("file", payload.file);
      if (payload.rootPks?.length) {
        data.append("root_pks", payload.rootPks.join(","));
      }
      return api
        .post(DISCOUNTS + "import_json/", data, {
          params: { commit: payload.commit ? "true" : "false" },
        })
        .catch((error) => {
          if (error.response) {
            return error.response;
          }
          throw error;
        });
    },
    createDiscountForQuantitity(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(DISCOUNTS + "create_discount_for_quantity/", payload)
        .then((response) => {
          context.commit("addCreateDiscountsForQData", response);
        })
        .catch((error) => {
          context.commit("addCreateDiscountsForQData", error.response);
        });
    },
    deleteDiscountForQuantitity(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(DISCOUNTS + "delete_discount_for_quantities/?id=" + payload.id)
        .then((response) => {
          context.commit("addCreateDiscountsForQData", response);
        })
        .catch((error) => {
          context.commit("addCreateDiscountsForQData", error.response);
        });
    },
    updateDiscountForQ(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      // Values from the price assistant are saved under all categories of the
      // product, with the cascade in every branch.
      const query = payload.allCategories ? "?all_categories=true" : "";
      api
        .post(
          DISCOUNTS + "update_discounts_for_quantity/" + query,
          payload.items
        )
        .then((response) => {
          context.commit("addCreateDiscountsForQData", response);
        })
        .catch((error) => {
          context.commit("addCreateDiscountsForQData", error.response);
        });
    },
    importDiscountForQ(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .post(DISCOUNTS + "import_discounts_for_quantity/", payload)
        .then((response) => {
          // The response carries the discounts parsed from the file, so it
          // feeds the same modal as a discount fetched by its id.
          context.commit("addDiscountData", response);
          context.commit("addImportDiscountsForQData", response);
        })
        .catch((error) => {
          context.commit("addImportDiscountsForQData", error.response);
        });
    },
    // Adds (without pk) or edits a note of a discount. Resolves with the
    // response also for a 400, since it carries the validation errors.
    saveDiscountNote(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const request = payload.pk
        ? api.patch(DISCOUNT_NOTES + payload.pk + "/", { text: payload.text })
        : api.post(DISCOUNT_NOTES, {
            discount: payload.discount,
            text: payload.text,
          });
      return request.catch((error) => {
        if (error.response) {
          return error.response;
        }
        throw error;
      });
    },
    deleteDiscountNote(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.delete(DISCOUNT_NOTES + payload.pk + "/").catch((error) => {
        if (error.response) {
          return error.response;
        }
        throw error;
      });
    },
    getInvoices(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          INVOICES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = INVOICES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === INVOICES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload?.filters) {
        for (const [key, value] of Object.entries(payload.filters)) {
          console.log(key);
          let kkey = "invoice_type";
          if (value === "deadline") {
            kkey = "payment_type";
          }
          if (pgurl === INVOICES) {
            if (value) {
              pgurl += "?" + kkey + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + kkey + "=" + value;
            }
          }
        }
      }

      pgurl += "&without_final=" + payload.final;

      if (payload?.ksefStatus) {
        pgurl += "&ksef_status=" + payload.ksefStatus;
      }

      if (payload?.ksefNumber) {
        pgurl += "&ksef_number=" + encodeURIComponent(payload.ksefNumber);
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addInvoicesData", response);
        })
        .catch((error) => {
          context.commit("addInvoicesData", error.response);
        });
    },
    getLegacyInvoices(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          LEGACY_INVOICES +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = LEGACY_INVOICES;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === LEGACY_INVOICES) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addInvoicesData", response);
        })
        .catch((error) => {
          context.commit("addInvoicesData", error.response);
        });
    },
    // Every invoice row carries its own type and each type has a dedicated
    // order endpoint - the same mapping orderSrvc.getInvoice does in the old
    // panel.
    getInvoicePdf(context, payload) {
      const invoiceTypes = [
        "proforma_invoice",
        "advance_invoice",
        "final_invoice",
        "vat_invoice",
      ];

      if (!payload.pk || !invoiceTypes.includes(payload.type)) {
        return;
      }

      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ORDERS + payload.pk + "/" + payload.type + "/", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let blob = new Blob([response.data], {
              type: "application/pdf",
            }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch();
    },
    invoiceExportCSV(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(
          INVOICES +
            "/" +
            payload.type +
            "/?date_month=" +
            payload.month +
            "&date_year=" +
            payload.year,
          { responseType: "arraybuffer" }
        )
        .then((response) => {
          let blob = new Blob([response.data], {
              type: "application/csv",
            }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .catch();
    },
    getTags(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(TAGS + "form_field_opts/")
        .then((response) => {
          context.commit("addTagsData", response);
        })
        .catch((error) => {
          context.commit("addTagsData", error.response);
        });
    },
    getApm(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(APM)
        .then((response) => {
          context.commit("addApmData", response);
        })
        .catch((error) => {
          context.commit("addApmData", error.response);
        });
    },
    createOrder(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .post(ORDERS + "admin_create/", payload)
        .then((response) => {
          context.commit("addCreateOrderData", response);
        })
        .catch((error) => {
          context.commit("addCreateOrderData", error.response);
        });
    },
    getAdminGP(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PRODUCTS + pk + "/admin_group_options/")
        .then((response) => {
          context.commit("addAdminGPData", response);
        })
        .catch((error) => {
          context.commit("addAdminGPData", error.response);
        });
    },
    getAdminQuantities(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PRODUCTS + pk + "/admin_quantities/")
        .then((response) => {
          context.commit("addAdminQuantitiesData", response);
        })
        .catch((error) => {
          context.commit("addAdminQuantitiesData", error.response);
        });
    },
    // Quantities are not part of the product update payload, so the product
    // form manages them through their own endpoints - the same as
    // productQuantityDataSrvc in the old panel.
    createQuantity(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.post(QUANTITIES, payload);
    },
    updateQuantity(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.patch(QUANTITIES + payload.pk + "/", payload);
    },
    // Product gallery images are saved right away through their own endpoint,
    // like productGalleryDataSrvc in the old panel.
    createProductGalleryImage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      const data = new FormData();
      data.append("product", payload.product);
      data.append("image", payload.image);

      return api.post(PRODUCT_GALLERY, data);
    },
    deleteProductGalleryImage(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.delete(PRODUCT_GALLERY + pk + "/");
    },
    deleteQuantity(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.delete(QUANTITIES + pk + "/");
    },
    // Allegro offer product picker - searched on the server by name and paged
    // through while scrolling, the way the old admin panel's ui-select does
    // it (data-on-search + cp-infinity-scroll). The caller decides whether the
    // returned page replaces the list or is appended to it.
    getAllProducts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const params = new URLSearchParams();
      if (payload?.page) {
        params.append("page", payload.page);
      }
      if (payload?.name) {
        params.append("name", payload.name);
      }

      const query = params.toString();

      return api.get(
        PRODUCTS + "admin_allegro_options_list/" + (query ? "?" + query : "")
      );
    },
    getProductOfferPricing(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.quantity_pk)
        params.append("quantity_pk", payload.quantity_pk);
      (payload.option_pk || []).forEach((pk) => params.append("option_pk", pk));

      api
        .get(PRODUCTS + payload.pk + "/admin_pricing/?" + params.toString())
        .then((response) => {
          context.commit("addProductOfferPricingData", response);
        })
        .catch((error) => {
          context.commit("addProductOfferPricingData", error.response);
        });
    },
    getProductOfferWeight(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.quantity_pk)
        params.append("quantity_pk", payload.quantity_pk);
      (payload.option_pk || []).forEach((pk) => params.append("option_pk", pk));

      api
        .get(PRODUCTS + payload.pk + "/admin_weight/?" + params.toString())
        .then((response) => {
          context.commit("addProductOfferWeightData", response);
        })
        .catch((error) => {
          context.commit("addProductOfferWeightData", error.response);
        });
    },
    getProductOfferDescription(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.quantity_pk)
        params.append("quantity_pk", payload.quantity_pk);
      (payload.option_pk || []).forEach((pk) => params.append("option_pk", pk));

      api
        .get(
          PRODUCTS +
            payload.pk +
            "/admin_description_for_offer/?" +
            params.toString()
        )
        .then((response) => {
          context.commit("addProductOfferDescriptionData", response);
        })
        .catch((error) => {
          context.commit("addProductOfferDescriptionData", error.response);
        });
    },
    getAllOffer(context, id) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_OFFERS + id)
        .then((response) => {
          context.commit("addAllOfferData", response);
        })
        .catch((error) => {
          context.commit("addAllOfferData", error.response);
        });
    },
    updateAllOffer(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(ALLEGRO_OFFERS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addUpdateAllOfferData", response);
        })
        .catch((error) => {
          context.commit("addUpdateAllOfferData", error.response);
        });
    },
    deleteAllOffer(context, id) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      // The trailing slash matters - without it the API answers with a 301 to
      // the canonical URL, which a preflighted cross origin DELETE does not
      // follow.
      api
        .delete(ALLEGRO_OFFERS + id + "/")
        .then((response) => {
          context.commit("addDeleteAllOfferData", response);
        })
        .catch((error) => {
          context.commit("addDeleteAllOfferData", error.response);
        });
    },
    createAllOffer(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(ALLEGRO_OFFERS, payload)
        .then((response) => {
          context.commit("addCreateAllOfferData", response);
        })
        .catch((error) => {
          context.commit("addCreateAllOfferData", error.response);
        });
    },
    getAllOffers(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          ALLEGRO_OFFERS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage;
      } else {
        pgurl = ALLEGRO_OFFERS;
      }

      if (payload.order_pk) {
        pgurl += "&order_pk=" + payload.order_pk;
      }
      if (payload.account_pk) {
        pgurl += "&account_pk=" + payload.account_pk;
      }
      if (payload.ordering) {
        pgurl += "&ordering=" + payload.ordering;
      }
      if (payload.search) {
        Object.entries(payload.search).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            pgurl += "&" + key + "=" + value;
          }
        });
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAllOffersData", response);
        })
        .catch((error) => {
          context.commit("addAllOffersData", error.response);
        });
    },
    getAllConf(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_CONF + pk)
        .then((response) => {
          context.commit("addAllConfDetailsData", response);
        })
        .catch((error) => {
          context.commit("addAllConfDetailsData", error.response);
        });
    },
    getAllegroAccounts(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const params = new URLSearchParams();
      if (payload.page) params.append("page", payload.page);
      if (payload.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      if (payload.ordering) params.append("ordering", payload.ordering);

      if (payload.search) {
        Object.entries(payload.search).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params.append(key, value);
          }
        });
      }

      const pgurl = params.toString()
        ? ALLEGRO_ACCOUNTS + "?" + params.toString()
        : ALLEGRO_ACCOUNTS;

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAllegroAccountsData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountsData", error.response);
        });
    },
    getAllegroAccount(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_ACCOUNTS + pk + "/")
        .then((response) => {
          context.commit("addAllegroAccountData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountData", error.response);
        });
    },
    createAllegroAccount(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(ALLEGRO_ACCOUNTS, payload)
        .then((response) => {
          context.commit("addAllegroAccountCreateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountCreateData", error.response);
        });
    },
    updateAllegroAccount(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .put(ALLEGRO_ACCOUNTS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addAllegroAccountUpdateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountUpdateData", error.response);
        });
    },
    deleteAllegroAccount(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(ALLEGRO_ACCOUNTS + pk + "/")
        .then((response) => {
          context.commit("addAllegroAccountDeleteData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountDeleteData", error.response);
        });
    },
    getAllegroAccountOauthData(context, accountPk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/oauth_data/")
        .then((response) => {
          context.commit("addAllegroAccountOauthData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountOauthData", error.response);
        });
    },
    getAllegroAccountSellerData(context, accountPk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/seller_data/")
        .then((response) => {
          context.commit("addAllegroAccountSellerData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountSellerData", error.response);
        });
    },
    getAllegroAccountSenderData(context, accountPk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/sender_data/")
        .then((response) => {
          context.commit("addAllegroAccountSenderData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountSenderData", error.response);
        });
    },
    getAllegroAccountCodReceiverData(context, accountPk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/cod_receiver_data/")
        .then((response) => {
          context.commit("addAllegroAccountCodReceiverData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountCodReceiverData", error.response);
        });
    },
    getAllegroAccountResponsibleProducerData(context, accountPk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/responsible_producer/")
        .then((response) => {
          context.commit("addAllegroAccountResponsibleProducerData", response);
        })
        .catch((error) => {
          context.commit(
            "addAllegroAccountResponsibleProducerData",
            error.response
          );
        });
    },
    getAllegroAccountSafetyInformationData(context, accountPk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_ACCOUNTS + accountPk + "/product_safety_information/")
        .then((response) => {
          context.commit("addAllegroAccountSafetyInformationData", response);
        })
        .catch((error) => {
          context.commit(
            "addAllegroAccountSafetyInformationData",
            error.response
          );
        });
    },
    getAllegroAccountOffers(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const accountPk = payload?.accountPk || payload;
      const params = new URLSearchParams();
      if (payload?.page) params.append("page", payload.page);
      if (payload?.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      if (payload?.ordering) params.append("ordering", payload.ordering);
      if (payload?.search) {
        Object.entries(payload.search).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params.append(key, value);
          }
        });
      }
      const url =
        ALLEGRO_ACCOUNTS +
        accountPk +
        "/offers/" +
        (params.toString() ? "?" + params.toString() : "");

      api
        .get(url)
        .then((response) => {
          context.commit("addAllegroAccountOffersData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountOffersData", error.response);
        });
    },
    getAllegroAccountThreads(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const accountPk = payload?.accountPk || payload;
      const params = new URLSearchParams();
      if (payload?.page) params.append("page", payload.page);
      if (payload?.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      if (payload?.ordering) params.append("ordering", payload.ordering);
      if (payload?.search) {
        Object.entries(payload.search).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            params.append(key, value);
          }
        });
      }
      const url =
        ALLEGRO_ACCOUNTS +
        accountPk +
        "/threads/" +
        (params.toString() ? "?" + params.toString() : "");

      api
        .get(url)
        .then((response) => {
          context.commit("addAllegroAccountThreadsData", response);
        })
        .catch((error) => {
          context.commit("addAllegroAccountThreadsData", error.response);
        });
    },
    createAllegroOauth(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(ALLEGRO_CONF, payload)
        .then((response) => {
          context.commit("addAllegroOauthCreateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroOauthCreateData", error.response);
        });
    },
    updateAllegroOauth(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .put(ALLEGRO_CONF + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addAllegroOauthUpdateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroOauthUpdateData", error.response);
        });
    },
    getAllegroOauthDeviceFlow(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .get(ALLEGRO_CONF + pk + "/device_flow/")
        .then((response) => {
          context.commit("addAllegroOauthUpdateData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addAllegroOauthUpdateData", error.response);
          return Promise.reject(error);
        });
    },
    // Connection status of an OAuth configuration - polled after the device
    // code is generated, until Allegro confirms the access.
    getAllegroOauthAuthInfo(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api.get(ALLEGRO_CONF + pk + "/auth_info/");
    },
    revokeAllegroOauthToken(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .get(ALLEGRO_CONF + pk + "/revoke_token/")
        .then((response) => {
          context.commit("addAllegroOauthUpdateData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addAllegroOauthUpdateData", error.response);
          return Promise.reject(error);
        });
    },
    getAllegroSellers(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const params = new URLSearchParams();
      if (payload.page) params.append("page", payload.page);
      if (payload.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      const pgurl = params.toString()
        ? ALLEGRO_SELLERS + "?" + params.toString()
        : ALLEGRO_SELLERS;

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAllegroSellersData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSellersData", error.response);
        });
    },
    getAllegroSeller(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_SELLERS + pk + "/")
        .then((response) => {
          context.commit("addAllegroSellerData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSellerData", error.response);
        });
    },
    createAllegroSeller(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      const data = new FormData();
      Object.keys(payload).forEach((key) => {
        if (payload[key] !== undefined && payload[key] !== null) {
          data.append(key, payload[key]);
        }
      });

      api
        .post(ALLEGRO_SELLERS, data)
        .then((response) => {
          context.commit("addAllegroSellerCreateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSellerCreateData", error.response);
        });
    },
    updateAllegroSeller(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      const data = new FormData();
      Object.keys(payload).forEach((key) => {
        if (payload[key] !== undefined && payload[key] !== null) {
          data.append(key, payload[key]);
        }
      });

      api
        .put(ALLEGRO_SELLERS + payload.pk + "/", data)
        .then((response) => {
          context.commit("addAllegroSellerUpdateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSellerUpdateData", error.response);
        });
    },
    getAllegroSenders(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.page) params.append("page", payload.page);
      if (payload.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      const pgurl = params.toString()
        ? ALLEGRO_SENDERS + "?" + params.toString()
        : ALLEGRO_SENDERS;

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAllegroSendersData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSendersData", error.response);
        });
    },
    getAllegroSender(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ALLEGRO_SENDERS + pk + "/")
        .then((response) => {
          context.commit("addAllegroSenderData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSenderData", error.response);
        });
    },
    createAllegroSender(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(ALLEGRO_SENDERS, payload)
        .then((response) => {
          context.commit("addAllegroSenderCreateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSenderCreateData", error.response);
        });
    },
    updateAllegroSender(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .put(ALLEGRO_SENDERS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addAllegroSenderUpdateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSenderUpdateData", error.response);
        });
    },
    getAllegroCodReceivers(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.page) params.append("page", payload.page);
      if (payload.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      const pgurl = params.toString()
        ? ALLEGRO_COD_RECEIVERS + "?" + params.toString()
        : ALLEGRO_COD_RECEIVERS;

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAllegroCodReceiversData", response);
        })
        .catch((error) => {
          context.commit("addAllegroCodReceiversData", error.response);
        });
    },
    getAllegroCodReceiver(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ALLEGRO_COD_RECEIVERS + pk + "/")
        .then((response) => {
          context.commit("addAllegroCodReceiverData", response);
        })
        .catch((error) => {
          context.commit("addAllegroCodReceiverData", error.response);
        });
    },
    createAllegroCodReceiver(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(ALLEGRO_COD_RECEIVERS, payload)
        .then((response) => {
          context.commit("addAllegroCodReceiverCreateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroCodReceiverCreateData", error.response);
        });
    },
    updateAllegroCodReceiver(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .put(ALLEGRO_COD_RECEIVERS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addAllegroCodReceiverUpdateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroCodReceiverUpdateData", error.response);
        });
    },
    getAllegroResponsibleProducers(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.page) params.append("page", payload.page);
      if (payload.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      const pgurl = params.toString()
        ? ALLEGRO_RESPONSIBLE_PRODUCERS + "?" + params.toString()
        : ALLEGRO_RESPONSIBLE_PRODUCERS;

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAllegroResponsibleProducersData", response);
        })
        .catch((error) => {
          context.commit("addAllegroResponsibleProducersData", error.response);
        });
    },
    getAllegroResponsibleProducer(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ALLEGRO_RESPONSIBLE_PRODUCERS + pk + "/")
        .then((response) => {
          context.commit("addAllegroResponsibleProducerData", response);
        })
        .catch((error) => {
          context.commit("addAllegroResponsibleProducerData", error.response);
        });
    },
    createAllegroResponsibleProducer(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(ALLEGRO_RESPONSIBLE_PRODUCERS, payload)
        .then((response) => {
          context.commit("addAllegroResponsibleProducerCreateData", response);
        })
        .catch((error) => {
          context.commit(
            "addAllegroResponsibleProducerCreateData",
            error.response
          );
        });
    },
    updateAllegroResponsibleProducer(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .put(ALLEGRO_RESPONSIBLE_PRODUCERS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addAllegroResponsibleProducerUpdateData", response);
        })
        .catch((error) => {
          context.commit(
            "addAllegroResponsibleProducerUpdateData",
            error.response
          );
        });
    },
    getAllegroSafetyInformations(context, payload = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const params = new URLSearchParams();
      if (payload.page) params.append("page", payload.page);
      if (payload.itemsPerPage)
        params.append("page_size", payload.itemsPerPage);
      const pgurl = params.toString()
        ? ALLEGRO_SAFETY_INFORMATIONS + "?" + params.toString()
        : ALLEGRO_SAFETY_INFORMATIONS;

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addAllegroSafetyInformationsData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSafetyInformationsData", error.response);
        });
    },
    getAllegroSafetyInformation(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ALLEGRO_SAFETY_INFORMATIONS + pk + "/")
        .then((response) => {
          context.commit("addAllegroSafetyInformationData", response);
        })
        .catch((error) => {
          context.commit("addAllegroSafetyInformationData", error.response);
        });
    },
    createAllegroSafetyInformation(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(ALLEGRO_SAFETY_INFORMATIONS, payload)
        .then((response) => {
          context.commit("addAllegroSafetyInformationCreateData", response);
        })
        .catch((error) => {
          context.commit(
            "addAllegroSafetyInformationCreateData",
            error.response
          );
        });
    },
    updateAllegroSafetyInformation(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .put(ALLEGRO_SAFETY_INFORMATIONS + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addAllegroSafetyInformationUpdateData", response);
        })
        .catch((error) => {
          context.commit(
            "addAllegroSafetyInformationUpdateData",
            error.response
          );
        });
    },
    getClientAllegroThreads(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ALLEGRO_THREADS + "?client_pk=" + payload.client_pk)
        .then((response) => {
          context.commit("addClientAllegroThreadsData", response);
        })
        .catch((error) => {
          context.commit("addClientAllegroThreadsData", error.response);
        });
    },
    getAllegroThread(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(ALLEGRO_THREADS + pk + "/")
        .then((response) => {
          context.commit("addAllegroThreadData", response);
        })
        .catch((error) => {
          context.commit("addAllegroThreadData", error.response);
        });
    },
    createAllegroThreadMessage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };
      const data = new FormData();
      if (payload.text) {
        data.append("text", payload.text);
      }
      if (payload.upload_files?.length) {
        payload.upload_files.forEach((file) => {
          data.append("upload_files", file);
        });
      } else if (payload.file) {
        data.append("upload_files", payload.file);
      }

      api
        .post(ALLEGRO_THREADS + payload.pk + "/create_message/", data)
        .then((response) => {
          context.commit("addAllegroThreadMessageCreateData", response);
        })
        .catch((error) => {
          context.commit("addAllegroThreadMessageCreateData", error.response);
        });
    },
    createAllegroOfferModificationCommand(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .post(ALLEGRO_OFFERS + "create_modification_command/", payload)
        .then((response) => {
          context.commit("addAllegroOfferModificationCommandData", response);
          return response;
        })
        .catch((error) => {
          context.commit(
            "addAllegroOfferModificationCommandData",
            error.response
          );
          return Promise.reject(error);
        });
    },
    createAllegroOfferPriceChangeCommand(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .post(ALLEGRO_OFFERS + "create_price_change_command/", payload)
        .then((response) => {
          context.commit("addAllegroOfferPriceChangeCommandData", response);
          return response;
        })
        .catch((error) => {
          context.commit(
            "addAllegroOfferPriceChangeCommandData",
            error.response
          );
          return Promise.reject(error);
        });
    },
    paymentsImport(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
        "Content-Type": "multipart/form-data",
      };

      api
        .post(ORDERS + "admin_payments_import/", payload)
        .then((response) => {
          context.commit("addPaymentsImportData", response);
        })
        .catch((error) => {
          context.commit("addPaymentsImportData", error.response);
        });
    },
    getOrderLogs(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          ORDER_LOGS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage;
      } else {
        pgurl = ORDER_LOGS;
      }

      if (payload.order_pk) {
        pgurl += "&order_pk=" + payload.order_pk;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addOrderLogsData", response);
        })
        .catch((error) => {
          context.commit("addOrderLogsData", error.response);
        });
    },
    getProcessStages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PROCESS_STAGES + "admin_for_process/?process_pk=" + payload.pk)
        .then((response) => {
          context.commit("addProcessStagesData", response);
        })
        .catch((error) => {
          context.commit("addProcessStagesData", error.response);
        });
    },
    getEditProcessStages(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(PROCESS_STAGES + pk)
        .then((response) => {
          context.commit("addEditProcessStagesData", response);
        })
        .catch((error) => {
          context.commit("addEditProcessStagesData", error.response);
        });
    },
    updateProcessStages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      let preconditions = [];
      var data = new FormData();
      data.append("machine", payload.machine);
      data.append("machine_action", payload.machine_action);
      data.append("description_pl", payload.description_pl);
      data.append("description_en", payload.description_en);
      data.append("description_de", payload.description_de);
      data.append("description_cpde", payload.description_cpde);
      data.append("description_cpen", payload.description_cpen);
      data.append("time", payload.time);
      data.append("process", payload.process);
      data.append("pk", payload.pk);
      Object.keys(payload.preconditions).forEach((e) => {
        preconditions.push(payload.preconditions[e]);
      });
      data.append(`preconditions`, JSON.stringify(preconditions));

      api
        .patch(PROCESS_STAGES + payload.pk + "/", data)
        .then((response) => {
          context.commit("addUpdateProcessStagesData", response);
        })
        .catch((error) => {
          context.commit("addUpdateProcessStagesData", error.response);
        });
    },
    createProcessStages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      let preconditions = [];
      var data = new FormData();
      data.append("machine", payload.machine);
      data.append("machine_action", payload.machine_action);
      data.append("description_pl", payload.description_pl);
      data.append("description_en", payload.description_en);
      data.append("description_de", payload.description_de);
      data.append("description_cpde", payload.description_cpde);
      data.append("description_cpen", payload.description_cpen);
      data.append("time", payload.time);
      data.append("process", payload.process);
      Object.keys(payload.preconditions).forEach((e) => {
        preconditions.push(payload.preconditions[e]);
      });
      data.append(`preconditions`, JSON.stringify(preconditions));

      api
        .post(PROCESS_STAGES, data)
        .then((response) => {
          context.commit("addCreateProcessStagesData", response);
        })
        .catch((error) => {
          context.commit("addCreateProcessStagesData", error.response);
        });
    },
    reorderProcessStage(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const data = new FormData();
      data.append("position", payload.position);
      return api.patch(PROCESS_STAGES + payload.pk + "/", data);
    },
    deleteProcessStages(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(PROCESS_STAGES + payload.pk + "/")
        .then((response) => {
          context.commit("addDeleteProcessStagesData", response);
        })
        .catch((error) => {
          context.commit("addDeleteProcessStagesData", error.response);
        });
    },
    getMontageStats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          MONTAGE_STATS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = MONTAGE_STATS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === MONTAGE_STATS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addMontageStatsData", response);
        })
        .catch((error) => {
          context.commit("addMontageStatsData", error.response);
        });
    },
    getProductionStats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          PRODUCTION_STATS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PRODUCTION_STATS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PRODUCTION_STATS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addProductionStatsData", response);
        })
        .catch((error) => {
          context.commit("addProductionStatsData", error.response);
        });
    },
    getSystemLogs(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      var pgurl;
      if (payload?.page) {
        pgurl =
          SYSTEM_LOGS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = SYSTEM_LOGS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === SYSTEM_LOGS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          payload.date[0] = new Date(payload.date[0]);
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          payload.date[1] = new Date(payload.date[1]);
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      if (dateMin && dateMax) {
        pgurl += "&date_added__gte=" + dateMin;
        pgurl += "&date_added__lte=" + dateMax;
      }

      api
        .get(pgurl)
        .then((response) => {
          context.commit("addSystemLogsData", response);
        })
        .catch((error) => {
          context.commit("addSystemLogsData", error.response);
        });
    },
    getProductsStats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      var pgurl;
      if (payload?.page) {
        pgurl =
          PRODUCTS_STATS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = PRODUCTS_STATS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === PRODUCTS_STATS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload.date) {
        pgurl += "&max_date=" + dateMax;
        pgurl += "&min_date=" + dateMin;
      }
      if (payload.shop_version) {
        pgurl += "&shop_version=" + payload.shop_version;
      }

      api
        .get(pgurl)
        .then((response) => {
          response.comp = payload.comp;
          context.commit("addProductsStatsData", response);
        })
        .catch((error) => {
          context.commit("addProductsStatsData", error.response);
        });
    },
    getClientStats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      var pgurl;
      if (payload?.page) {
        pgurl =
          CLIENT_STATS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = CLIENT_STATS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === CLIENT_STATS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload.date) {
        pgurl += "&max_date=" + dateMax;
        pgurl += "&min_date=" + dateMin;
      }
      if (payload.shop_version) {
        pgurl += "&shop_version=" + payload.shop_version;
      }

      api
        .get(pgurl)
        .then((response) => {
          response.comp = payload.comp;
          context.commit("addClientStatsData", response);
        })
        .catch((error) => {
          context.commit("addClientStatsData", error.response);
        });
    },
    getSalesStats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      var pgurl;
      if (payload?.page) {
        pgurl =
          SALES_STATS +
          "?page=" +
          payload.page +
          "&page_size=" +
          payload.itemsPerPage +
          "&ordering=" +
          payload.ordering;
      } else {
        pgurl = SALES_STATS;
      }

      if (payload?.search) {
        for (const [key, value] of Object.entries(payload.search)) {
          if (pgurl === SALES_STATS) {
            if (value) {
              pgurl += "?" + key + "=" + value;
            }
          } else {
            if (value) {
              pgurl += "&" + key + "=" + value;
            }
          }
        }
      }

      if (payload.date) {
        pgurl += "&max_date=" + dateMax;
        pgurl += "&min_date=" + dateMin;
      }
      if (payload.shop_version) {
        pgurl += "&shop_version=" + payload.shop_version;
      }
      if (payload.group_by_date) {
        pgurl += "&group_by_date=" + payload.group_by_date;
      }

      api
        .get(pgurl)
        .then((response) => {
          response.comp = payload.comp;
          context.commit("addSaleStatsData", response);
        })
        .catch((error) => {
          context.commit("addSaleStatsData", error.response);
        });
    },
    getPackageStats(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let day, month, year, dayEnd, monthEnd, yearEnd, dateMax, dateMin;
      if (payload?.date) {
        if (payload.date[0]) {
          day = payload.date[0].getDate();
          month = payload.date[0].getMonth() + 1;
          year = payload.date[0].getFullYear();

          dateMin = `${day}.${month}.${year}`;
        }

        if (payload.date[1]) {
          dayEnd = payload.date[1].getDate();
          monthEnd = payload.date[1].getMonth() + 1;
          yearEnd = payload.date[1].getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
        }
      }

      var pgurl = PACKAGE_STATS;
      if (payload.date) {
        pgurl += "?max_date=" + dateMax;
        pgurl += "&min_date=" + dateMin;
      }
      if (payload.shop_version) {
        pgurl += "&shop_version=" + payload.shop_version;
      }

      api
        .get(pgurl)
        .then((response) => {
          response.comp = payload.comp;
          context.commit("addPackageStatsData", response);
        })
        .catch((error) => {
          context.commit("addPackageStatsData", error.response);
        });
    },
    getSalesGroups(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(SALES_STATS + "group_by_dates_options/")
        .then((response) => {
          context.commit("addSalesGroupsData", response);
        })
        .catch((error) => {
          context.commit("addSalesGroupsData", error.response);
        });
    },
    getAdminChsenOptions(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(ORDER_PRODUCTS + pk + "/admin_get_chosen_options/")
        .then((response) => {
          context.commit("addChosenOptionsData", response);
        })
        .catch((error) => {
          context.commit("addChosenOptionsData", error.response);
        });
    },
    updatePriceDetail(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      // Resolves with every option price of the product, the way
      // productOptionPricesDataSrvc.priceDetail does in the old panel.
      return api
        .put(POP + "price_detail/", payload)
        .then((response) => {
          context.commit("addUpdatePriceDetailData", response);
          return response;
        })
        .catch((error) => {
          context.commit("addUpdatePriceDetailData", error.response);
          throw error;
        });
    },
    getNote(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      return api
        .get(NOTES + pk + "/")
        .then((response) => {
          context.commit("addNoteDetailData", response);
        })
        .catch((error) => {
          context.commit("addNoteDetailData", error.response);
        });
    },
    getOrderNotes(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      let queryParams = new URLSearchParams();
      queryParams.append("content_type", payload.content_type);
      queryParams.append("object_id", payload.object_id);
      queryParams.append("page_size", payload.page_size ?? 100);

      return api
        .get(NOTES + "?" + queryParams.toString())
        .then((response) => {
          context.commit("addOrderNotesData", response);
        })
        .catch((error) => {
          context.commit("addOrderNotesData", error.response);
        });
    },
    addOrderNote(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(NOTES, payload)
        .then((response) => {
          context.commit("addNotesData", response);
        })
        .catch((error) => {
          context.commit("addNotesData", error.response);
        });
    },
    updateOrderNote(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .patch(NOTES + payload.pk + "/", payload)
        .then((response) => {
          context.commit("addNotesData", response);
        })
        .catch((error) => {
          context.commit("addNotesData", error.response);
        });
    },
    delOrderNote(context, pk) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .delete(NOTES + pk + "/")
        .then((response) => {
          response.type = "delete";
          context.commit("addNotesData", response);
        })
        .catch((error) => {
          context.commit("addNotesData", error.response);
        });
    },
    getCeidgData(context, nip) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(CEL + "?identifier=" + nip)
        .then((response) => {
          context.commit("addCeidgData", response);
        })
        .catch((error) => {
          context.commit("addCeidgData", error.response);
        });
    },
    getUnits(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .get(UNITS)
        .then((response) => {
          context.commit("addUnitsData", response);
        })
        .catch((error) => {
          context.commit("addUnitsData", error.response);
        });
    },
    createUnit(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      api
        .post(UNITS, payload)
        .then((response) => {
          context.commit("addCreateUnitData", response);
        })
        .catch((error) => {
          context.commit("addCreateUnitData", error.response);
        });
    },
    deleteUnit(context, unitId) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(`${UNITS}${unitId}/`)
        .then((response) => {
          context.commit("addDeleteUnitData", response);
        })
        .catch((error) => {
          context.commit("addDeleteUnitData", error.response);
        });
    },
    getTrackingTags(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(TRACKING_TAGS, { params: payload })
        .then((response) => {
          context.commit("addTrackingTagsData", response);
        })
        .catch((error) => {
          context.commit("addTrackingTagsData", error.response);
        });
    },
    getTrackingTag(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(`${TRACKING_TAGS}${payload.pk}/`)
        .then((response) => {
          context.commit("addTrackingTagData", response);
        })
        .catch((error) => {
          context.commit("addTrackingTagData", error.response);
        });
    },
    createTrackingTag(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(TRACKING_TAGS, payload)
        .then((response) => {
          context.commit("addCreateTrackingTagData", response);
        })
        .catch((error) => {
          context.commit("addCreateTrackingTagData", error.response);
        });
    },
    updateTrackingTag(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .put(`${TRACKING_TAGS}${payload.pk}/`, payload)
        .then((response) => {
          context.commit("addUpdateTrackingTagData", response);
        })
        .catch((error) => {
          context.commit("addUpdateTrackingTagData", error.response);
        });
    },
    deleteTrackingTag(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(`${TRACKING_TAGS}${payload.pk}/`)
        .then((response) => {
          context.commit("addDeleteTrackingTagData", response);
        })
        .catch((error) => {
          context.commit("addDeleteTrackingTagData", error.response);
        });
    },
    getTrackingTagsTypeOpts(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(TRACKING_TAGS_TYPE_OPTS)
        .then((response) => {
          context.commit("addTrackingTagsTypeOpts", response);
        })
        .catch((error) => {
          context.commit("addTrackingTagsTypeOpts", error.response);
        });
    },
    getTrackingTagsLocationOpts(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(TRACKING_TAGS_LOCATION_OPTS)
        .then((response) => {
          context.commit("addTrackingTagsLocationOpts", response);
        })
        .catch((error) => {
          context.commit("addTrackingTagsLocationOpts", error.response);
        });
    },
    getKsefCompanies(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(KSEF_COMPANIES, { params: payload })
        .then((response) => {
          context.commit("addKsefCompaniesData", response);
        })
        .catch((error) => {
          context.commit("addKsefCompaniesData", error.response);
        });
    },
    getKsefCompany(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(`${KSEF_COMPANIES}${payload.pk}/`)
        .then((response) => {
          context.commit("addKsefCompanyData", response);
        })
        .catch((error) => {
          context.commit("addKsefCompanyData", error.response);
        });
    },
    createKsefCompany(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(KSEF_COMPANIES, payload)
        .then((response) => {
          context.commit("addCreateKsefCompanyData", response);
        })
        .catch((error) => {
          context.commit("addCreateKsefCompanyData", error.response);
        });
    },
    updateKsefCompany(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .patch(`${KSEF_COMPANIES}${payload.pk}/`, {
          name: payload.name,
          nip: payload.nip,
        })
        .then((response) => {
          context.commit("addUpdateKsefCompanyData", response);
        })
        .catch((error) => {
          context.commit("addUpdateKsefCompanyData", error.response);
        });
    },
    activateKsefConnection(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .post(`${KSEF_COMPANIES}${payload.pk}/activate_connection/`)
        .then((response) => {
          context.commit("addActivateKsefConnectionData", response);
        })
        .catch((error) => {
          context.commit("addActivateKsefConnectionData", error.response);
        });
    },
    getKsefCompanyCerts(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      const { pk, ...params } = payload;
      api
        .get(`${KSEF_COMPANIES}${pk}/certificates/`, { params: params })
        .then((response) => {
          context.commit("addKsefCompanyCertsData", response);
        })
        .catch((error) => {
          context.commit("addKsefCompanyCertsData", error.response);
        });
    },
    createKsefCertificate(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const formData = new FormData();
      Object.keys(payload).forEach((key) => {
        const value = payload[key];
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      api
        .post(KSEF_CERTIFICATES, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          context.commit("addCreateKsefCertificateData", response);
        })
        .catch((error) => {
          context.commit("addCreateKsefCertificateData", error.response);
        });
    },
    deleteKsefCertificate(context, payload) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .delete(`${KSEF_CERTIFICATES}${payload.pk}/`)
        .then((response) => {
          context.commit("addDeleteKsefCertificateData", response);
        })
        .catch((error) => {
          context.commit("addDeleteKsefCertificateData", error.response);
        });
    },
    getKsefInvoiceStatusOpts(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(KSEF_INVOICES_STATUS_OPTS)
        .then((response) => {
          context.commit("addKsefInvoiceStatusOpts", response);
        })
        .catch((error) => {
          context.commit("addKsefInvoiceStatusOpts", error.response);
        });
    },
    getKsefUnsentInvoicesCount(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(KSEF_INVOICES_UNSENT_COUNT)
        .then((response) => {
          context.commit("addKsefUnsentInvoicesData", response);
        })
        .catch((error) => {
          context.commit("addKsefUnsentInvoicesData", error.response);
        });
    },
    getMachineCostTypeOpts(context) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };
      api
        .get(MACHINE_COST_TYPE_OPTS)
        .then((response) => {
          context.commit("addMachineCostTypeOpts", response);
        })
        .catch((error) => {
          context.commit("addMachineCostTypeOpts", error.response);
        });
    },
    getOrdersListSummary(context, params = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      // Przygotuj query string z parametrami
      const queryParams = new URLSearchParams();

      if (params.ordering) {
        queryParams.append("ordering", params.ordering);
      }

      if (params.search && Object.keys(params.search).length > 0) {
        Object.keys(params.search).forEach((key) => {
          if (params.search[key]) {
            queryParams.append(key, params.search[key]);
          }
        });
      }

      if (params.date && params.date.length > 0) {
        let day, month, year, dayEnd, monthEnd, yearEnd, dateMin, dateMax;

        if (params.date[0]) {
          const date = new Date(params.date[0]);
          day = date.getDate();
          month = date.getMonth() + 1;
          year = date.getFullYear();
          dateMin = `${day}.${month}.${year}`;
          queryParams.append("date_added__gte", dateMin);
        }

        if (params.date[1]) {
          const date = new Date(params.date[1]);
          dayEnd = date.getDate();
          monthEnd = date.getMonth() + 1;
          yearEnd = date.getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
          queryParams.append("date_added__lte", dateMax);
        }
      }

      if (params.filters) {
        Object.keys(params.filters).forEach((key) => {
          const rawValue = params.filters[key];
          if (rawValue === undefined || rawValue === null || rawValue === "") {
            return;
          }

          const values = Array.isArray(rawValue) ? rawValue : [rawValue];
          values
            .map((value) =>
              typeof value === "object" && value !== null ? value.value : value
            )
            .filter(
              (value) => value !== undefined && value !== null && value !== ""
            )
            .forEach((value) => {
              queryParams.append(key, value);
            });
        });
      }

      if (params.notes_text) {
        queryParams.append("notes_text", params.notes_text);
      }

      const url =
        ORDERS_LIST_SUMMARY +
        (queryParams.toString() ? `?${queryParams.toString()}` : "");

      api
        .get(url)
        .then((response) => {
          context.commit("addOrdersListSummary", response);
        })
        .catch((error) => {
          context.commit("addOrdersListSummary", error.response);
        });
    },
    getMontagesListSummary(context, params = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const queryParams = new URLSearchParams();
      queryParams.append("is_archive", params.is_archive);

      if (params.ordering) {
        queryParams.append("ordering", params.ordering);
      }

      if (params.search && Object.keys(params.search).length > 0) {
        Object.keys(params.search).forEach((key) => {
          if (params.search[key]) {
            queryParams.append(key, params.search[key]);
          }
        });
      }

      if (params.date && params.date.length > 0) {
        let day, month, year, dayEnd, monthEnd, yearEnd, dateMin, dateMax;

        if (params.date[0]) {
          const date = new Date(params.date[0]);
          day = date.getDate();
          month = date.getMonth() + 1;
          year = date.getFullYear();
          dateMin = `${day}.${month}.${year}`;
          queryParams.append("date_added__gte", dateMin);
        }

        if (params.date[1]) {
          const date = new Date(params.date[1]);
          dayEnd = date.getDate();
          monthEnd = date.getMonth() + 1;
          yearEnd = date.getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
          queryParams.append("date_added__lte", dateMax);
        }
      }

      if (params.filters) {
        Object.keys(params.filters).forEach((key) => {
          if (params.filters[key] && params.filters[key].length > 0) {
            if (Array.isArray(params.filters[key])) {
              params.filters[key].forEach((value) => {
                queryParams.append(key, value.value || value);
              });
            } else {
              queryParams.append(key, params.filters[key]);
            }
          }
        });
      }

      const url =
        MONTAGES_LIST_SUMMARY +
        (queryParams.toString() ? `?${queryParams.toString()}` : "");

      api
        .get(url)
        .then((response) => {
          context.commit("addMontagesListSummary", response);
        })
        .catch((error) => {
          context.commit("addMontagesListSummary", error.response);
        });
    },
    getMontagesListSummaryClosed(context, params = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const queryParams = new URLSearchParams();
      queryParams.append("is_archive", params.is_archive);

      if (params.ordering) {
        queryParams.append("ordering", params.ordering);
      }

      if (params.search && Object.keys(params.search).length > 0) {
        Object.keys(params.search).forEach((key) => {
          if (params.search[key]) {
            queryParams.append(key, params.search[key]);
          }
        });
      }

      if (params.date && params.date.length > 0) {
        let day, month, year, dayEnd, monthEnd, yearEnd, dateMin, dateMax;

        if (params.date[0]) {
          const date = new Date(params.date[0]);
          day = date.getDate();
          month = date.getMonth() + 1;
          year = date.getFullYear();
          dateMin = `${day}.${month}.${year}`;
          queryParams.append("date_added__gte", dateMin);
        }

        if (params.date[1]) {
          const date = new Date(params.date[1]);
          dayEnd = date.getDate();
          monthEnd = date.getMonth() + 1;
          yearEnd = date.getFullYear();
          dateMax = `${dayEnd}.${monthEnd}.${yearEnd}`;
          queryParams.append("date_added__lte", dateMax);
        }
      }

      if (params.filters) {
        Object.keys(params.filters).forEach((key) => {
          if (params.filters[key] && params.filters[key].length > 0) {
            if (Array.isArray(params.filters[key])) {
              params.filters[key].forEach((value) => {
                queryParams.append(key, value.value || value);
              });
            } else {
              queryParams.append(key, params.filters[key]);
            }
          }
        });
      }

      const url =
        MONTAGES_LIST_SUMMARY_CLOSED +
        (queryParams.toString() ? `?${queryParams.toString()}` : "");

      api
        .get(url)
        .then((response) => {
          context.commit("addMontagesListSummaryClosed", response);
        })
        .catch((error) => {
          context.commit("addMontagesListSummaryClosed", error.response);
        });
    },
    getOrderProductsAdminRealized(context, params = {}) {
      api.defaults.headers = {
        Authorization: "Token " + cookies.get("CPsession"),
      };

      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page);
      if (params.page_size) queryParams.append("page_size", params.page_size);
      if (params.ordering) queryParams.append("ordering", params.ordering);
      if (params.pk) queryParams.append("pk", params.pk);
      if (params.order_pk) queryParams.append("order_pk", params.order_pk);
      if (params.product_pk)
        queryParams.append("product_pk", params.product_pk);
      if (params.product_name)
        queryParams.append("product_name", params.product_name);
      if (params.client_email)
        queryParams.append("client_email", params.client_email);
      if (params.weight_gte)
        queryParams.append("weight_gte", params.weight_gte);
      if (params.weight_lte)
        queryParams.append("weight_lte", params.weight_lte);
      if (params.net_price_gte)
        queryParams.append("net_price_gte", params.net_price_gte);
      if (params.net_price_lte)
        queryParams.append("net_price_lte", params.net_price_lte);
      if (params.gross_price_gte)
        queryParams.append("gross_price_gte", params.gross_price_gte);
      if (params.gross_price_lte)
        queryParams.append("gross_price_lte", params.gross_price_lte);
      if (params.display_quantity_gte)
        queryParams.append("display_quantity_gte", params.display_quantity_gte);
      if (params.display_quantity_lte)
        queryParams.append("display_quantity_lte", params.display_quantity_lte);
      if (params.discount_group_name)
        queryParams.append("discount_group_name", params.discount_group_name);
      if (params.realization_date_gte)
        queryParams.append("realization_date_gte", params.realization_date_gte);
      if (params.realization_date_lte)
        queryParams.append("realization_date_lte", params.realization_date_lte);

      const url = ORDER_PRODUCTS_ADMIN_REALIZED + "?" + queryParams.toString();
      api
        .get(url)
        .then((response) => {
          context.commit("addOrderProductsAdminRealizedData", response);
        })
        .catch((error) => {
          context.commit("addOrderProductsAdminRealizedData", error.response);
        });
    },
  },
  getters: {
    getTurnoverDiscountSettings(state) {
      return state.turnoverDiscountSettingsData;
    },
    getTurnoverDiscountSettingsSave(state) {
      return state.turnoverDiscountSettingsSaveData;
    },
    getTurnoverDiscountSummary(state) {
      return state.turnoverDiscountSummaryData;
    },
    getLoginData(state) {
      return state.loginData;
    },
    getAdminsData(state) {
      return state.adminsData;
    },
    getOnlineAdminsData(state) {
      return state.onlineAdminsData;
    },
    getAdminBarcodeData(state) {
      return state.adminsBarcodeData;
    },
    getAdminData(state) {
      return state.adminData;
    },
    getMachinesData(state) {
      return state.machinesData;
    },
    getCompetenciesData(state) {
      return state.competenciesData;
    },
    getPermissionsGroupData(state) {
      return state.permissionsGroupData;
    },
    getPermissionsGroupsData(state) {
      return state.permissionsGroupsData;
    },
    getPermissionsData(state) {
      return state.permissionsData;
    },
    getCreateAdminData(state) {
      return state.createAdminData;
    },
    getAdminEditData(state) {
      return state.adminEditData;
    },
    getCollectionPointsData(state) {
      return state.collectionPointsData;
    },
    getAdminGroupEditData(state) {
      return state.adminGroupEditData;
    },
    getAdminEditionData(state) {
      return state.adminEditionData;
    },
    getAdminDeleteData(state) {
      return state.deleteAdminData;
    },
    getAdminLogsData(state) {
      return state.adminLogsData;
    },
    getDeletePermissionsGroupData(state) {
      return state.deletePermissionsGroupData;
    },
    getCreatePermissionsGroupData(state) {
      return state.createPermissionsGroupData;
    },
    getUpdatePermissionsGroupData(state) {
      return state.updatePermissionsGroupData;
    },
    getDeleteCompetenceData(state) {
      return state.deleteCompetenceData;
    },
    getCreateCompetenceData(state) {
      return state.createCompetenceData;
    },
    getCompetenceData(state) {
      return state.competenceData;
    },
    getUpdateCompetenceData(state) {
      return state.updateCompetenceData;
    },
    getIpsData(state) {
      return state.ipsData;
    },
    getIpData(state) {
      return state.ipData;
    },
    getCreateIpData(state) {
      return state.createIpData;
    },
    getDeleteIpData(state) {
      return state.deleteIpData;
    },
    getUpdateIpData(state) {
      return state.updateIpData;
    },
    getSettingsData(state) {
      return state.settingsData;
    },
    getSettingData(state) {
      return state.settingData;
    },
    getCreateSettingData(state) {
      return state.createSettingData;
    },
    getDeleteSettingData(state) {
      return state.deleteSettingData;
    },
    getUpdateSettingData(state) {
      return state.updateSettingData;
    },
    getHolidaysData(state) {
      return state.holidaysData;
    },
    getCreateHolidaysData(state) {
      return state.createHolidaysData;
    },
    getDeleteHolidaysData(state) {
      return state.deleteHolidaysData;
    },
    getPackagesData(state) {
      return state.packagesData;
    },
    getPackageData(state) {
      return state.packageData;
    },
    getUpdatePackagesData(state) {
      return state.updatePackagesData;
    },
    getCreatePackagesData(state) {
      return state.createPackagesData;
    },
    getDeletePackagesData(state) {
      return state.deletePackagesData;
    },
    getProcessesData(state) {
      return state.processesData;
    },
    getCreateProcessesData(state) {
      return state.createProcessesData;
    },
    getDeleteProcessesData(state) {
      return state.deleteProcessesData;
    },
    getUpdateProcessesData(state) {
      return state.updateProcessesData;
    },
    getProcessData(state) {
      return state.processData;
    },
    getPlatesData(state) {
      return state.platesData;
    },
    getPlateData(state) {
      return state.plateData;
    },
    getUpdatePlatesData(state) {
      return state.updatePlatesData;
    },
    getCreatePlatesData(state) {
      return state.createPlatesData;
    },
    getDeletePlatesData(state) {
      return state.deletePlatesData;
    },
    getVariablesData(state) {
      return state.variablesData;
    },
    getVariableData(state) {
      return state.variableData;
    },
    getCreateVariablesData(state) {
      return state.createVariablesData;
    },
    getUpdateVariablesData(state) {
      return state.updateVariablesData;
    },
    getDeleteVariablesData(state) {
      return state.deleteVariablesData;
    },
    getAllCostsData(state) {
      return state.costsData;
    },
    getCostData(state) {
      return state.costData;
    },
    getAllCostsCreateData(state) {
      return state.createCostsData;
    },
    getAllCostsUpdateData(state) {
      return state.updateCostsData;
    },
    getAllCostsDeleteData(state) {
      return state.deleteCostsData;
    },
    getAllCostsSummaryData(state) {
      return state.costsSummaryData;
    },
    getPeriodUnitOptsData(state) {
      return state.periodUnitOptsData;
    },
    getProdlogsData(state) {
      return state.prodlogsData;
    },
    getNewsListData(state) {
      return state.newsListData;
    },
    getNewsData(state) {
      return state.newsData;
    },
    getCreateNewsData(state) {
      return state.createNewsData;
    },
    getUpdateNewsData(state) {
      return state.updateNewsData;
    },
    getDeleteNewsData(state) {
      return state.deleteNewsData;
    },
    getDeleteMontageData(state) {
      return state.deleteMontagesData;
    },
    getBannersData(state) {
      return state.bannersData;
    },
    getBannerData(state) {
      return state.bannerData;
    },
    getCreateBannersData(state) {
      return state.createBannersData;
    },
    getUpdateBannersData(state) {
      return state.updateBannersData;
    },
    getDeleteBannersData(state) {
      return state.deleteBannersData;
    },
    getPageBannersData(state) {
      return state.pageBannersData;
    },
    getProductPagesData(state) {
      return state.productPagesData;
    },
    getAdminsPGsData(state) {
      return state.adminsPGsData;
    },
    getCreateMachinesData(state) {
      return state.createMachinesData;
    },
    getDeleteMachinesData(state) {
      return state.deleteMachinesData;
    },
    getUpdateMachinesData(state) {
      return state.updateMachinesData;
    },
    getMachineData(state) {
      return state.machineData;
    },
    getLogStatusesData(state) {
      return state.statusesData;
    },
    getProdLogsSummaryData(state) {
      return state.prodLogsSummaryData;
    },
    getPagesData(state) {
      return state.pagesData;
    },
    getPageData(state) {
      return state.pageData;
    },
    getPageTypesData(state) {
      return state.pageTypesData;
    },
    getFaqsData(state) {
      return state.faqsData;
    },
    getDeleteFaqData(state) {
      return state.deleteFaqData;
    },
    getCreateFaqData(state) {
      return state.createFaqData;
    },
    getFaqData(state) {
      return state.faqData;
    },
    getUpdateFaqData(state) {
      return state.updateFaqData;
    },
    getTranslationsData(state) {
      return state.translationsData;
    },
    getUpdateTranslationsData(state) {
      return state.updateTranslationsData;
    },
    getTranslationsModelsData(state) {
      return state.translationsModelsData;
    },
    getUpdateTranslationsModelsData(state) {
      return state.updateTranslationsModelsData;
    },
    getI18nTranslationsData(state) {
      return state.i18nTranslationsData;
    },
    getI18nCreateTranslationData(state) {
      return state.i18nCreateTranslationData;
    },
    getI18nUpdateTranslationData(state) {
      return state.i18nUpdateTranslationData;
    },
    getI18nDeleteTranslationData(state) {
      return state.i18nDeleteTranslationData;
    },
    getI18nTranslationsMetaData(state) {
      return state.i18nTranslationsMetaData;
    },
    getFilesData(state) {
      return state.filesData;
    },
    getFileData(state) {
      return state.fileData;
    },
    getCreateFilesData(state) {
      return state.createFilesData;
    },
    getDeleteFilesData(state) {
      return state.deleteFilesData;
    },
    getUpdateFilesData(state) {
      return state.updateFilesData;
    },
    getImportTMData(state) {
      return state.importTMData;
    },
    getCategoriesData(state) {
      return state.categoriesData;
    },
    getCategoriesAdminProductData(state) {
      return state.categoriesAdminProductData;
    },
    getCategoryData(state) {
      return state.categoryData;
    },
    getUpdateCategoriesData(state) {
      return state.updateCategoriesData;
    },
    getCreateCategoriesData(state) {
      return state.createCategoriesData;
    },
    getDeleteCategoriesData(state) {
      return state.deleteCategoriesData;
    },
    getCategoryParentsData(state) {
      return state.categoryParentsData;
    },
    getPageLayoutsData(state) {
      return state.pageLayoutsData;
    },
    getPageMenuData(state) {
      return state.pageMenuData;
    },
    getCreatePagesData(state) {
      return state.createPagesData;
    },
    getDeletePagesData(state) {
      return state.deletePagesData;
    },
    getUpdatePagesData(state) {
      return state.updatePagesData;
    },
    getProductsData(state) {
      return state.productsData;
    },
    getCreateProductsData(state) {
      return state.createProductsData;
    },
    getUpdateProductsData(state) {
      return state.updateProductsData;
    },
    getProductMaterialsData(state) {
      return state.productMaterialsData;
    },
    getProductOptionsData(state) {
      return state.productOptionsData;
    },
    getProductFormatsData(state) {
      return state.productFormatsData;
    },
    getAppliancesData(state) {
      return state.appliancesData;
    },
    getParametersData(state) {
      return state.parametersData;
    },
    getAdminParametersData(state) {
      return state.adminParametersData;
    },
    getParameterData(state) {
      return state.parameterData;
    },
    getCreateParametersData(state) {
      return state.createParametersData;
    },
    getDeleteParametersData(state) {
      return state.deleteParametersData;
    },
    getUpdateParametersData(state) {
      return state.updateParametersData;
    },
    getFormatGroupsData(state) {
      return state.formatGroupsData;
    },
    getFormatGroupData(state) {
      return state.formatGroupData;
    },
    getCreateFormatGroupsData(state) {
      return state.createFormatGroupsData;
    },
    getUpdateFormatGroupsData(state) {
      return state.updateFormatGroupsData;
    },
    getDeleteFormatGroupsData(state) {
      return state.deleteFormatGroupsData;
    },
    getFormatsData(state) {
      return state.formatsData;
    },
    getFormatData(state) {
      return state.formatData;
    },
    getCreateFormatsData(state) {
      return state.createFormatsData;
    },
    getDeleteFormatsData(state) {
      return state.deleteFormatsData;
    },
    getUpdateFormatsData(state) {
      return state.updateFormatsData;
    },
    getFormatGroupsAdminData(state) {
      return state.formatGroupsAdminData;
    },
    getpOptionsGroupData(state) {
      return state.pOptionsGroupData;
    },
    getpaOptionsGroupData(state) {
      return state.paOptionsGroupData;
    },
    getpOptionsExData(state) {
      return state.pOptionsExData;
    },
    getCreatepOptionsGroupData(state) {
      return state.createPoptionsGroupData;
    },
    getPOGChoicesData(state) {
      return state.POGChoicesData;
    },
    getPOGData(state) {
      return state.pOptionGroupData;
    },
    getPOEXData(state) {
      return state.pOptionExData;
    },
    getDeletepOptionsGroupData(state) {
      return state.deletePoptionsGroupData;
    },
    getDeletepOptionsExData(state) {
      return state.deletePoptionsExData;
    },
    getUpdatepOptionsGroupData(state) {
      return state.updatePoptionsGroupData;
    },
    getUpdatepOptionsExData(state) {
      return state.updatePoptionsExData;
    },
    getAdminProductSearchData(state) {
      return state.adminProductSearchData;
    },
    getAdminProductOptionsData(state) {
      return state.adminProductOptionsData;
    },
    getAdminOptionsListByGroupData(state) {
      return state.adminOptionsListByGroupData;
    },
    getOptionData(state) {
      return state.optionData;
    },
    getUpdateOptionData(state) {
      return state.updateOptionData;
    },
    getDeleteOptionData(state) {
      return state.deleteOptionData;
    },
    getCreateOptionData(state) {
      return state.createOptionData;
    },
    getTechLineData(state) {
      return state.techLineData;
    },
    getUpdateTechLineData(state) {
      return state.updateTechLineData;
    },
    getCreatepOptionsExData(state) {
      return state.createPoptionsExData;
    },
    getCreateAppliancesData(state) {
      return state.createAppliancesData;
    },
    getApplianceData(state) {
      return state.applianceData;
    },
    getUpdateAppliancesData(state) {
      return state.updateAppliancesData;
    },
    getDeleteAppliancesData(state) {
      return state.deleteAppliancesData;
    },
    getPublishProductsData(state) {
      return state.publishProductsData;
    },
    getPopularProductsData(state) {
      return state.popularProductsData;
    },
    getCopyProductData(state) {
      return state.copyProductData;
    },
    getAdminProductsOptionsData(state) {
      return state.adminProductsOptionsData;
    },
    getMontagesData(state) {
      return state.montagesData;
    },
    getMachineActionsData(state) {
      return state.machineActionsData;
    },
    getSendOrderData(state) {
      return state.sendOrderData;
    },
    getAdminSendUpsData(state) {
      return state.adminSendUpsData;
    },
    getLabelData(state) {
      return state.labelData;
    },
    getConfirmDeliveryPackageData(state) {
      return state.confirmDeliveryPackageData;
    },
    getUpdateTrackingData(state) {
      return state.updateTrackingData;
    },
    getDeliveryOptionsData(state) {
      return state.deliveryOptionsData;
    },
    getUpdateExternalData(state) {
      return state.updateExternalData;
    },
    getDuplicateOrderData(state) {
      return state.duplicateOrderData;
    },
    getExternalOrderConfirmData(state) {
      return state.externalOrderConfirmData;
    },
    getUpdateOrderProductData(state) {
      return state.updateOrderProductData;
    },
    getRealWeightData(state) {
      return state.realWeightData;
    },
    getOrderProductFilesData(state) {
      return state.orderProductFilesData;
    },
    getCreateOrderProductFileData(state) {
      return state.createOrderProductFileData;
    },
    getOrderProductFileDetailData(state) {
      return state.orderProductFileDetailData;
    },
    getCreateSourceFileData(state) {
      return state.createSourceFileData;
    },
    getMontageData(state) {
      return state.montageData;
    },
    getMontageProcessData(state) {
      return state.montageProcessData;
    },
    getMontageProductionLogsData(state) {
      return state.montageProductionLogsData;
    },
    getCubesData(state) {
      return state.cubesData;
    },
    getCubeData(state) {
      return state.cubeData;
    },
    getCubeProductFilterData(state) {
      return state.cubeProductFilterData;
    },
    getCubeProductsData(state) {
      return state.cubeProductsData;
    },
    getCubeProductData(state) {
      return state.cubeProductData;
    },
    getOrderProcessStageData(state) {
      return state.orderProcessStageData;
    },
    getOrderProcessStatusData(state) {
      return state.orderProcessStatusData;
    },
    getOrderProductFileData(state) {
      return state.orderProductFileData;
    },
    getOrderProductFileData2(state) {
      return state.orderProductFileData2;
    },
    getOrderData(state) {
      return state.orderData;
    },
    getOrdersData(state) {
      return state.ordersData;
    },
    getClientOrdersData(state) {
      return state.clientOrdersData;
    },
    getClientMessagesData(state) {
      return state.clientMessagesData;
    },
    getMontageProductsData(state) {
      return state.montageProductsData;
    },
    getMontageFilterGroupData(state) {
      return state.montageFilterGroupData;
    },
    getSitesData(state) {
      return state.sitesData;
    },
    getMontageFormatData(state) {
      return state.montageFormatData;
    },
    getMontageQuantitiesData(state) {
      return state.montageQuantityData;
    },
    getMontagePaperOptionsData(state) {
      return state.montagePaperOptionsData;
    },
    getMontagePapersData(state) {
      return state.montagePapersData;
    },
    getMontageFormatsData(state) {
      return state.montageFormatsData;
    },
    getMontagePlatesData(state) {
      return state.montagePlatesData;
    },
    getCreateMontageData(state) {
      return state.createMontageData;
    },
    getUpdateMontageProductData(state) {
      return state.updateMontageProductData;
    },
    getClientsData(state) {
      return state.clientsData;
    },
    getClientData(state) {
      return state.clientData;
    },
    getAdminClientsData(state) {
      return state.adminClientsData;
    },
    getCountriesData(state) {
      return state.countriesData;
    },
    getCreateClientData(state) {
      return state.createClientData;
    },
    getDeleteClientData(state) {
      return state.deleteClientData;
    },
    getUpdateClientData(state) {
      return state.updateClientData;
    },
    getDiscountGroupsData(state) {
      return state.discountGroupsData;
    },
    getDiscountGroupData(state) {
      return state.discountGroupData;
    },
    getCreateDiscountGroupsData(state) {
      return state.createDiscountGroupsData;
    },
    getUpdateDiscountGroupData(state) {
      return state.updateDiscountGroupsData;
    },
    getDeleteDiscountGroupData(state) {
      return state.deleteDiscountGroupsData;
    },
    getOrderProductsFileData(state) {
      return state.orderProductsFileData;
    },
    getMessagesData(state) {
      return state.messagesData;
    },
    getHomeMyMessagesCountData(state) {
      return state.homeMyMessagesCountData;
    },
    getHomeAllMessagesCountData(state) {
      return state.homeAllMessagesCountData;
    },
    getMessageData(state) {
      return state.messageData;
    },
    getClientsContactData(state) {
      return state.clientsContactData;
    },
    getAdminsContactData(state) {
      return state.adminsContactData;
    },
    getAdminsReasonsData(state) {
      return state.adminsReasonsData;
    },
    getAdminsComplaintData(state) {
      return state.adminsComplaintData;
    },
    getUpdateMessageData(state) {
      return state.updateMessageData;
    },
    getCreateMessageData(state) {
      return state.createMessageData;
    },
    getConversationData(state) {
      return state.conversationData;
    },
    getDiscountsData(state) {
      return state.discountsData;
    },
    getDiscountData(state) {
      return state.discountData;
    },
    getUpdateDiscountsData(state) {
      return state.updateDiscountsData;
    },
    getCreateDiscountsForQData(state) {
      return state.createDiscountsForQData;
    },
    getImportDiscountsForQData(state) {
      return state.importDiscountsForQData;
    },
    getInvoicesData(state) {
      return state.invoicesData;
    },
    getTagsData(state) {
      return state.tagsData;
    },
    getApmData(state) {
      return state.apmData;
    },
    getCreateOrderData(state) {
      return state.createOrderData;
    },
    getPaymentsImportData(state) {
      return state.paymentsImportData;
    },
    getOrderLogsData(state) {
      return state.orderLogsData;
    },
    getProcessStagesData(state) {
      return state.processStagesData;
    },
    getEditProcessStagesData(state) {
      return state.editProcessStagesData;
    },
    getCreateProcessStagesData(state) {
      return state.createProcessStagesData;
    },
    getUpdateProcessStagesData(state) {
      return state.updateProcessStagesData;
    },
    getDeleteProcessStagesData(state) {
      return state.deleteProcessStagesData;
    },
    getMontageStatsData(state) {
      return state.montageStatsData;
    },
    getProductionStatsData(state) {
      return state.productionStatsData;
    },
    getSystemLogsData(state) {
      return state.systemLogsData;
    },
    getClientStatsData(state) {
      return state.clientStatsData;
    },
    getProductsStatsData(state) {
      return state.productsStatsData;
    },
    getPackageStatsData(state) {
      return state.packageStatsData;
    },
    getSalesStatsData(state) {
      return state.salesStatsData;
    },
    getSalesGroupsData(state) {
      return state.salesGroupsData;
    },
    getClientInvoicesData(state) {
      return state.clientInvoicesData;
    },
    getMachinesAdminPSData(state) {
      return state.machinesAdminPSData;
    },
    getPOptionsAdminPSData(state) {
      return state.pOptionsAdminPSData;
    },
    getProductData(state) {
      return state.productData;
    },
    getAllConfDetailsData(state) {
      return state.allConfDetailsData;
    },
    getAllOffersData(state) {
      return state.allOffersData;
    },
    getProductOfferPricingData(state) {
      return state.productOfferPricingData;
    },
    getProductOfferWeightData(state) {
      return state.productOfferWeightData;
    },
    getProductOfferDescriptionData(state) {
      return state.productOfferDescriptionData;
    },
    getAdminQuantitiesData(state) {
      return state.adminQuantitiesData;
    },
    getAdminGPData(state) {
      return state.adminGPData;
    },
    getAllMatchCategoriesData(state) {
      return state.allMatchCategoriesData;
    },
    getAllCategoriesData(state) {
      return state.allCategoriesData;
    },
    getAllCatPData(state) {
      return state.allCatPData;
    },
    getCreateAllOfferData(state) {
      return state.createAllOfferData;
    },
    getDeleteAllOfferData(state) {
      return state.deleteAllOfferData;
    },
    getUpdateAllOfferData(state) {
      return state.updateAllOfferData;
    },
    getAllOfferData(state) {
      return state.allOfferData;
    },
    getAllShopingRatesData(state) {
      return state.allShopingRatesData;
    },
    getAllWarrantiesData(state) {
      return state.allWarrantiesData;
    },
    getAllReturnData(state) {
      return state.allReturnData;
    },
    getAllDurationsPubData(state) {
      return state.allDurationsPubData;
    },
    getAllDeliveryTimesData(state) {
      return state.allDeliveryTimesData;
    },
    getAllegroAccountsData(state) {
      return state.allegroAccountsData;
    },
    getAllegroAccountData(state) {
      return state.allegroAccountData;
    },
    getAllegroAccountCreateData(state) {
      return state.allegroAccountCreateData;
    },
    getAllegroAccountUpdateData(state) {
      return state.allegroAccountUpdateData;
    },
    getAllegroAccountDeleteData(state) {
      return state.allegroAccountDeleteData;
    },
    getAllegroAccountOauthData(state) {
      return state.allegroAccountOauthData;
    },
    getAllegroAccountSellerData(state) {
      return state.allegroAccountSellerData;
    },
    getAllegroAccountSenderData(state) {
      return state.allegroAccountSenderData;
    },
    getAllegroAccountCodReceiverData(state) {
      return state.allegroAccountCodReceiverData;
    },
    getAllegroAccountResponsibleProducerData(state) {
      return state.allegroAccountResponsibleProducerData;
    },
    getAllegroAccountSafetyInformationData(state) {
      return state.allegroAccountSafetyInformationData;
    },
    getAllegroAccountOffersData(state) {
      return state.allegroAccountOffersData;
    },
    getAllegroAccountThreadsData(state) {
      return state.allegroAccountThreadsData;
    },
    getAllegroOauthCreateData(state) {
      return state.allegroOauthCreateData;
    },
    getAllegroOauthUpdateData(state) {
      return state.allegroOauthUpdateData;
    },
    getAllegroSellersData(state) {
      return state.allegroSellersData;
    },
    getAllegroSellerData(state) {
      return state.allegroSellerData;
    },
    getAllegroSellerCreateData(state) {
      return state.allegroSellerCreateData;
    },
    getAllegroSellerUpdateData(state) {
      return state.allegroSellerUpdateData;
    },
    getAllegroSendersData(state) {
      return state.allegroSendersData;
    },
    getAllegroSenderData(state) {
      return state.allegroSenderData;
    },
    getAllegroSenderCreateData(state) {
      return state.allegroSenderCreateData;
    },
    getAllegroSenderUpdateData(state) {
      return state.allegroSenderUpdateData;
    },
    getAllegroCodReceiversData(state) {
      return state.allegroCodReceiversData;
    },
    getAllegroCodReceiverData(state) {
      return state.allegroCodReceiverData;
    },
    getAllegroCodReceiverCreateData(state) {
      return state.allegroCodReceiverCreateData;
    },
    getAllegroCodReceiverUpdateData(state) {
      return state.allegroCodReceiverUpdateData;
    },
    getAllegroResponsibleProducersData(state) {
      return state.allegroResponsibleProducersData;
    },
    getAllegroResponsibleProducerData(state) {
      return state.allegroResponsibleProducerData;
    },
    getAllegroResponsibleProducerCreateData(state) {
      return state.allegroResponsibleProducerCreateData;
    },
    getAllegroResponsibleProducerUpdateData(state) {
      return state.allegroResponsibleProducerUpdateData;
    },
    getAllegroSafetyInformationsData(state) {
      return state.allegroSafetyInformationsData;
    },
    getAllegroSafetyInformationData(state) {
      return state.allegroSafetyInformationData;
    },
    getAllegroSafetyInformationCreateData(state) {
      return state.allegroSafetyInformationCreateData;
    },
    getAllegroSafetyInformationUpdateData(state) {
      return state.allegroSafetyInformationUpdateData;
    },
    getClientAllegroThreadsData(state) {
      return state.clientAllegroThreadsData;
    },
    getAllegroThreadData(state) {
      return state.allegroThreadData;
    },
    getAllegroThreadMessageCreateData(state) {
      return state.allegroThreadMessageCreateData;
    },
    getAllegroOfferModificationCommandData(state) {
      return state.allegroOfferModificationCommandData;
    },
    getAllegroOfferPriceChangeCommandData(state) {
      return state.allegroOfferPriceChangeCommandData;
    },
    getUpdateMontageData(state) {
      return state.updateMontageData;
    },
    getDuplicateMontageData(state) {
      return state.duplicateMontageData;
    },
    getChosenOptionsData(state) {
      return state.chosenOptionsData;
    },
    getImportProductPricesData(state) {
      return state.importProductPricesData;
    },
    getImportProductPQData(state) {
      return state.importProductPQData;
    },
    getUpdatePriceDetailData(state) {
      return state.updatePriceDetailData;
    },
    getActionsOrderData(state) {
      return state.actionsOrderData;
    },
    getNotesData(state) {
      return state.notesData;
    },
    getOrderNotesData(state) {
      return state.orderNotesData;
    },
    getNoteDetailData(state) {
      return state.noteDetailData;
    },
    getCeidgData(state) {
      return state.ceidgData;
    },
    getUnitsData(state) {
      return state.unitsData;
    },
    getCreateUnitData(state) {
      return state.createUnitData;
    },
    getDeleteUnitData(state) {
      return state.deleteUnitData;
    },
    getTrackingTagsData(state) {
      return state.trackingTagsData;
    },
    getTrackingTagData(state) {
      return state.trackingTagData;
    },
    getCreateTrackingTagData(state) {
      return state.createTrackingTagData;
    },
    getUpdateTrackingTagData(state) {
      return state.updateTrackingTagData;
    },
    getDeleteTrackingTagData(state) {
      return state.deleteTrackingTagData;
    },
    getTrackingTagsTypeOpts(state) {
      return state.trackingTagsTypeOpts;
    },
    getTrackingTagsLocationOpts(state) {
      return state.trackingTagsLocationOpts;
    },
    getKsefCompaniesData(state) {
      return state.ksefCompaniesData;
    },
    getKsefCompanyData(state) {
      return state.ksefCompanyData;
    },
    getCreateKsefCompanyData(state) {
      return state.createKsefCompanyData;
    },
    getUpdateKsefCompanyData(state) {
      return state.updateKsefCompanyData;
    },
    getActivateKsefConnectionData(state) {
      return state.activateKsefConnectionData;
    },
    getKsefCompanyCertsData(state) {
      return state.ksefCompanyCertsData;
    },
    getCreateKsefCertificateData(state) {
      return state.createKsefCertificateData;
    },
    getDeleteKsefCertificateData(state) {
      return state.deleteKsefCertificateData;
    },
    getKsefInvoiceStatusOpts(state) {
      return state.ksefInvoiceStatusOpts;
    },
    getKsefUnsentInvoicesData(state) {
      return state.ksefUnsentInvoicesData;
    },
    getMachineCostTypeOpts(state) {
      return state.machineCostTypeOpts;
    },
    getOrdersListSummary(state) {
      return state.ordersListSummary;
    },
    getMontagesListSummary(state) {
      return state.montagesListSummary;
    },
    getMontagesListSummaryClosed(state) {
      return state.montagesListSummaryClosed;
    },
    getOrderProductsAdminRealizedData(state) {
      return state.orderProductsAdminRealizedData;
    },
  },
});
